// ========================================
// TOAST NOTIFICATION SYSTEM
// ========================================
(function() {
  'use strict';

  // Create toast container on load
  var toastContainer = document.createElement('div');
  toastContainer.id = 'toast-container';
  toastContainer.style.cssText = 'position:fixed;top:20px;right:20px;z-index:99999;display:flex;flex-direction:column;gap:10px;pointer-events:none;';
  document.body.appendChild(toastContainer);

  // Toast function - type: 'success', 'error', 'info'
  window.showToast = function(message, type, duration) {
    type = type || 'info';
    duration = duration || 3000;

    var toast = document.createElement('div');
    toast.className = 'toast toast--' + type;
    toast.style.cssText = 'padding:12px 20px;border-radius:5px;color:#fff;font-size:14px;font-weight:500;box-shadow:0 4px 12px rgba(0,0,0,0.15);transform:translateX(120%);transition:transform 0.3s ease;pointer-events:auto;max-width:300px;';

    // Set color based on type
    if (type === 'success') {
      toast.style.background = '#2e7d32';
    } else if (type === 'error') {
      toast.style.background = '#c62828';
    } else {
      toast.style.background = '#0b1215';
    }

    toast.textContent = message;
    toastContainer.appendChild(toast);

    // Animate in
    requestAnimationFrame(function() {
      toast.style.transform = 'translateX(0)';
    });

    // Auto remove
    setTimeout(function() {
      toast.style.transform = 'translateX(120%)';
      setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 300);
    }, duration);
  };
})();

jQuery(document).ready(function($) {
  $(".toolbar .toolbar__menu > li > a.hassubmenu").hover(function(e) {
    $(this).parent().addClass("submenu_open");
  }, function(e) {
    $(this).parent().removeClass("submenu_open");
  });
  
  $(".submenu").hover(function(e) {
    $(this).parent().addClass("submenu_open");
  }, function(e) {
    $(this).parent().removeClass("submenu_open");
  });
  
  if($(".product-description").length > 0) {
    if($(".product-description .rte").height() < 200) {
      $(".product-description").addClass("full");
    }
  }
  
  $(".desc_btn-readmore").click(function(e) {
    $(this).parents(".product-description").find(".desc_readmore").removeClass("hide");
    $(this).addClass("hide");
  });
  

  
//   $(".color-swatches-wrapper .variant-input").hover(function(e) {
//     $(this).find(".color_tooltip").removeClass("hide");
//   }, function(e) {
//     $(this).find(".color_tooltip").addClass("hide");
//   });
  
  $(".variant_sel-trigger").change(function(e) {
    var hdl = $(this).attr("data-handle");
    var val = $(this).find("option:selected").val();
    $(".variant-input-wrap[data-handle='" + hdl + "'] .variant-input[data-value='" + val + "'] label").trigger("click");
  });
  
  $(".shopify-app-block").addClass("page-width");
  
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener nofollow';
  }
}



 // Add to Cart success state
  document.addEventListener('ajaxProduct:added', function(evt) {
    var btn = evt.detail.addToCartBtn;
    if (btn) {
      btn.classList.add('btn--success');

      // Store original text and change to "Added!"
      var textEl = btn.querySelector('[data-add-to-cart-text]');
      var originalText = textEl ? textEl.textContent : '';
      if (textEl) textEl.textContent = 'Added!';

      // Reset after 2 seconds
      setTimeout(function() {
        btn.classList.remove('btn--success');
        if (textEl) textEl.textContent = originalText;
      }, 2000);
    }
  });

// ========================================
// PRODUCT HORIZONTAL TABS
// ========================================
document.addEventListener('DOMContentLoaded', function() {
  // Tab switching
  document.querySelectorAll('[data-tab-trigger]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var tabId = this.getAttribute('data-tab-trigger');
      var tabsContainer = this.closest('[data-product-tabs]');

      // Update active tab button
      tabsContainer.querySelectorAll('[data-tab-trigger]').forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      this.classList.add('is-active');
      this.setAttribute('aria-selected', 'true');

      // Update active panel
      tabsContainer.querySelectorAll('[data-tab-panel]').forEach(function(panel) {
        panel.classList.remove('is-active');
      });
      tabsContainer.querySelector('[data-tab-panel="' + tabId + '"]').classList.add('is-active');

    });
  });

  // Click on Judge.me preview badge (star rating) scrolls to Reviews tab
  // Use capture phase because Judge.me calls stopPropagation() on the click
  document.addEventListener('click', function(evt) {
    var badge = evt.target.closest('.jdgm-preview-badge');
    if (!badge) return;

    var tabsContainer = document.querySelector('[data-product-tabs]');
    if (!tabsContainer) return;

    var reviewsTab = tabsContainer.querySelector('[data-reviews-tab]');
    if (!reviewsTab) return;

    // Activate the Reviews tab
    tabsContainer.querySelectorAll('[data-tab-trigger]').forEach(function(t) {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    reviewsTab.classList.add('is-active');
    reviewsTab.setAttribute('aria-selected', 'true');

    tabsContainer.querySelectorAll('[data-tab-panel]').forEach(function(panel) {
      panel.classList.remove('is-active');
    });
    var reviewsPanel = tabsContainer.querySelector('[data-reviews-panel]');
    if (reviewsPanel) {
      reviewsPanel.classList.add('is-active');
    }

    // Scroll to the tabs
    tabsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

});

// ========================================
// COLLECTION PAGE QUICK ADD TO CART
// ========================================
(function() {
  'use strict';

  // Event delegation for Add to Cart buttons on collection pages
  document.addEventListener('click', function(evt) {
    var btn = evt.target.closest('.grid-product__add-btn');
    if (!btn || btn.disabled) return;

    evt.preventDefault();
    evt.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) {
      console.error('Quick Add: No variant ID found');
      return;
    }

    // Prevent double-click
    if (btn.classList.contains('btn--loading')) return;

    // Set loading state
    btn.classList.add('btn--loading');
    btn.disabled = true;

    // POST to Shopify Cart API
    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: 1
        }]
      })
    })
    .then(function(response) {
      return response.json().then(function(data) {
        return { status: response.status, data: data };
      });
    })
    .then(function(result) {
      // Remove loading state
      btn.classList.remove('btn--loading');
      btn.disabled = false;

      if (result.status === 422 || result.data.status === 422) {
        // Handle error (e.g., out of stock)
        var errorMessage = result.data.description || result.data.message || 'Could not add to cart';
        if (typeof showToast === 'function') {
          showToast(errorMessage, 'error', 4000);
        }
        return;
      }

      // Success - dispatch event for existing success state handler
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: result.data,
          addToCartBtn: btn
        }
      }));

      // Open Rebuy Smart Cart
      if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
        Rebuy.Cart.fetchCart();
        Rebuy.SmartCart.show();
      }
    })
    .catch(function(error) {
      // Network error
      btn.classList.remove('btn--loading');
      btn.disabled = false;
      if (typeof showToast === 'function') {
        showToast('Network error. Please try again.', 'error', 4000);
      }
    });
  });
})();

// ========================================
// VARIANT SELECTION ON PRODUCT GRID
// ========================================
(function() {
  'use strict';

  // Render the live Shopify price into a card's .grid-product__price element.
  // priceCents / comparePriceCents may be number or string; comparePriceCents is optional.
  // Returns true if the DOM was updated, false if it bailed (no theme.Currency, no priceEl, etc).
  function renderCardPrice(card, priceCents, comparePriceCents) {
    if (!card || priceCents == null || priceCents === '') return false;
    var priceEl = card.querySelector('.grid-product__price');
    if (!priceEl) return false;
    // Custom-priced products show their custom.custom_price_range metafield
    // text (e.g. "Customize for Price") — never overwrite with variant price.
    if (priceEl.classList.contains('grid-product__price--custom-range')) return false;
    if (typeof theme === 'undefined' || !theme.Currency) return false;

    var priceInt = parseInt(priceCents, 10);
    if (isNaN(priceInt)) return false;
    var salePriceFormatted = theme.Currency.formatMoney(priceCents, theme.settings.moneyFormat);
    var compareInt = comparePriceCents ? parseInt(comparePriceCents, 10) : 0;

    if (compareInt && compareInt > priceInt) {
      var savingsInt = compareInt - priceInt;
      var pctOff = Math.round((savingsInt / compareInt) * 100);

      // Superscript cents on sale price
      var saleMatch = salePriceFormatted.match(/^(\$[\d,]+)\.(\d{2})\s*(CAD)?/);
      var saleHtml = saleMatch
        ? saleMatch[1] + '<sup class="price-cents">' + saleMatch[2] + '</sup>' + (saleMatch[3] ? ' <span class="currency-format">' + saleMatch[3] + '</span>' : '')
        : salePriceFormatted;

      // Round up compare-at to nearest dollar; drop cents on savings
      var compareDollars = Math.ceil(compareInt / 100);
      var savingsDollars = Math.floor(savingsInt / 100);

      var html = '<span class="grid-product__price--current recs-sale">' + saleHtml + '</span>' +
                 '<span class="grid-product__price--original">$' + compareDollars + '</span>';
      if (pctOff >= 10) {
        html += '<div class="grid-product__pct-off">' + pctOff + '% off</div>';
      }
      html += '<span class="grid-product__price--savings">Save $' + savingsDollars + '</span>';
      priceEl.innerHTML = html;
      priceEl.classList.add('ss-price-restructured');
      priceEl.classList.remove('ss-cents-done');
    } else {
      var regMatch = salePriceFormatted.match(/^(\$[\d,]+)\.(\d{2})\s*(CAD)?/);
      var regHtml = regMatch
        ? regMatch[1] + '<sup class="price-cents">' + regMatch[2] + '</sup>' + (regMatch[3] ? ' <span class="currency-format">' + regMatch[3] + '</span>' : '')
        : salePriceFormatted;
      priceEl.innerHTML = '<span class="grid-product__price--current">' + regHtml + '</span>';
      priceEl.classList.remove('ss-price-restructured');
      priceEl.classList.add('ss-cents-done');
    }
    return true;
  }

  // Expose for use by enhanceProductCards (initial-paint price patch from /products/{handle}.js)
  window.__thsRenderCardPrice = renderCardPrice;

  document.addEventListener('change', function(evt) {
    var select = evt.target.closest('.grid-product__variant-select');
    if (!select) return;

    // Find the product card (works for both Shopify and SearchSpring grids)
    var card = select.closest('.grid-product') || select.closest('.grid-product__content');
    if (!card) return;

    var selectedOption = select.options[select.selectedIndex];
    var variantId = select.value;

    // 1. Update Add to Cart button variant ID (check inline wrapper first, then card)
    var addBtn = select.parentElement.querySelector('.grid-product__add-btn') ||
                 card.querySelector('.grid-product__add-btn');
    if (addBtn) {
      addBtn.dataset.variantId = variantId;

      // Update button state based on availability
      var isAvailable = selectedOption.dataset.available === 'true';
      if (isAvailable) {
        addBtn.disabled = false;
        addBtn.classList.remove('grid-product__add-btn--sold-out');
        var btnText = addBtn.querySelector('[data-add-to-cart-text]');
        if (btnText) btnText.textContent = 'Add';
      } else {
        addBtn.disabled = true;
        addBtn.classList.add('grid-product__add-btn--sold-out');
        var btnText = addBtn.querySelector('[data-add-to-cart-text]');
        if (btnText) btnText.textContent = 'Sold Out';
      }
    }

    // 2. Update price display from selected variant
    renderCardPrice(card, selectedOption.dataset.price, selectedOption.dataset.comparePrice);

    // 3. Update image if variant has specific image
    var variantImage = selectedOption.dataset.image;
    if (variantImage) {
      // Try multiple selectors to find the image (Shopify and SearchSpring)
      var imgEl = card.querySelector('.grid-product__image-mask img') ||
                  card.querySelector('.grid__image-contain') ||
                  card.querySelector('.grid-product__image') ||
                  card.querySelector('img.lazyloaded') ||
                  card.querySelector('img.lazyload') ||
                  card.querySelector('img');
      if (imgEl) {
        imgEl.src = variantImage;
        if (imgEl.dataset.src) {
          imgEl.dataset.src = variantImage;
        }
        imgEl.classList.add('lazyloaded');
        imgEl.classList.remove('lazyload');
      }
    }
  });
})();

// ========================================
// SEARCHSPRING: ENHANCE PRODUCT CARDS
// ========================================
(function() {
  'use strict';

  // Cache for product data to avoid duplicate fetches.
  // Stores in-flight promises so concurrent callers share one network request.
  var productCache = {};

  // Shared fetcher used by collection cards, recommendations, and search autocomplete.
  // Returns a Promise<product> for /products/{handle}.js.
  function fetchProductByHandle(handle) {
    if (!handle) return Promise.reject(new Error('no handle'));
    if (productCache[handle] && typeof productCache[handle].then === 'function') {
      return productCache[handle]; // in-flight or resolved promise
    }
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }
    var p = fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        productCache[handle] = product; // replace promise with resolved value
        return product;
      })
      .catch(function(err) {
        delete productCache[handle]; // allow retry on next call
        throw err;
      });
    productCache[handle] = p;
    return p;
  }
  window.__thsFetchProduct = fetchProductByHandle;

  // Parse SearchSpring filters from URL hash
  function getActiveFilters() {
    var hash = window.location.hash;
    var filters = [];

    if (!hash) return filters;

    // Match patterns like filter:ss_color_group:Red or filter:ss_color_group:White$2520$252F$2520Blue
    var matches = hash.match(/filter:[^:]+:[^\/]+/g);
    if (!matches) return filters;

    matches.forEach(function(match) {
      var parts = match.split(':');
      if (parts.length >= 3) {
        // SearchSpring double-encodes: $25 = %, so $2520 = %20 = space, $252F = %2F = /
        var rawValue = parts[2];
        var singleEncoded = rawValue.replace(/\$25/g, '%');
        var filterValue = decodeURIComponent(singleEncoded).toLowerCase().trim();
        if (filterValue) {
          filters.push(filterValue);
        }
      }
    });

    return filters;
  }

  // Find best matching variant based on active filters (optimized)
  function findMatchingVariant(variants, filters) {
    if (!filters || filters.length === 0) return null;

    // Pre-compute filter segments once (avoid repeated splits)
    var filterData = filters.map(function(f) {
      return {
        value: f,
        segments: f.split(/[\s\/\-]+/).filter(function(s) { return s.length > 0; })
      };
    });

    var bestMatch = null;
    var bestScore = 0;
    var maxPossibleScore = filters.length * 10; // Perfect match = 10 per filter

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var score = 0;
      var options = variant.options;

      if (!options || options.length === 0) continue;

      // Pre-compute lowercase options once per variant
      var optionsLower = options.map(function(opt) {
        return opt ? opt.toLowerCase().trim() : '';
      });

      // Score against each filter
      for (var f = 0; f < filterData.length; f++) {
        var filter = filterData[f];
        var filterValue = filter.value;

        for (var o = 0; o < optionsLower.length; o++) {
          var optLower = optionsLower[o];
          if (!optLower) continue;

          if (optLower === filterValue) {
            score += 10; // Exact match
            break; // Found match for this option, check next filter
          } else if (optLower.indexOf(filterValue) !== -1 && filterValue.length > 2) {
            score += 3; // Partial match
            break;
          } else if (filterValue.indexOf(optLower) !== -1 && optLower.length > 2) {
            // Check if option is a complete segment in filter
            var segments = filter.segments;
            for (var s = 0; s < segments.length; s++) {
              if (segments[s] === optLower) {
                score += 1;
                break;
              }
            }
          }
        }
      }

      if (score > bestScore) {
        bestScore = score;
        bestMatch = variant;
        // Early termination if perfect match found
        if (score === maxPossibleScore) return bestMatch;
      }
    }

    return bestMatch;
  }

  // Toggle: set to true to enable yellow-tag sale price layout on collection pages
  var SALE_PRICE_YELLOW_TAGS = false;

  function moveDiscountBadges() {
    if (SALE_PRICE_YELLOW_TAGS) {
      // Yellow-tag mode: Reformats sale pricing into two-row layout
      var priceBlocks = document.querySelectorAll('#searchspring-content .grid-product__price:not(.ss-price-reformatted)');

      priceBlocks.forEach(function(priceBlock) {
        var original = priceBlock.querySelector('.grid-product__price--original');
        var current = priceBlock.querySelector('.grid-product__price--current');
        if (!original || !current) return;

        priceBlock.classList.add('ss-price-reformatted');

        var card = priceBlock.closest('.grid-product');
        if (!card) return;

        var meta = card.querySelector('.grid-product__meta');

        var salePriceText = current.textContent.replace(/[^0-9.]/g, '');
        var comparePriceText = original.textContent.replace(/[^0-9.]/g, '');
        var salePrice = parseFloat(salePriceText);
        var comparePrice = parseFloat(comparePriceText);

        if (isNaN(salePrice) || isNaN(comparePrice) || comparePrice <= salePrice) return;

        var savings = comparePrice - salePrice;
        var pctOff = Math.round(((comparePrice - salePrice) / comparePrice) * 100);

        priceBlock.innerHTML = '';
        priceBlock.classList.add('sale-price-layout');

        var row1 = document.createElement('div');
        row1.className = 'sale-price-row sale-price-row--prices';

        var saleTag = document.createElement('span');
        saleTag.className = 'sale-price-tag';
        saleTag.textContent = '$' + salePrice.toFixed(2) + ' CAD';

        var compareSpan = document.createElement('span');
        compareSpan.className = 'sale-price-compare';
        compareSpan.textContent = '$' + comparePrice.toFixed(2);

        row1.appendChild(saleTag);
        row1.appendChild(compareSpan);

        var row2 = document.createElement('div');
        row2.className = 'sale-price-row sale-price-row--savings';

        var dollarTag = document.createElement('span');
        dollarTag.className = 'sale-savings-tag';
        dollarTag.textContent = '$' + savings.toFixed(2) + ' off';

        var pctBadge = document.createElement('span');
        pctBadge.className = 'sale-pct-badge';
        pctBadge.textContent = pctOff + '% off';

        row2.appendChild(dollarTag);
        row2.appendChild(pctBadge);

        priceBlock.appendChild(row1);
        priceBlock.appendChild(row2);

        if (meta) {
          var oldBadge = meta.querySelector('.grid-product__pct-off');
          if (oldBadge) oldBadge.remove();
        }
        if (card) {
          var imgBadge = card.querySelector('.grid-product__pct-off');
          if (imgBadge) imgBadge.remove();
        }
      });
    } else {
      // Default mode: restructure price into two rows
      // Row 1: sale price + compare-at | Row 2: pct off + save amount
      var priceBlocks = document.querySelectorAll('#searchspring-content .grid-product__price:not(.ss-price-restructured)');

      priceBlocks.forEach(function(priceBlock) {
        var original = priceBlock.querySelector('.grid-product__price--original');
        var current = priceBlock.querySelector('.grid-product__price--current');
        if (!original || !current) return; // Not on sale, skip

        priceBlock.classList.add('ss-price-restructured');

        // Superscript the cents on the current price
        var priceText = current.textContent.trim();
        var priceMatch = priceText.match(/^(\$[\d,]+)\.(\d{2})\s*(CAD)?/);
        if (priceMatch) {
          current.innerHTML = priceMatch[1] + '<sup class="price-cents">' + priceMatch[2] + '</sup>' +
            (priceMatch[3] ? ' <span class="currency-format">' + priceMatch[3] + '</span>' : '');
        }

        // Round up compare-at price to nearest dollar
        var origText = original.textContent.trim();
        var origMatch = origText.match(/\$([\d,]+)\.(\d{2})/);
        if (origMatch) {
          var origDollars = parseInt(origMatch[1].replace(/,/g, ''), 10);
          var origCents = parseInt(origMatch[2], 10);
          if (origCents > 0) origDollars += 1;
          original.innerHTML = '$' + origDollars;
          original.removeAttribute('ng-binding');
          original.classList.add('ss-price-modified');
        }

        // Remove cents from save amount (e.g. "Save $150.09" -> "Save $150")
        var savings = priceBlock.querySelector('.grid-product__price--savings');
        if (savings) {
          var saveText = savings.textContent.trim();
          var saveMatch = saveText.match(/(Save\s*\$[\d,]+)\.\d{2}/);
          if (saveMatch) {
            savings.textContent = saveMatch[1];
          }
        }

        var card = priceBlock.closest('.grid-product');
        if (!card) return;

        // Find the pct-off badge and move it into the price block
        var pctBadge = card.querySelector('.grid-product__pct-off:not(.ss-badge-moved)');
        if (pctBadge) {
          pctBadge.classList.add('ss-badge-moved');
          // Insert before the savings span so pct comes first on row 2
          if (savings) {
            priceBlock.insertBefore(pctBadge, savings);
          } else {
            priceBlock.appendChild(pctBadge);
          }
        }
      });

      // Superscript cents on non-sale prices too
      var regularPrices = document.querySelectorAll('#searchspring-content .grid-product__price:not(.ss-price-restructured):not(.ss-cents-done)');
      regularPrices.forEach(function(priceBlock) {
        var current = priceBlock.querySelector('.grid-product__price--current');
        if (!current) return;
        priceBlock.classList.add('ss-cents-done');
        var priceText = current.textContent.trim();
        var priceMatch = priceText.match(/^(\$[\d,]+)\.(\d{2})\s*(CAD)?/);
        if (priceMatch) {
          current.innerHTML = priceMatch[1] + '<sup class="price-cents">' + priceMatch[2] + '</sup>' +
            (priceMatch[3] ? ' <span class="currency-format">' + priceMatch[3] + '</span>' : '');
        }
      });
    }
  }

  // === Collection card chips: Best Seller / New / Pro Stock ===
  // One small plate top-left of the image box, one per card, in that priority.
  // Best Seller = nightly `chip-best-seller` tag (searchspring-sales-fields/
  // tag_best_sellers.js: top ~5% of each product type by 90-day units).
  // New = published in the last 45 days on a product created in the last 180
  // (re-published old stock resets published_at, the created_at floor skips it).
  // Pro Stock = title or tag. Reads the /products/{handle}.js payload the card
  // already fetched, so it costs no extra requests. Customizer cards own their
  // image overlay and fully sold-out cards already say Sold Out: no chip there.
  var CARD_CHIP_NEW_DAYS = 45;
  var CARD_CHIP_NEW_MAX_AGE_DAYS = 180;
  var CARD_CHIP_PRO_STOCK = /pro[\s-]?stock/i;
  function cardChipFor(product) {
    var tags = Array.isArray(product.tags) ? product.tags : [];
    if (tags.indexOf('THS-Custom') !== -1 || product.available === false) return null;
    if (tags.indexOf('chip-best-seller') !== -1) return { key: 'best', text: 'Best Seller' };
    // Source Exclusive outranks New on purpose: New expires, the exclusivity
    // doesn't, and a Source Exclusive is almost always also a new arrival --
    // so ranking New higher would hide it on exactly the products where the
    // claim is worth the most. Swap these two blocks to reverse that.
    if (tags.indexOf('Source Exclusive') !== -1) return { key: 'source', text: 'Source Exclusive' };
    var published = Date.parse(product.published_at);
    var created = Date.parse(product.created_at);
    if (published && created) {
      var day = 86400000, now = Date.now();
      if (now - published <= CARD_CHIP_NEW_DAYS * day && now - created <= CARD_CHIP_NEW_MAX_AGE_DAYS * day) {
        return { key: 'new', text: 'New' };
      }
    }
    var isProStock = CARD_CHIP_PRO_STOCK.test(product.title || '') || tags.some(function(t) { return CARD_CHIP_PRO_STOCK.test(t); });
    if (isProStock) return { key: 'pro', text: 'Pro Stock' };
    return null;
  }
  // SearchSpring re-renders the image area after the first enhancement pass
  // (filters, in-stock toggle, sort), which drops anything we appended to the
  // mask. Re-apply from the product cache on every pass; cards whose
  // /products/{handle}.js is still in flight get their chip from the
  // addVariantControlsToCard callback instead. No new fetches here.
  function applyCardChips() {
    var cards = document.querySelectorAll('#searchspring-content .grid-product.ss-enhanced');
    cards.forEach(function(card) {
      if (card.querySelector('.ths-card-chip')) return;
      var product = productCache[card.dataset.productHandle];
      if (!product || typeof product.then === 'function') return;
      addCardChip(card, product);
    });
  }
  function addCardChip(card, product) {
    if (card.querySelector('.ths-card-chip')) return;
    var chip = cardChipFor(product);
    if (!chip) return;
    var mask = card.querySelector('.grid-product__image-mask');
    if (!mask) return;
    var el = document.createElement('span');
    el.className = 'ths-card-chip ths-card-chip--' + chip.key;
    el.textContent = chip.text;
    mask.appendChild(el);
  }

  // === Collection card review stars ===
  // Judge.me keeps each product's average and review count in the
  // reviews.rating / reviews.rating_count metafields. /products/{handle}.js
  // carries tags but no metafields (and SearchSpring's own `rating` field is
  // stale Okendo data), so the nightly searchspring-sales-fields/
  // tag_review_stars.js mirrors the metafields into one product tag,
  // rv:<average>:<count> (e.g. rv:4.8:12). Liquid cards read the metafields
  // directly (product-grid-item.liquid); this renders the same row under the
  // price on SearchSpring cards from the tag. Shown from the first review.
  var CARD_STARS_TAG = /^rv:(\d+(?:\.\d+)?):(\d+)$/;
  function cardStarsFor(product) {
    var tags = Array.isArray(product.tags) ? product.tags : [];
    for (var i = 0; i < tags.length; i++) {
      var m = CARD_STARS_TAG.exec(tags[i]);
      if (!m) continue;
      var rating = parseFloat(m[1]), count = parseInt(m[2], 10);
      if (rating > 0 && count > 0) return { rating: Math.min(rating, 5), count: count };
    }
    return null;
  }
  function applyCardStars() {
    var cards = document.querySelectorAll('#searchspring-content .grid-product.ss-enhanced');
    cards.forEach(function(card) {
      if (card.querySelector('.ths-card-stars')) return;
      var product = productCache[card.dataset.productHandle];
      if (!product || typeof product.then === 'function') return;
      addCardStars(card, product);
    });
  }
  function addCardStars(card, product) {
    if (card.querySelector('.ths-card-stars')) return;
    var stars = cardStarsFor(product);
    if (!stars) return;
    var meta = card.querySelector('.grid-product__meta');
    if (!meta) return;
    var el = document.createElement('div');
    el.className = 'ths-card-stars';
    el.setAttribute('aria-label', stars.rating.toFixed(1) + ' out of 5 stars, ' + stars.count + ' review' + (stars.count === 1 ? '' : 's'));
    var row = document.createElement('span');
    row.className = 'ths-card-stars__row';
    row.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('span');
    fill.className = 'ths-card-stars__fill';
    fill.style.width = (stars.rating / 5 * 100).toFixed(1) + '%';
    row.appendChild(fill);
    var count = document.createElement('span');
    count.className = 'ths-card-stars__count';
    count.setAttribute('aria-hidden', 'true');
    count.textContent = '(' + stars.count + ')';
    el.appendChild(row);
    el.appendChild(count);
    meta.appendChild(el);
  }

  function addVariantControlsToCard(card, product) {
    var content = card.querySelector('.grid-product__content');
    if (!content) return;

    // Check if controls already added
    if (card.querySelector('.grid-product__quick-add')) return;

    // Find elements
    var link = card.querySelector('a.grid-product__link');
    var imageMask = card.querySelector('.grid-product__image-mask');
    var meta = card.querySelector('.grid-product__meta');
    if (!link || !imageMask) return;

    var productUrl = link.href;

    // === RESTRUCTURE DOM ===
    // Move image link to only wrap the image, then add quick-add and meta-link separately

    // 1. Create new image-only link
    var imageLink = document.createElement('a');
    imageLink.href = productUrl;
    imageLink.className = 'grid-product__image-link';

    // 2. Move image mask into the new image link
    imageLink.appendChild(imageMask);

    // 3. Create quick-add wrapper
    var wrapper = document.createElement('div');
    wrapper.className = 'grid-product__quick-add';

    // 4. Create meta link wrapper
    var metaLink = document.createElement('a');
    metaLink.href = productUrl;
    metaLink.className = 'grid-product__meta-link';
    if (meta) {
      metaLink.appendChild(meta);
    }

    // 5. Replace the old link's content with new structure
    // Clear the old link and replace with our new structure
    var parent = link.parentNode;
    parent.insertBefore(imageLink, link);
    parent.insertBefore(wrapper, link);
    parent.insertBefore(metaLink, link);
    parent.removeChild(link);

    // Chip lives inside the image mask, which moved into imageLink above;
    // the star row goes under the price inside the meta block.
    addCardChip(card, product);
    addCardStars(card, product);

    // Get available variants (in stock)
    var availableVariants = product.variants.filter(function(v) {
      return v.available;
    });

    // If no variants available, show sold out button and mark card
    if (availableVariants.length === 0) {
      wrapper.innerHTML = '<button class="btn btn--secondary grid-product__add-btn grid-product__add-btn--sold-out" disabled>Sold Out</button>';
      card.setAttribute('data-sold-out', 'true');
      // Still patch the price so sold-out cards reflect live Shopify pricing.
      if (typeof window.__thsRenderCardPrice === 'function' && product.variants[0]) {
        var fallbackVariant = product.variants[0];
        window.__thsRenderCardPrice(card, fallbackVariant.price, fallbackVariant.compare_at_price);
      }
      // Swatches still render (all sold-out) so shoppers can preview colors.
      buildCardSwatches(card, product, wrapper, product.variants[0]);
      return;
    }

    // Sort available variants
    // For goalie products: variants starting with "White" first, then alphabetical
    // For all other products: alphabetical
    var isGoalieProduct = product.title.toLowerCase().indexOf('goalie') !== -1;

    var sortedVariants = availableVariants.slice().sort(function(a, b) {
      if (isGoalieProduct) {
        // Check if variant starts with "White" (handles "White", "White / S", etc.)
        var aStartsWhite = a.title.toLowerCase().trim().indexOf('white') === 0;
        var bStartsWhite = b.title.toLowerCase().trim().indexOf('white') === 0;

        // White variants come first
        if (aStartsWhite && !bStartsWhite) return -1;
        if (!aStartsWhite && bStartsWhite) return 1;
      }

      // Alphabetical sort within each group (or for non-goalie products)
      return a.title.localeCompare(b.title);
    });

    // Try to match active filters, otherwise use first alphabetically
    var activeFilters = getActiveFilters();
    var matchingVariant = findMatchingVariant(sortedVariants, activeFilters);
    var selectedVariant = matchingVariant || sortedVariants[0];

    // Always show dropdown (even for single variant - consistency)
    var select = document.createElement('select');
    select.className = 'grid-product__variant-select';

    sortedVariants.forEach(function(variant) {
      var option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.title;
      option.dataset.price = variant.price;
      option.dataset.comparePrice = variant.compare_at_price || '';
      option.dataset.available = variant.available;
      if (variant.featured_image) {
        option.dataset.image = variant.featured_image.src;
      }
      select.appendChild(option);
    });

    select.value = selectedVariant.id;
    wrapper.appendChild(select);

    // Compact Add button (secondary style)
    var addBtn = document.createElement('button');
    addBtn.className = 'btn btn--secondary grid-product__add-btn';
    addBtn.dataset.variantId = selectedVariant.id;
    addBtn.innerHTML = '<span data-add-to-cart-text>Add</span>';
    wrapper.appendChild(addBtn);

    // Update image to match selected variant (if it has a specific image)
    if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
      var imgEl = imageLink.querySelector('img');
      if (imgEl) {
        imgEl.src = selectedVariant.featured_image.src;
        if (imgEl.dataset.src) {
          imgEl.dataset.src = selectedVariant.featured_image.src;
        }
      }
    }

    // Replace SearchSpring's indexed price with the live Shopify variant price.
    // Why: SS price lags Shopify until reindex; pulling from /products/{handle}.js
    // means price changes show up on collection pages immediately.
    if (typeof window.__thsRenderCardPrice === 'function') {
      window.__thsRenderCardPrice(card, selectedVariant.price, selectedVariant.compare_at_price);
    }

    buildCardSwatches(card, product, wrapper, selectedVariant);
  }

  // ========================================
  // COLOR SWATCHES ON PRODUCT CARDS
  // ========================================
  // Rendered two ways: built here from /products/{handle}.js data on
  // SearchSpring grids, or server-rendered by product-grid-item.liquid on
  // native collection grids (same markup; initLiquidSwatches styles those).
  // Clicking a swatch selects that color's first available variant through
  // the existing .grid-product__variant-select change handler.

  var SWATCH_COLOR_MAP = {
    'black': '#151515', 'white': '#ececec', 'grey': '#8e8e8e', 'gray': '#8e8e8e',
    'charcoal': '#3d3d3d', 'graphite': '#4a4a4a',
    'navy': '#152744', 'royal': '#1f4bc4', 'blue': '#2054c8', 'light blue': '#7db3e0',
    'sky blue': '#7db3e0', 'carolina blue': '#66a3d2', 'teal': '#0f8a8a', 'turquoise': '#30c4c9',
    'red': '#c8102e', 'maroon': '#6e1c2e', 'burgundy': '#6e1c2e', 'cardinal': '#8c1d2f',
    'green': '#1c6b3c', 'forest green': '#1b4d2e', 'forest': '#1b4d2e',
    'kelly': '#2c9c46', 'kelly green': '#2c9c46', 'lime': '#9ccc3d',
    'orange': '#e8551e', 'burnt orange': '#c1521f',
    'yellow': '#f4c400', 'gold': '#d4a017', 'vegas gold': '#c5b358',
    'sport gold': '#f4c400', 'old gold': '#cfb53b',
    'pink': '#e86ca4', 'purple': '#5c2d91',
    'brown': '#6b4a2b', 'tan': '#c9a56e', 'beige': '#d9c7a3', 'cream': '#f1e7d0',
    'silver': '#c4c8cc', 'clear': '#eef0f2', 'natural': '#e6dcc8'
  };

  // Extended swatch map: hand-mapped team colorways + colors auto-extracted
  // from variant images. Generated by upc_sku_fix/apply_swatch_extraction.js
  // (source: extract_swatch_colors.js). Values may be full CSS gradients.
  var SWATCH_COLOR_EXTRA = {
    'chicago blackhawks': 'linear-gradient(135deg, #cf0a2c 32.5%, #151515 33.5% 65.5%, #ececec 66.5%)',
    'toronto maple leafs': 'linear-gradient(135deg, #00205b 49.5%, #ececec 50.5%)',
    'detroit red wings': 'linear-gradient(135deg, #ce1126 49.5%, #ececec 50.5%)',
    'boston bruins': 'linear-gradient(135deg, #151515 49.5%, #fcb514 50.5%)',
    'montreal canadiens': 'linear-gradient(135deg, #af1e2d 49.5%, #192168 50.5%)',
    'rescue red': '#b9081e',
    'seafoam': '#aaece0',
    'canada': 'linear-gradient(135deg, #c8102e 49.5%, #ececec 50.5%)',
    'chrome': 'linear-gradient(135deg, #a0a0a0 49.5%, #1b1b1b 50.5%)',
    'icy blue': '#b8dcea',
    'dark chrome': 'linear-gradient(135deg, #6f6f6f 49.5%, #23272b 50.5%)',
    'big sky blue': '#bdd4f1',
    'big wave blue': '#0183c5',
    'camp green': '#444648',
    'heather grey': '#7e7e7e',
    'king crab': '#f67c0f',
    'agave teal': '#0b3941',
    'dark green': 'linear-gradient(135deg, #29514a 49.5%, #0c1110 50.5%)',
    'tropical pink': 'linear-gradient(135deg, #f26e89 49.5%, #cd4a66 50.5%)',
    'vegas golden knights': 'linear-gradient(135deg, #b4975a 49.5%, #333f42 50.5%)',
    'cosmic lilac': 'linear-gradient(135deg, #bcbad8 49.5%, #3c3c50 50.5%)',
    'camo': '#414038',
    'new york rangers': 'linear-gradient(135deg, #0038a8 49.5%, #ce1126 50.5%)',
    'true navy': '#3a3c53',
    'olive': '#4f563f',
    'athletic grey': 'linear-gradient(135deg, #bcbab8 49.5%, #7e7f82 50.5%)',
    'calgary flames': 'linear-gradient(135deg, #c8102e 49.5%, #f1be48 50.5%)',
    'stainless': '#bdbab6',
    'philadelphia flyers': 'linear-gradient(135deg, #f74902 49.5%, #151515 50.5%)',
    'dark grey': '#494c54',
    'kings': 'linear-gradient(135deg, #151515 49.5%, #a2aaad 50.5%)',
    'neon green': 'linear-gradient(135deg, #0ee262 49.5%, #c7f2db 50.5%)',
    '2-tone': 'linear-gradient(135deg, #131113 49.5%, #f6e163 50.5%)',
    'edmonton oilers': 'linear-gradient(135deg, #041e42 49.5%, #ff4c00 50.5%)',
    'san jose sharks': 'linear-gradient(135deg, #006d75 49.5%, #151515 50.5%)',
    'wood': '#8b6037',
    'flames': 'linear-gradient(135deg, #c8102e 49.5%, #f1be48 50.5%)',
    'light grey': '#b5b7ba',
    'royal blue': 'linear-gradient(135deg, #3a4aa8 49.5%, #8387b6 50.5%)',
    'acai': '#5f2c30',
    'la kings': 'linear-gradient(135deg, #151515 49.5%, #a2aaad 50.5%)',
    'orca': '#b9b9ad',
    'power pink': '#dc9ebf',
    'vancouver canucks': 'linear-gradient(135deg, #00205b 49.5%, #00843d 50.5%)',
    'wild': 'linear-gradient(135deg, #154734 49.5%, #a6192e 50.5%)',
    'carbon': '#6e6b64',
    'ottawa senators': 'linear-gradient(135deg, #c52032 49.5%, #151515 50.5%)',
    'predators': 'linear-gradient(135deg, #ffb81c 49.5%, #041e42 50.5%)',
    'chicago': 'linear-gradient(135deg, #bd3329 49.5%, #48393b 50.5%)',
    'dark green / white': '#0e4438',
    'harvard': 'linear-gradient(135deg, #b2474e 49.5%, #120d0f 50.5%)',
    'violet': 'linear-gradient(135deg, #574d6d 49.5%, #18161a 50.5%)',
    'black / graphite grey': '#211f22',
    'bruins': 'linear-gradient(135deg, #151515 49.5%, #fcb514 50.5%)',
    'gunmetal': 'linear-gradient(135deg, #b6b4b4 49.5%, #434245 50.5%)',
    'indigo': '#183d6a',
    'langley eagles': '#3a393c',
    'vintage brown': '#b9b9b7',
    'black / ice grey': 'linear-gradient(135deg, #2a272a 49.5%, #605e61 50.5%)',
    'buckaroo blue': '#3f3f3f',
    'daybreak yellow': 'linear-gradient(135deg, #eee09f 49.5%, #b9ac70 50.5%)',
    'gold chain': 'linear-gradient(135deg, #97844d 49.5%, #ba4c3a 50.5%)',
    'islanders': 'linear-gradient(135deg, #00539b 49.5%, #f47d30 50.5%)',
    'khaki': '#a79889',
    'lime green': '#6baa39',
    'mettalic gold': '#b2ada7',
    'natural wood': 'linear-gradient(135deg, #cea87f 49.5%, #ecd9c3 50.5%)',
    'neon yellow': 'linear-gradient(135deg, #e7d416 49.5%, #eae26a 50.5%)',
    'papaya': 'linear-gradient(135deg, #fa6846 49.5%, #db360f 50.5%)',
    'pittsburgh penguins': 'linear-gradient(135deg, #151515 49.5%, #fcb514 50.5%)',
    'powder blue': '#5486cd',
    'senators': 'linear-gradient(135deg, #c52032 49.5%, #151515 50.5%)',
    'sunflower': '#da8d04',
    'toronto': 'linear-gradient(135deg, #274d8d 49.5%, #3b3b41 50.5%)',
    'wildflower fuchsia': 'linear-gradient(135deg, #e377b9 49.5%, #b64b8c 50.5%)',
    'baby blue': '#064e95',
    'black camo': 'linear-gradient(135deg, #201e1d 49.5%, #514f4e 50.5%)',
    'columbus blue jackets': 'linear-gradient(135deg, #002654 49.5%, #ce1126 50.5%)',
    'dark blue': '#113a87',
    'detroit': 'linear-gradient(135deg, #aeaeac 49.5%, #40403e 50.5%)',
    'high desert clay': '#df7655',
    'iron': '#2f2e34',
    'jets': 'linear-gradient(135deg, #041e42 49.5%, #c8102e 50.5%)',
    'midnight blue': '#363d5d',
    'natural wood / black': 'linear-gradient(135deg, #b2a38b 49.5%, #dfd6c3 50.5%)',
    'sand': '#c0b9b0',
    'unbleached': '#ebe4da',
    'winnipeg jets': 'linear-gradient(135deg, #041e42 49.5%, #c8102e 50.5%)',
    'anthracite': '#242b35',
    'beekeeper': 'linear-gradient(135deg, #f8aa1d 49.5%, #c47c04 50.5%)',
    'camel / black': 'linear-gradient(135deg, #a3a3a2 49.5%, #696968 50.5%)',
    'canadiens royal': '#1f4bc4',
    'canopy green': 'linear-gradient(135deg, #53a935 49.5%, #2d6a19 50.5%)',
    'canucks': 'linear-gradient(135deg, #00205b 49.5%, #00843d 50.5%)',
    'crimson': '#8e171d',
    'fleury': '#fabb2d',
    'graphite grey': 'linear-gradient(135deg, #5a5d5f 49.5%, #2e3031 50.5%)',
    'kachina': 'linear-gradient(135deg, #2a1f23 49.5%, #657072 50.5%)',
    'metallic gold': '#a8a4a0',
    'mod grey': '#2a282b',
    'offwhite': 'linear-gradient(135deg, #e1d7cb 49.5%, #178b57 50.5%)',
    'price': 'linear-gradient(135deg, #222a66 49.5%, #b7b9c0 50.5%)',
    'sabres': 'linear-gradient(135deg, #003087 49.5%, #ffb81c 50.5%)',
    'sharks': 'linear-gradient(135deg, #006d75 49.5%, #151515 50.5%)',
    'tampa bay lightning': 'linear-gradient(135deg, #002868 49.5%, #ececec 50.5%)',
    'team canada': 'linear-gradient(135deg, #c8102e 49.5%, #ececec 50.5%)',
    'twilight': 'linear-gradient(135deg, #443f39 49.5%, #92908e 50.5%)',
    'black / camo': '#32333b',
    'blaze orange': '#3a3a3b',
    'buffalo sabres': 'linear-gradient(135deg, #003087 49.5%, #ffb81c 50.5%)',
    'clay': 'linear-gradient(135deg, #904b13 49.5%, #1a1a1a 50.5%)',
    'clr': 'linear-gradient(135deg, #37373a 49.5%, #5f6e76 50.5%)',
    'cream / dark green / red': '#3b393e',
    'dallas stars': 'linear-gradient(135deg, #006847 49.5%, #151515 50.5%)',
    'egret': 'linear-gradient(135deg, #efdbc5 49.5%, #d4a689 50.5%)',
    'grey camo': '#4b545b',
    'grey heather': '#bebbb2',
    'matte black': 'linear-gradient(135deg, #3a3539 49.5%, #7e7877 50.5%)',
    'mint': '#d3ddc6',
    'montreal': 'linear-gradient(135deg, #aeaeac 49.5%, #40403e 50.5%)',
    'oilers': 'linear-gradient(135deg, #041e42 49.5%, #ff4c00 50.5%)',
    'onyx': '#3c3c3c',
    'poison ivy': '#3d3c35',
    'rsg': 'linear-gradient(135deg, #252a2b 49.5%, #5a5e5f 50.5%)',
    'rust': 'linear-gradient(135deg, #98544a 49.5%, #682f27 50.5%)',
    'sky': '#4394cb',
    'stars': 'linear-gradient(135deg, #006847 49.5%, #151515 50.5%)',
    'stealth grey': '#d0cfdb',
    'sunflower / white': '#e3a930',
    'team usa': 'linear-gradient(135deg, #041e42 32.5%, #c8102e 33.5% 65.5%, #ececec 66.5%)',
    'warm orange': 'linear-gradient(135deg, #bf2707 49.5%, #878484 50.5%)',
    'white / ice grey': 'linear-gradient(135deg, #b7b5b9 49.5%, #2f2b2e 50.5%)',
    'alpha': 'linear-gradient(135deg, #212126 49.5%, #555756 50.5%)',
    'anaheim ducks': 'linear-gradient(135deg, #151515 49.5%, #f47a38 50.5%)',
    'avalanche': 'linear-gradient(135deg, #6f263d 49.5%, #236192 50.5%)',
    'avery': 'linear-gradient(135deg, #1c191c 49.5%, #bd7a28 50.5%)',
    'blue camo': 'linear-gradient(135deg, #162747 49.5%, #4b5870 50.5%)',
    'blue jackets': 'linear-gradient(135deg, #002654 49.5%, #ce1126 50.5%)',
    'boston': 'linear-gradient(135deg, #aeaeac 49.5%, #40403e 50.5%)',
    'breeze blue': '#ace1e1',
    'brick': '#bd371a',
    'cape taupe': 'linear-gradient(135deg, #d7d0c5 49.5%, #aaa298 50.5%)',
    'capitals': 'linear-gradient(135deg, #c8102e 49.5%, #041e42 50.5%)',
    'cherry blossom': '#3f3f3f',
    'classic navy': '#222537',
    'collegiate royal': '#354e91',
    'cool pink': '#fb3c7c',
    'covert': 'linear-gradient(135deg, #24242a 49.5%, #52555f 50.5%)',
    'crimson red': '#901920',
    'cyan': '#35363c',
    'dark flames': 'linear-gradient(135deg, #1f1b21 49.5%, #faba25 50.5%)',
    'devils': 'linear-gradient(135deg, #ce1126 49.5%, #151515 50.5%)',
    'dlc': '#5e5b61',
    'flyers': 'linear-gradient(135deg, #f74902 49.5%, #151515 50.5%)',
    'harvard / white': '#862238',
    'ice': 'linear-gradient(135deg, #222222 49.5%, #5a5d5f 50.5%)',
    'la kings 3rd': 'linear-gradient(135deg, #151515 32.5%, #a2aaad 33.5% 65.5%, #ececec 66.5%)',
    'lightning': 'linear-gradient(135deg, #002868 49.5%, #ececec 50.5%)',
    'london knights': 'linear-gradient(135deg, #155a46 49.5%, #2b2a28 50.5%)',
    'mto': '#2a1f1e',
    'phoenix': '#78181b',
    'pitch grey': '#232427',
    'quinn hughes': 'linear-gradient(135deg, #262123 49.5%, #c09727 50.5%)',
    'storm grey': '#5b5b5d',
    'usa': 'linear-gradient(135deg, #041e42 32.5%, #c8102e 33.5% 65.5%, #ececec 66.5%)',
    'vapor - black / red / neon green': 'linear-gradient(135deg, #272325 49.5%, #f14641 50.5%)',
    'wetlands camo': 'linear-gradient(135deg, #987f6b 49.5%, #624f43 50.5%)',
    '1/18 scale': 'linear-gradient(135deg, #95969b 49.5%, #5a5c5d 50.5%)',
    '1/64 scale': 'linear-gradient(135deg, #3c3b38 49.5%, #a1a09d 50.5%)',
    'academy': '#414a66',
    'alternate': '#aa3d5d',
    'arizona coyotes': 'linear-gradient(135deg, #8c2633 49.5%, #e2d6b5 50.5%)',
    'black / neon green': 'linear-gradient(135deg, #52eb54 49.5%, #c7f2c8 50.5%)',
    'black weave / sport gold / red / white': 'linear-gradient(135deg, #4b4848 49.5%, #7a6d65 50.5%)',
    'bright orange': '#f7440d',
    'brock boeser': 'linear-gradient(135deg, #262325 49.5%, #c1972c 50.5%)',
    'bucky': 'linear-gradient(135deg, #7a5731 49.5%, #a2947e 50.5%)',
    'bucky / black': '#b07420',
    'carolina hurricanes': 'linear-gradient(135deg, #cc0000 49.5%, #151515 50.5%)',
    'cerise': '#fb84bd',
    'coyotes': 'linear-gradient(135deg, #8c2633 49.5%, #e2d6b5 50.5%)',
    'dark lichen': 'linear-gradient(135deg, #3e6258 49.5%, #949190 50.5%)',
    'dark midnight': '#2d3141',
    'diamond white': '#ddd9cf',
    'diva': 'linear-gradient(135deg, #ca096e 49.5%, #362029 50.5%)',
    'electric blue': '#295b8d',
    'elias petterson': '#272225',
    'emerald green': '#7caa3e',
    'forrest green': 'linear-gradient(135deg, #35332f 49.5%, #0c0c0a 50.5%)',
    'fuschia': '#be3061',
    'glow in the dark': '#e8e2c6',
    'i2': 'linear-gradient(135deg, #808083 49.5%, #24242a 50.5%)',
    'jet black': '#151515',
    'jet grey / black': '#7a7877',
    'maize yellow': '#eabf45',
    'mascot': 'linear-gradient(135deg, #a97d86 49.5%, #a61630 50.5%)',
    'melon': 'linear-gradient(135deg, #e6a372 49.5%, #664c3d 50.5%)',
    'moon dust': '#616488',
    'natural wood / gold (blue tip)': '#eedcc9',
    'neon orange': 'linear-gradient(135deg, #e7cec6 49.5%, #cf573d 50.5%)',
    'new french navy': '#3c4753',
    'oat': '#9d9079',
    'octane': '#c6bbdc',
    'penguins': 'linear-gradient(135deg, #151515 49.5%, #fcb514 50.5%)',
    'plaid': 'linear-gradient(135deg, #2f1515 49.5%, #543d3e 50.5%)',
    'platinum': '#b4b7ba',
    'platinum grey': '#a09b96',
    'prism': '#e3dae7',
    'resue red': 'linear-gradient(135deg, #a1151c 49.5%, #df2b38 50.5%)',
    'river green': '#4f7d81',
    'royal / baby blue / white': 'linear-gradient(135deg, #0e153d 49.5%, #a9b0ba 50.5%)',
    'satin black': '#2f2f2f',
    'shark': '#4b4347',
    'shiny black': '#595758',
    'shiny navy': '#595758',
    'smoke': 'linear-gradient(135deg, #7f7f80 49.5%, #b7b7b8 50.5%)',
    'washington capitals': 'linear-gradient(135deg, #c8102e 49.5%, #041e42 50.5%)',
    'white / black / red weave': 'linear-gradient(135deg, #222122 49.5%, #b6b5b4 50.5%)',
    'white / navy / ice blue': 'linear-gradient(135deg, #b2d8dc 49.5%, #0d1325 50.5%)',
    'army': 'linear-gradient(135deg, #272528 49.5%, #5b5657 50.5%)',
    'beta': 'linear-gradient(135deg, #302e2e 49.5%, #df7175 50.5%)',
    'black / antique gold': 'linear-gradient(135deg, #1c1c1c 49.5%, #575656 50.5%)',
    'black / pitch grey': '#3a3a3b',
    'black / white / white weave': 'linear-gradient(135deg, #212c43 49.5%, #a6a4a3 50.5%)',
    'black 20th anniversary': '#242424',
    'black forest green': 'linear-gradient(135deg, #0f3e30 49.5%, #436d60 50.5%)',
    'black matte': 'linear-gradient(135deg, #3c3a3a 49.5%, #766f68 50.5%)',
    'black stone': '#616162',
    'blue cobalt': '#283d6e',
    'canvas': 'linear-gradient(135deg, #d4d6d6 49.5%, #13171c 50.5%)',
    'classic': 'linear-gradient(135deg, #848283 49.5%, #1c1a1e 50.5%)',
    'college blue': '#26294f',
    'colorado avalanche': 'linear-gradient(135deg, #6f263d 49.5%, #236192 50.5%)',
    'copper': '#944827',
    'crimson / white': '#872338',
    'cruise blue': 'linear-gradient(135deg, #393b3c 49.5%, #2f749a 50.5%)',
    'dark': 'linear-gradient(135deg, #4d5a5e 49.5%, #a6b3b6 50.5%)',
    'edmonton': '#1b2231',
    'fire red': '#8b2119',
    'fired up': '#586167',
    'golden knights grey': 'linear-gradient(135deg, #8e8e8e 49.5%, #b4975a 50.5%)',
    'gunmetal grey': '#706d74',
    'hi vis yellow': 'linear-gradient(135deg, #30302e 49.5%, #eaee54 50.5%)',
    'hunter green': '#0f3a32',
    'hurricanes': 'linear-gradient(135deg, #cc0000 49.5%, #151515 50.5%)',
    'i heart cowboys': '#938e9f',
    'ice blue': '#a5c6ec',
    'key lime': 'linear-gradient(135deg, #c3e1a8 49.5%, #809969 50.5%)',
    'l/xl': '#d4d7e1',
    'la kings black': 'linear-gradient(135deg, #151515 49.5%, #a2aaad 50.5%)',
    'la purple': 'linear-gradient(135deg, #35332f 49.5%, #0c0c0a 50.5%)',
    'leafs': 'linear-gradient(135deg, #b8b7bd 49.5%, #2c3c66 50.5%)',
    'los angeles kings': 'linear-gradient(135deg, #151515 49.5%, #a2aaad 50.5%)',
    'madder brown': '#67312f',
    'midnight tropics': 'linear-gradient(135deg, #191817 49.5%, #4d4e45 50.5%)',
    'n michigan': 'linear-gradient(135deg, #115d45 49.5%, #f7be1b 50.5%)',
    'natural wood / gold (white tip)': 'linear-gradient(135deg, #aea685 49.5%, #dcd5c0 50.5%)',
    'neon': '#c6d720',
    'new york islanders': 'linear-gradient(135deg, #00539b 49.5%, #f47d30 50.5%)',
    'nyr': 'linear-gradient(135deg, #cabed9 49.5%, #5241be 50.5%)',
    'oat milk': '#b9a083',
    'oatmeal': '#ecdecb',
    'oatmeal heather': '#d2c7c3',
    'ocean': 'linear-gradient(135deg, #19384c 49.5%, #564a4c 50.5%)',
    'orca blue': '#1e4082',
    'os': 'linear-gradient(135deg, #252526 49.5%, #7f7f7c 50.5%)',
    'osfm': 'linear-gradient(135deg, #232322 49.5%, #d9d4c8 50.5%)',
    'painterly paradise': 'linear-gradient(135deg, #212021 49.5%, #555955 50.5%)',
    'penta pink': '#3a3a3b',
    'philly': '#131518',
    'phoenix red': '#c63233',
    'pineapple': 'linear-gradient(135deg, #2f3133 49.5%, #9e9ea0 50.5%)',
    'pitch grey / cerise': 'linear-gradient(135deg, #464748 49.5%, #f46f9c 50.5%)',
    'pitch grey / cruise blue': 'linear-gradient(135deg, #56595a 49.5%, #497ea5 50.5%)',
    'pitch grey / hi vis yellow': 'linear-gradient(135deg, #454748 49.5%, #c9cf3f 50.5%)',
    'polar blue': '#0e84c8',
    'rainbow': 'linear-gradient(135deg, #eac5df 49.5%, #a7b4da 50.5%)',
    'reef blue': 'linear-gradient(135deg, #54bed6 49.5%, #969a9b 50.5%)',
    's/m': '#161c24',
    'salmon': '#f4a797',
    'salt & pepper': '#505059',
    'sandstone pink': 'linear-gradient(135deg, #d09c98 49.5%, #8b5753 50.5%)',
    'shiny black / red': '#595758',
    'skate': 'linear-gradient(135deg, #070708 49.5%, #eb100a 50.5%)',
    'st. louis blues': 'linear-gradient(135deg, #002f87 49.5%, #fcb514 50.5%)',
    'stars & stripes': 'linear-gradient(135deg, #041e42 32.5%, #c8102e 33.5% 65.5%, #ececec 66.5%)',
    'steel / hypergreen': '#605d5e',
    'supersize camo': '#1e1c1e',
    'swedish yellow': '#d8ba05',
    'sweet concrete': '#bcbcbc',
    'third - black': 'linear-gradient(135deg, #151416 49.5%, #d69633 50.5%)',
    'uniform green': '#67665b',
    'vancouver canucks skate': 'linear-gradient(135deg, #151515 49.5%, #f4c400 50.5%)',
    'vegas black': 'linear-gradient(135deg, #201f25 49.5%, #e5d9bf 50.5%)',
    'vegas grey': 'linear-gradient(135deg, #31302f 49.5%, #0f0f0f 50.5%)',
    'vetiver': '#838680',
    'vintage black': '#25252a',
    'violet / white': '#5c3f96',
    'volcano': '#302b27',
    'whalers': '#377b4f',
    'wild green': '#275148',
    'wild vine red': 'linear-gradient(135deg, #44171f 49.5%, #6b4047 50.5%)',
    'wildcat': 'linear-gradient(135deg, #2e2a37 49.5%, #bbb6b8 50.5%)',
    '#tapeouthate': 'linear-gradient(135deg, #828282 49.5%, #b3b2b3 50.5%)',
    '1/50 scale': 'linear-gradient(135deg, #201d1e 49.5%, #6f6d71 50.5%)',
    '2 boxes': '#1d1b1e',
    '3-pack': 'linear-gradient(135deg, #828486 49.5%, #101010 50.5%)',
    '75 degree': 'linear-gradient(135deg, #3e3d3e 49.5%, #b9b9b6 50.5%)',
    'alexandre barkov champs edition': '#b90a25',
    'alien': 'linear-gradient(135deg, #05da1b 49.5%, #0dfa6d 50.5%)',
    'all daye': 'linear-gradient(135deg, #ec8162 49.5%, #c4c58b 50.5%)',
    'all star': 'linear-gradient(135deg, #322843 49.5%, #6d1829 50.5%)',
    'all teams': 'linear-gradient(135deg, #a5969e 49.5%, #74656c 50.5%)',
    'american flag': 'linear-gradient(135deg, #041e42 32.5%, #c8102e 33.5% 65.5%, #ececec 66.5%)',
    'artic berry': '#94d1c9',
    'ash rose': 'linear-gradient(135deg, #e1a086 49.5%, #a97059 50.5%)',
    'auston mathews': 'linear-gradient(135deg, #929fb6 49.5%, #53678e 50.5%)',
    'bad morning': 'linear-gradient(135deg, #c2d2da 49.5%, #a8a6a3 50.5%)',
    'bagheera': 'linear-gradient(135deg, #394242 49.5%, #68746f 50.5%)',
    'banana': '#d4b82a',
    'banana bunch': 'linear-gradient(135deg, #c9764f 49.5%, #d6b55d 50.5%)',
    'batallion': 'linear-gradient(135deg, #aa8f62 49.5%, #665943 50.5%)',
    'batman': 'linear-gradient(135deg, #6d6e68 49.5%, #333127 50.5%)',
    'bauer': '#1f1d22',
    'bauer supreme (24)': 'linear-gradient(135deg, #23282e 49.5%, #b2b3b1 50.5%)',
    'bauer vapor (23)': 'linear-gradient(135deg, #1d2128 49.5%, #b0b3b2 50.5%)',
    'beyond the grave': 'linear-gradient(135deg, #1f1e20 49.5%, #4e4c4d 50.5%)',
    'big blue wave': 'linear-gradient(135deg, #048dc7 49.5%, #04628f 50.5%)',
    'birthday cake': 'linear-gradient(135deg, #7e8378 49.5%, #b0bbb5 50.5%)',
    'black /  white / white weave': 'linear-gradient(135deg, #222122 49.5%, #b6b5b4 50.5%)',
    'black / blue / camo': 'linear-gradient(135deg, #272423 49.5%, #5f5f60 50.5%)',
    'black / chrome': 'linear-gradient(135deg, #292929 49.5%, #6f6f6f 50.5%)',
    'black / dark charcoal': 'linear-gradient(135deg, #7a7b7e 49.5%, #1b1c1e 50.5%)',
    'black / electric blue': '#1c1a21',
    'black / lime green / white': '#38383d',
    'black / neon red': '#242325',
    'black / shock green': '#414140',
    'black / steel / white': '#afb1b8',
    'black / sunflower': '#18191f',
    'black / tech': '#151312',
    'black / white / aviator blue': 'linear-gradient(135deg, #36363c 49.5%, #b2b0b2 50.5%)',
    'black / white felt': 'linear-gradient(135deg, #2a2a2a 49.5%, #5c5c5c 50.5%)',
    'black / youth': '#31302f',
    'black & white': 'linear-gradient(135deg, #1d1e1c 49.5%, #a0a19f 50.5%)',
    'black astro surf / turf': 'linear-gradient(135deg, #211d20 49.5%, #9e999a 50.5%)',
    'black beer champs': '#323232',
    'black blurred stripe': '#36373c',
    'black clear': 'linear-gradient(135deg, #beb9b4 49.5%, #958678 50.5%)',
    'black coast stripe': 'linear-gradient(135deg, #292929 49.5%, #5a5a5a 50.5%)',
    'black crew stripe': 'linear-gradient(135deg, #7c7c7c 49.5%, #282828 50.5%)',
    'black forest cherry': '#3f3f3f',
    'black gradient stripe': '#362e36',
    'black mountainscape': 'linear-gradient(135deg, #231f1f 49.5%, #5a584e 50.5%)',
    'black ombre stripe': 'linear-gradient(135deg, #807e82 49.5%, #4d4b51 50.5%)',
    'black prism': '#171417',
    'black sig': '#3d3d3d',
    'black skate': '#3c3a39',
    'black solar pineapples': '#171315',
    'black space': '#282729',
    'black stache': 'linear-gradient(135deg, #5d5d5f 49.5%, #242327 50.5%)',
    'black stripe': '#242d36',
    'black trail': 'linear-gradient(135deg, #a7a3a6 49.5%, #2c2b2c 50.5%)',
    'black true north': '#2e2a2c',
    'black white orange': '#222121',
    'black/lime green': 'linear-gradient(135deg, #1a1919 49.5%, #d09f7d 50.5%)',
    'blackhawks': 'linear-gradient(135deg, #cf0a2c 32.5%, #151515 33.5% 65.5%, #ececec 66.5%)',
    'blue / sky': 'linear-gradient(135deg, #272828 49.5%, #c7cbd2 50.5%)',
    'blue & green': 'linear-gradient(135deg, #638188 49.5%, #325a63 50.5%)',
    'blue action shot': 'linear-gradient(135deg, #63a6cb 49.5%, #2e3138 50.5%)',
    'blue banana rama': 'linear-gradient(135deg, #28aec1 49.5%, #232227 50.5%)',
    'blue checker': '#81819b',
    'blue fade': '#76949d',
    'blue foxy': '#304460',
    'blue green camo': '#707176',
    'blue hiker stripe': 'linear-gradient(135deg, #606378 49.5%, #9094a6 50.5%)',
    'blue nighthawk': '#3b4053',
    'blue pinata bang': '#3a4c75',
    'blue poppy': 'linear-gradient(135deg, #8bc3d7 49.5%, #3d3f40 50.5%)',
    'blue pucking awesome': 'linear-gradient(135deg, #5b9ac2 49.5%, #99b6cd 50.5%)',
    'blue space hiker stripe': 'linear-gradient(135deg, #1e5d69 49.5%, #17262a 50.5%)',
    'blue totally gnar': '#5f6b7a',
    'blue whoopee': 'linear-gradient(135deg, #52adce 49.5%, #16203a 50.5%)',
    'bluejay blue': '#3bbae7',
    'bluesteel': '#87a0aa',
    'bo horvat': 'linear-gradient(135deg, #262325 49.5%, #c1972c 50.5%)',
    'bowties n booze': '#211f20',
    'brady tkachuk': '#b20e1e',
    'buckeyes': 'linear-gradient(135deg, #f05761 49.5%, #de252f 50.5%)',
    'budgie green': 'linear-gradient(135deg, #4ba955 49.5%, #228f31 50.5%)',
    'bull dogs': 'linear-gradient(135deg, #1d1b2c 49.5%, #9f9ba2 50.5%)',
    'burgundy chain': 'linear-gradient(135deg, #663b46 49.5%, #927b86 50.5%)',
    'burnt plum': '#42202d',
    'butterfly palm': 'linear-gradient(135deg, #bcbab7 49.5%, #78a9b0 50.5%)',
    'calgary flames white': 'linear-gradient(135deg, #ececec 49.5%, #c8102e 50.5%)',
    'camo / black': '#313233',
    'camo / blue': 'linear-gradient(135deg, #1d2229 49.5%, #46535d 50.5%)',
    'canadian lager': 'linear-gradient(135deg, #3b3435 49.5%, #796466 50.5%)',
    'canadian lumberjack': '#31292b',
    'canadiana': '#1c1819',
    'canadiens': 'linear-gradient(135deg, #af1e2d 49.5%, #192168 50.5%)',
    'canary yellow': '#edc00e',
    'canyon red': 'linear-gradient(135deg, #d6342e 49.5%, #911813 50.5%)',
    'capre taupe': 'linear-gradient(135deg, #d5cec3 49.5%, #a49d93 50.5%)',
    'capri': '#69b0f8',
    'carbonlite': 'linear-gradient(135deg, #403c3e 49.5%, #b8b0af 50.5%)',
    'carolina dash': 'linear-gradient(135deg, #a1c7e5 49.5%, #3c3e40 50.5%)',
    'ccm jetspeed (23)': 'linear-gradient(135deg, #21272c 49.5%, #a5a8a6 50.5%)',
    'ccm tacks (24)': '#171c21',
    'cement': 'linear-gradient(135deg, #c9ced7 49.5%, #494147 50.5%)',
    'chambray americana': '#414f6e',
    'charcoal camo': '#4f4f4f',
    'charcoal heather / black': '#616161',
    'chartreuse': 'linear-gradient(135deg, #c4d53b 49.5%, #8f9d0d 50.5%)',
    'cherry': '#c7a9a4',
    'chicago black': '#0f0f0f',
    'chilliwack chiefs': 'linear-gradient(135deg, #4e100f 49.5%, #8b8082 50.5%)',
    'city blue': '#1f4e84',
    'city blue heather': '#494949',
    'clayton keller': '#73a6cf',
    'coast life navy': 'linear-gradient(135deg, #1d2228 49.5%, #4a555e 50.5%)',
    'colorado blue': '#155478',
    'columbus blue jackets away': 'linear-gradient(135deg, #ececec 49.5%, #002654 50.5%)',
    'columbus blue jackets home': 'linear-gradient(135deg, #002654 49.5%, #ce1126 50.5%)',
    'coral': 'linear-gradient(135deg, #f6846a 49.5%, #faad95 50.5%)',
    'coral / pink': '#fa405c',
    'cotton candy': '#599bcf',
    'crossgrain stripe boxers': '#282d34',
    'dark grey / navy': '#3f465a',
    'dark ink / geo': '#151622',
    'dark ink coast stripe': 'linear-gradient(135deg, #222027 49.5%, #495c66 50.5%)',
    'dark orange / pitch grey': '#f2735b',
    'dark red': '#670202',
    'dark teal': '#0c3d4a',
    'digi dash': 'linear-gradient(135deg, #d5badb 49.5%, #3e3e40 50.5%)',
    'dk denim stencil camo': 'linear-gradient(135deg, #576e85 49.5%, #98a1ad 50.5%)',
    'ducks': 'linear-gradient(135deg, #151515 49.5%, #f47a38 50.5%)',
    'dusty rose': '#d39b8c',
    'eagle white': '#bdbdbc',
    'embellished story': 'linear-gradient(135deg, #b1bbbd 49.5%, #a68985 50.5%)',
    'energie': 'linear-gradient(135deg, #8392a2 49.5%, #b4bdc7 50.5%)',
    'equinox': '#2e2624',
    'fear factor': 'linear-gradient(135deg, #3b455a 49.5%, #8ea9be 50.5%)',
    'fire / blue': '#e64538',
    'fire / green': '#eb4c33',
    'fish food': '#b2e2de',
    'flamingo pink': '#fcb0e0',
    'floral': '#232122',
    'florida panthers': 'linear-gradient(135deg, #c8102e 32.5%, #041e42 33.5% 65.5%, #b9975b 66.5%)',
    'florida panthers - navy/white': 'linear-gradient(135deg, #041e42 49.5%, #ececec 50.5%)',
    'footy & pints': 'linear-gradient(135deg, #aab1c4 49.5%, #7089ad 50.5%)',
    'friars black': '#3b3b3b',
    'frog camo': 'linear-gradient(135deg, #d7979f 49.5%, #3e3b3c 50.5%)',
    'furnace': '#da4029',
    'galactic teal': '#2d585e',
    'gamer': 'linear-gradient(135deg, #110e10 49.5%, #616068 50.5%)',
    'geometrix': 'linear-gradient(135deg, #d7979f 49.5%, #3e3b3c 50.5%)',
    'glacier grey': '#9e9ca5',
    'goal cut': '#161c24',
    'golden knights': 'linear-gradient(135deg, #b4975a 49.5%, #333f42 50.5%)',
    'gone bananas': 'linear-gradient(135deg, #1b1a1b 49.5%, #918076 50.5%)',
    'gorilla': 'linear-gradient(135deg, #424149 49.5%, #747075 50.5%)',
    'grape': '#886790',
    'graphite mura kamo': 'linear-gradient(135deg, #5f5b51 49.5%, #262321 50.5%)',
    'green no bad days': 'linear-gradient(135deg, #cfe1c5 49.5%, #98ac98 50.5%)',
    'grey (full right)': 'linear-gradient(135deg, #828182 49.5%, #2b2b2d 50.5%)',
    'grey / soda': '#686574',
    'grey / youth': '#b9b9b9',
    'grey heather lumberjack': 'linear-gradient(135deg, #7f7778 49.5%, #6b4540 50.5%)',
    'grey hockey': '#a4a6a8',
    'grey hot taco': '#a39f9b',
    'grey sock monkey': '#a3a2a2',
    'gridiron snowman': 'linear-gradient(135deg, #378d92 49.5%, #82a3a6 50.5%)',
    'grillicious': 'linear-gradient(135deg, #818d8e 49.5%, #171515 50.5%)',
    'grillicous': 'linear-gradient(135deg, #8e989a 49.5%, #706d6e 50.5%)',
    'harbour pink': 'linear-gradient(135deg, #f590af 49.5%, #c15071 50.5%)',
    'hazy stripe': 'linear-gradient(135deg, #626a75 49.5%, #999da3 50.5%)',
    'hi-vis yellow': '#eaee34',
    'high desert': '#3d3d3d',
    'holiday spirits': 'linear-gradient(135deg, #181e1d 49.5%, #534a49 50.5%)',
    'horizon stripe': 'linear-gradient(135deg, #252439 49.5%, #65505a 50.5%)',
    'hossa': 'linear-gradient(135deg, #1d1a1d 49.5%, #e8ddd0 50.5%)',
    'huskies': 'linear-gradient(135deg, #89313a 49.5%, #b49e9f 50.5%)',
    'hydro': '#264a6e',
    'hyperglide': '#bfbcbd',
    'india ink': '#47484e',
    'india ink amaz-zing': '#3e414f',
    'inline colors': 'linear-gradient(135deg, #b4e0d5 49.5%, #454f63 50.5%)',
    'inner healing': 'linear-gradient(135deg, #9d91b7 49.5%, #bed0d9 50.5%)',
    'ironman': 'linear-gradient(135deg, #616a64 49.5%, #849187 50.5%)',
    'island dream / black': 'linear-gradient(135deg, #bbf0ed 49.5%, #272627 50.5%)',
    'ivory': '#e5ded8',
    'jack hughes': '#971821',
    'jack hughes special edition': '#9e0926',
    'jr1': 'linear-gradient(135deg, #393738 49.5%, #716e71 50.5%)',
    'jr2': 'linear-gradient(135deg, #393738 49.5%, #716e71 50.5%)',
    'jr3': 'linear-gradient(135deg, #393738 49.5%, #716e71 50.5%)',
    'jr4': 'linear-gradient(135deg, #393738 49.5%, #716e71 50.5%)',
    'jungle yellow': 'linear-gradient(135deg, #3e3f4d 49.5%, #855e47 50.5%)',
    'kingston': 'linear-gradient(135deg, #cdcdcf 49.5%, #b0a989 50.5%)',
    'la kings white': 'linear-gradient(135deg, #ececec 49.5%, #151515 50.5%)',
    'langley': 'linear-gradient(135deg, #383738 49.5%, #110f11 50.5%)',
    'lavender': '#59597a',
    'leopard': 'linear-gradient(135deg, #141311 49.5%, #453a2e 50.5%)',
    'liberty navy': '#2c2b41',
    'light brown': '#a37a50',
    'light orange': '#e4950b',
    'light royal': '#0340be',
    'light up': '#bcb9b9',
    'lilac': 'linear-gradient(135deg, #c4ada7 49.5%, #9a7766 50.5%)',
    'lion': 'linear-gradient(135deg, #393136 49.5%, #bea0a0 50.5%)',
    'low country peach': '#f6ad93',
    'lumberjacks': 'linear-gradient(135deg, #c5b7a9 49.5%, #837a76 50.5%)',
    'majolica blue': '#55839c',
    'maple leaf': 'linear-gradient(135deg, #c8102e 49.5%, #ececec 50.5%)',
    'maple leaf black': 'linear-gradient(135deg, #151515 49.5%, #c8102e 50.5%)',
    'maple leafs': 'linear-gradient(135deg, #00205b 49.5%, #ececec 50.5%)',
    'matthew tkachuk': '#a10516',
    'matty beniers': '#254274',
    'miami vice': 'linear-gradient(135deg, #1a1a1a 49.5%, #4f5049 50.5%)',
    'mitchell marner': 'linear-gradient(135deg, #bcc7d5 49.5%, #657393 50.5%)',
    'mod gray heather/white/white': '#471625',
    'mod grey light heather': '#b0a8a2',
    'mountainscape': 'linear-gradient(135deg, #595357 49.5%, #a19d9a 50.5%)',
    'multi cmyk pineapple': 'linear-gradient(135deg, #a2ae92 49.5%, #6e6299 50.5%)',
    'nashville': 'linear-gradient(135deg, #131b2a 49.5%, #334059 50.5%)',
    'natural wood / red': 'linear-gradient(135deg, #f3dfcc 49.5%, #ec8581 50.5%)',
    'nautical nightcap': '#496378',
    'navy / jungle': 'linear-gradient(135deg, #2a303d 49.5%, #585c66 50.5%)',
    'navy / off-white': 'linear-gradient(135deg, #312b4f 49.5%, #9f9fa3 50.5%)',
    'navy / sky / white': '#071f42',
    'navy / youth': '#322e3c',
    'navy banner stripe': 'linear-gradient(135deg, #2d354b 49.5%, #d68f78 50.5%)',
    'navy confetti': '#2f3345',
    'navy lucha libre': 'linear-gradient(135deg, #8a7373 49.5%, #46464e 50.5%)',
    'navy weave /  black / silver /  white': 'linear-gradient(135deg, #4c5974 49.5%, #afb1b7 50.5%)',
    'navy weave / black /  silver / white': 'linear-gradient(135deg, #39404f 49.5%, #3b64a4 50.5%)',
    'navy weave / black / silver / white': 'linear-gradient(135deg, #212c43 49.5%, #a6a4a3 50.5%)',
    'neon / green': '#d6d116',
    'new jersey devils': 'linear-gradient(135deg, #ce1126 49.5%, #151515 50.5%)',
    'nikita kucherov': 'linear-gradient(135deg, #95a0b7 49.5%, #415884 50.5%)',
    'ocean camo': '#333d49',
    'off-white / maroon': 'linear-gradient(135deg, #481b26 49.5%, #d7cfc9 50.5%)',
    'ofsa': 'linear-gradient(135deg, #3c3b3b 49.5%, #bfbcb5 50.5%)',
    'olive green': '#4c3f30',
    'ombre rugby (blue/green)': '#5c7783',
    'ombre rugby (tomato)': '#861a26',
    'orange palm-fetti': '#db704e',
    'oriole orange': '#fd7a38',
    'ottawa': '#141619',
    'otters': 'linear-gradient(135deg, #454153 49.5%, #f9d460 50.5%)',
    'p1': 'linear-gradient(135deg, #5b5557 49.5%, #9c7e81 50.5%)',
    'panthers': 'linear-gradient(135deg, #c8102e 32.5%, #041e42 33.5% 65.5%, #b9975b 66.5%)',
    'pants drunk': 'linear-gradient(135deg, #b9b9b5 49.5%, #879b82 50.5%)',
    'paradise': 'linear-gradient(135deg, #61533f 49.5%, #1f1d1c 50.5%)',
    'park lodge geo': 'linear-gradient(135deg, #cdbfbe 49.5%, #441d29 50.5%)',
    'parrot-dise': 'linear-gradient(135deg, #727b92 49.5%, #454d5f 50.5%)',
    'patrick roy': 'linear-gradient(135deg, #c6c0ba 49.5%, #a8060b 50.5%)',
    'peak purple': 'linear-gradient(135deg, #534373 49.5%, #8d78ae 50.5%)',
    'peri': 'linear-gradient(135deg, #4f4f61 49.5%, #19181d 50.5%)',
    'phantom camo': 'linear-gradient(135deg, #969089 49.5%, #bdb8b3 50.5%)',
    'pink camo': '#ebcacf',
    'pink poppy': 'linear-gradient(135deg, #d7979f 49.5%, #3e3b3c 50.5%)',
    'pink xoro': 'linear-gradient(135deg, #9d9f9d 49.5%, #3a3c3c 50.5%)',
    'pixel paradise': 'linear-gradient(135deg, #a1b5d4 49.5%, #7072b4 50.5%)',
    'plant': 'linear-gradient(135deg, #242828 49.5%, #aa7654 50.5%)',
    'plum': '#3b416f',
    'plum heather': '#4c262a',
    'pool party': '#a4dae5',
    'pool sharks': 'linear-gradient(135deg, #bddae1 49.5%, #84a0ad 50.5%)',
    'poppin\' blue': 'linear-gradient(135deg, #5fbadd 49.5%, #afbabc 50.5%)',
    'port': '#581c26',
    'powder': '#4778a8',
    'prancer': '#413a4a',
    'pulse ti': '#212120',
    'purple checker': 'linear-gradient(135deg, #9e7d95 49.5%, #c9b2c7 50.5%)',
    'purple dyed map': 'linear-gradient(135deg, #3f3e41 49.5%, #a29aab 50.5%)',
    'quack camo': 'linear-gradient(135deg, #d1d5d5 49.5%, #523445 50.5%)',
    'quiet grey': '#d6ccbf',
    'rangers': 'linear-gradient(135deg, #0038a8 49.5%, #ce1126 50.5%)',
    'rangers alt white': 'linear-gradient(135deg, #ececec 49.5%, #0038a8 50.5%)',
    'raven black': 'linear-gradient(135deg, #272727 49.5%, #505050 50.5%)',
    'red / black demo': '#b8b9b5',
    'red / youth': '#31302f',
    'red dash': 'linear-gradient(135deg, #c9646d 49.5%, #3d3a3a 50.5%)',
    'red drinksgiving': 'linear-gradient(135deg, #d42e17 49.5%, #843b27 50.5%)',
    'red halloweenie': '#d44232',
    'red holiday errand': '#9f1830',
    'red plaid': '#3d1d22',
    'red solar stripe': 'linear-gradient(135deg, #93423e 49.5%, #35313b 50.5%)',
    'red tartan': '#4e2f33',
    'red vine': 'linear-gradient(135deg, #4c1621 49.5%, #6b3b44 50.5%)',
    'red wings': 'linear-gradient(135deg, #ce1126 49.5%, #ececec 50.5%)',
    'remix geo': 'linear-gradient(135deg, #6d94c2 49.5%, #b2c8c7 50.5%)',
    'retro': 'linear-gradient(135deg, #aa8558 49.5%, #cab292 50.5%)',
    'reverse retro': 'linear-gradient(135deg, #3e0f12 49.5%, #183564 50.5%)',
    'rooster red': '#d31c1b',
    'root beer': '#594839',
    'royal dash': 'linear-gradient(135deg, #6588b9 49.5%, #303234 50.5%)',
    'salty watermelon': '#77c4a4',
    'san jose': '#1f1f1f',
    'santa / black': 'linear-gradient(135deg, #272727 49.5%, #b6d0c4 50.5%)',
    'satin white': 'linear-gradient(135deg, #3d3d3d 49.5%, #bdbdbd 50.5%)',
    'shiny black/red': '#54565a',
    'sienna': 'linear-gradient(135deg, #be5c37 49.5%, #341e24 50.5%)',
    'skull & crossbones': 'linear-gradient(135deg, #5b6b86 49.5%, #8797aa 50.5%)',
    'skulls': '#1a1a1b',
    'snakeskin tan': 'linear-gradient(135deg, #171716 49.5%, #7b745c 50.5%)',
    'snakeskin white': 'linear-gradient(135deg, #161616 49.5%, #9b9fa0 50.5%)',
    'solid black': '#242424',
    'sonic blue': 'linear-gradient(135deg, #3d52a7 49.5%, #f16932 50.5%)',
    'soupy': 'linear-gradient(135deg, #cd1926 49.5%, #de5455 50.5%)',
    'sour': 'linear-gradient(135deg, #92b851 49.5%, #bcc8b1 50.5%)',
    'spacedye heather': '#7f8d9a',
    'spring training': '#3b3c4e',
    'st. patrick\'s day': 'linear-gradient(135deg, #14a486 49.5%, #6aa48b 50.5%)',
    'stainless steel': '#bfb9b4',
    'standard red': 'linear-gradient(135deg, #575357 49.5%, #ec4449 50.5%)',
    'stawberry dangles': 'linear-gradient(135deg, #f2071a 49.5%, #cdaca2 50.5%)',
    'steel camo': 'linear-gradient(135deg, #808285 49.5%, #414242 50.5%)',
    'stretch limo': '#29282b',
    'superman': 'linear-gradient(135deg, #90b3cd 49.5%, #356bb4 50.5%)',
    'sushi': 'linear-gradient(135deg, #71bab7 49.5%, #373e4c 50.5%)',
    'tailgate': 'linear-gradient(135deg, #2e62ab 49.5%, #181b25 50.5%)',
    'tan/sage': 'linear-gradient(135deg, #b5a483 49.5%, #ece4d3 50.5%)',
    'tang': '#8f879c',
    'tangerine': '#edaa73',
    'taylor creek': 'linear-gradient(135deg, #666067 49.5%, #302f36 50.5%)',
    'team finland': '#192230',
    'team royal': 'linear-gradient(135deg, #566889 49.5%, #373838 50.5%)',
    'team sweden': '#1c2330',
    'thor': 'linear-gradient(135deg, #616a64 49.5%, #849187 50.5%)',
    'tim stutzle': '#0a090b',
    'titans': 'linear-gradient(135deg, #b83b4b 49.5%, #e3d0c3 50.5%)',
    'toronto 3rd royal': '#0e3574',
    'translucent blue': 'linear-gradient(135deg, #3c3d44 49.5%, #4b519b 50.5%)',
    'tropical pop': 'linear-gradient(135deg, #232d32 49.5%, #54717d 50.5%)',
    'true': '#171c21',
    'turqoise': 'linear-gradient(135deg, #8ed0d0 49.5%, #172329 50.5%)',
    'turqoiuse': '#04516f',
    'turquiose': '#04719d',
    'underneath it all': 'linear-gradient(135deg, #4d325e 49.5%, #735e85 50.5%)',
    'undersea garden': 'linear-gradient(135deg, #232937 49.5%, #374f67 50.5%)',
    'vancouver': 'linear-gradient(135deg, #ccccc3 49.5%, #3a3d59 50.5%)',
    'vapor green': '#50d681',
    'velvet crush': '#334155',
    'vintage skate': '#b2bfc1',
    'volcano grey': '#5d5857',
    'washedblack': 'linear-gradient(135deg, #1b1b1d 49.5%, #76898f 50.5%)',
    'watermelon': 'linear-gradient(135deg, #b0c4af 49.5%, #539b4c 50.5%)',
    'wayne gretzky': '#d9521e',
    'wetlands brown': '#553d37',
    'white / dc blue / maroon': 'linear-gradient(135deg, #b6b5b6 49.5%, #8c8a8d 50.5%)',
    'white / grey / goldwhite / grey / gold': '#51515a',
    'white / sport gold / blue / black': 'linear-gradient(135deg, #151417 49.5%, #113574 50.5%)',
    'white / white blue': 'linear-gradient(135deg, #b8bcce 49.5%, #868caa 50.5%)',
    'wild camo': '#494f48',
    'wild spirit': '#4a5260',
    'wildfire camo': '#271c1b',
    'wine / white': '#242424',
    'winter shadows': '#211f20',
    'wire': '#3f4a58',
    'wolfpack': 'linear-gradient(135deg, #373343 49.5%, #69606e 50.5%)',
    'worldwide santa': 'linear-gradient(135deg, #8f3536 49.5%, #ac7f7a 50.5%)',
    'wu tang': '#1a1c1a',
    'xxs': '#242223',
    'yakapov': '#1c1a1d',
    'yellow tin': 'linear-gradient(135deg, #e6ce4e 49.5%, #7ba7d7 50.5%)',
    'yellow xoro': 'linear-gradient(135deg, #9d9f9d 49.5%, #3a3c3c 50.5%)',
    'yeti set go': 'linear-gradient(135deg, #c5dadf 49.5%, #a2aaad 50.5%)',
    'minnesota wild': 'linear-gradient(135deg, #154734 49.5%, #a6192e 50.5%)',
    'nashville predators': 'linear-gradient(135deg, #ffb81c 49.5%, #041e42 50.5%)'
  };
  for (var swatchExtraKey in SWATCH_COLOR_EXTRA) {
    SWATCH_COLOR_MAP[swatchExtraKey] = SWATCH_COLOR_EXTRA[swatchExtraKey];
  }

  // Resolve a color option value to a CSS background. Combo names like
  // "Black / Red" become a split-circle gradient when every part resolves;
  // otherwise null (caller falls back to the variant image thumb).
  function resolveSwatchColor(name) {
    if (!name) return null;
    var key = name.toLowerCase().trim();
    if (SWATCH_COLOR_MAP[key]) return SWATCH_COLOR_MAP[key];
    if (key.indexOf('/') !== -1) {
      // Dedupe repeated parts: "White / White / Black" renders as a clean
      // white/black split, "Black / Black" as solid black
      var uniq = [];
      key.split('/').forEach(function(p) {
        p = p.trim();
        if (p && uniq.indexOf(p) === -1) uniq.push(p);
      });
      var parts = uniq.map(function(p) { return SWATCH_COLOR_MAP[p]; });
      if (!parts.length || !parts.every(Boolean)) return null;
      if (parts.length === 1) return parts[0];
      if (parts.length === 2) {
        // Slight overlap between stops anti-aliases the diagonal edge
        return 'linear-gradient(135deg, ' + parts[0] + ' 49.5%, ' + parts[1] + ' 50.5%)';
      }
      if (parts.length === 3) {
        return 'linear-gradient(135deg, ' + parts[0] + ' 32.5%, ' + parts[1] + ' 33.5% 65.5%, ' + parts[2] + ' 66.5%)';
      }
    }
    return null;
  }

  function applySwatchVisual(btn) {
    if (btn.classList.contains('ss-swatch-styled')) return;
    btn.classList.add('ss-swatch-styled');
    var resolved = resolveSwatchColor(btn.dataset.color);
    if (resolved) {
      btn.style.background = resolved;
      return;
    }
    if (btn.dataset.image) {
      // Thumb URL is square-cropped, so cover fills the circle exactly —
      // no photo edges or letterbox bands inside the dot
      btn.style.backgroundImage = 'url(' + btn.dataset.image + ')';
      btn.style.backgroundSize = 'cover';
      btn.style.backgroundPosition = 'center';
      btn.style.backgroundColor = '#f4f4f4';
    }
  }

  function swatchThumbUrl(src) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=80&height=80&crop=center';
  }

  function buildCardSwatches(card, product, beforeEl, selectedVariant) {
    if (card.querySelector('.grid-product__swatches')) return;

    var colorIdx = -1;
    (product.options || []).some(function(opt, i) {
      var name = ((typeof opt === 'string' ? opt : opt.name) || '').toLowerCase();
      if (name === 'color' || name === 'colour') {
        colorIdx = i;
        return true;
      }
      return false;
    });

    // Group variants by color value, preserving variant order
    var groups = [];
    var byColor = {};
    if (colorIdx !== -1) {
      product.variants.forEach(function(v) {
        var val = (v.options && v.options[colorIdx]) || v['option' + (colorIdx + 1)];
        if (!val) return;
        var g = byColor[val];
        if (!g) {
          g = byColor[val] = { color: val, ids: [], target: null, image: null, cardImage: null };
          groups.push(g);
        }
        g.ids.push(String(v.id));
        if (!g.target && v.available) g.target = v.id;
        if (!g.image && v.featured_image && v.featured_image.src) {
          var src = v.featured_image.src;
          g.image = swatchThumbUrl(src);
          g.cardImage = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=540';
        }
      });
    }

    var row = document.createElement('div');
    row.className = 'grid-product__swatches ss-swatches-init';

    // No colors, or a single color (a lone dot says nothing the image
    // doesn't): keep an empty placeholder row so every card's controls,
    // title, and price line up at the same heights across the grid.
    if (groups.length < 2) {
      row.classList.add('grid-product__swatches--empty');
      row.setAttribute('aria-hidden', 'true');
      beforeEl.parentNode.insertBefore(row, beforeEl);
      return;
    }

    // In-stock colors first (stable within each group) — sold-out dots sit
    // on the right and are the first to fall behind the "+N" cap.
    groups = groups.filter(function(g) { return g.target; })
      .concat(groups.filter(function(g) { return !g.target; }));

    var MAX_SWATCHES = 8;
    var shown = groups.length > MAX_SWATCHES ? groups.slice(0, MAX_SWATCHES - 1) : groups;

    shown.forEach(function(g) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'grid-product__swatch';
      btn.dataset.color = g.color;
      btn.dataset.variantIds = g.ids.join(',');
      if (g.image) btn.dataset.image = g.image;
      if (g.cardImage) btn.dataset.cardImage = g.cardImage;
      if (g.target) {
        btn.dataset.targetVariant = g.target;
      } else {
        // Sold-out colors stay clickable so shoppers can still preview the
        // image; the click handler puts the Add button into Sold Out state.
        btn.classList.add('grid-product__swatch--soldout');
      }
      var label = g.color + (g.target ? '' : ' — Sold Out');
      btn.title = label;
      btn.setAttribute('aria-label', product.title + ' - ' + label);
      if (selectedVariant && g.ids.indexOf(String(selectedVariant.id)) !== -1) {
        btn.classList.add('is-active');
      }
      applySwatchVisual(btn);
      row.appendChild(btn);
    });

    if (groups.length > MAX_SWATCHES) {
      var more = document.createElement('a');
      more.className = 'grid-product__swatch-more';
      more.href = '/products/' + (card.dataset.productHandle || product.handle);
      more.textContent = '+' + (groups.length - (MAX_SWATCHES - 1));
      more.setAttribute('aria-label', 'View all ' + groups.length + ' colors');
      row.appendChild(more);
    }

    beforeEl.parentNode.insertBefore(row, beforeEl);
  }

  // Style + activate swatches server-rendered by product-grid-item.liquid
  // (native collection grids). Idempotent via .ss-swatches-init.
  function initLiquidSwatches() {
    var rows = document.querySelectorAll('.grid-product__swatches:not(.ss-swatches-init)');
    rows.forEach(function(row) {
      row.classList.add('ss-swatches-init');
      row.querySelectorAll('.grid-product__swatch').forEach(applySwatchVisual);
    });
  }
  window.__thsInitSwatches = initLiquidSwatches;

  // Swap the card's main image (same selector chain as the variant-select
  // change handler, which covers both Shopify and SearchSpring grid markup).
  function setCardImage(card, src) {
    if (!src) return;
    var imgEl = card.querySelector('.grid-product__image-mask img') ||
                card.querySelector('.grid__image-contain') ||
                card.querySelector('.grid-product__image') ||
                card.querySelector('img.lazyloaded') ||
                card.querySelector('img.lazyload') ||
                card.querySelector('img');
    if (!imgEl) return;
    imgEl.src = src;
    if (imgEl.dataset.src) imgEl.dataset.src = src;
    if (imgEl.srcset) imgEl.removeAttribute('srcset');
    imgEl.classList.add('lazyloaded');
    imgEl.classList.remove('lazyload');
  }

  // Swatch click: swap the card image to that color, and select its first
  // available variant. The existing variant-select change handler updates
  // price and the Add button. Sold-out colors still preview their image but
  // force the Add button into Sold Out state so a stale in-stock variant
  // can't be added while a sold-out color is displayed.
  document.addEventListener('click', function(evt) {
    var btn = evt.target.closest && evt.target.closest('.grid-product__swatch');
    if (!btn) return;
    // Customizer metafield dots are informational only - no variant to select
    if (btn.classList.contains('grid-product__swatch--static')) return;
    evt.preventDefault();
    evt.stopPropagation();
    var card = btn.closest('.grid-product');
    if (!card) return;

    setCardImage(card, btn.dataset.cardImage);

    var select = card.querySelector('.grid-product__variant-select');
    var target = btn.dataset.targetVariant;
    var addBtn = card.querySelector('.grid-product__add-btn');
    if (target) {
      if (select && select.querySelector('option[value="' + target + '"]')) {
        select.value = target;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (addBtn) {
      addBtn.disabled = true;
      addBtn.classList.add('grid-product__add-btn--sold-out');
      var btnText = addBtn.querySelector('[data-add-to-cart-text]');
      if (btnText) btnText.textContent = 'Sold Out';
    }

    card.querySelectorAll('.grid-product__swatch.is-active').forEach(function(sw) {
      sw.classList.remove('is-active');
    });
    btn.classList.add('is-active');
  });

  // Keep the active ring in sync when the size/variant dropdown changes color
  document.addEventListener('change', function(evt) {
    var select = evt.target.closest && evt.target.closest('.grid-product__variant-select');
    if (!select) return;
    var card = select.closest('.grid-product');
    var row = card && card.querySelector('.grid-product__swatches');
    if (!row) return;
    var id = String(select.value);
    row.querySelectorAll('.grid-product__swatch').forEach(function(sw) {
      var ids = (sw.dataset.variantIds || '').split(',');
      sw.classList.toggle('is-active', ids.indexOf(id) !== -1);
    });
  });

  function enhanceProductCards() {
    var cards = document.querySelectorAll('#searchspring-content .grid-product:not(.ss-enhanced)');

    cards.forEach(function(card) {
      // Mark as being processed
      card.classList.add('ss-enhanced');

      var handle = card.dataset.productHandle;
      if (!handle) return;

      fetchProductByHandle(handle)
        .then(function(product) {
          addVariantControlsToCard(card, product);
        })
        .catch(function(error) {
          console.error('Error fetching product:', handle, error);
        });
    });
  }

  function updateProductCountDisplay() {
    var container = document.getElementById('searchspring-content');
    if (!container) return;

    // Count visible products
    var visibleProducts = container.querySelectorAll('.grid-product').length;
    if (visibleProducts === 0) return;

    // Try to get total from SearchSpring's elements
    var totalProducts = 0;

    // SearchSpring shows total in .collection-filter__item--count
    var totalEl = document.querySelector('.collection-filter__item--count');
    if (totalEl) {
      var match = totalEl.textContent.match(/(\d+)/);
      if (match) totalProducts = parseInt(match[1], 10);
    }

    // Fallback: try other SearchSpring selectors
    if (!totalProducts) {
      var altEl = document.querySelector('.ss-summary-container .ss-results-count-total, .ss-results-count, [class*="result-count"]');
      if (altEl) {
        var altMatch = altEl.textContent.match(/(\d+)/);
        if (altMatch) totalProducts = parseInt(altMatch[1], 10);
      }
    }

    // Fallback: try SS global object if available
    if (!totalProducts && window.SS && window.SS.results && window.SS.results.pagination) {
      totalProducts = window.SS.results.pagination.totalResults || 0;
    }

    // Only show if we have valid numbers
    if (totalProducts === 0) totalProducts = visibleProducts;

    // Find or create the display element
    var displayId = 'ss-product-count-display';
    var display = document.getElementById(displayId);

      if (!display) {
      display = document.createElement('div');
      display.id = displayId;
      display.className = 'ss-product-count-display';

      // Insert inside the collection-filter, immediately before the sort item
      var sortItem = document.querySelector('.collection-filter__item--sort');
      if (sortItem && sortItem.parentNode) {
        sortItem.parentNode.insertBefore(display, sortItem);
      } else {
        // Fallback: insert at top of searchspring container
        var toolbar = container.querySelector('.ss-toolbar-top, .ss-toolbar');
        if (toolbar) {
          toolbar.parentNode.insertBefore(display, toolbar.nextSibling);
        } else {
          container.insertBefore(display, container.firstChild);
        }
      }
    }

    // Update the display
    display.textContent = 'Showing ' + visibleProducts + ' of ' + totalProducts + ' products';
  }

  // Auto-apply "In Stock" filter before SearchSpring's first search.
  // Setting the hash after SS renders (the old toggle default) made SS
  // re-search and re-render the whole grid — a visible layout shift.
  function applyInStockFilter() {
    // Search pages (/collections/shop?q=) and SS-rendered collection pages
    var isSearch = window.location.pathname.includes('/collections/shop') && window.location.search.includes('q=');
    var isSSCollection = window.location.pathname.includes('/collections/') && document.getElementById('searchspring-content');
    if (!isSearch && !isSSCollection) {
      return;
    }

    // Check if filter is already applied (in URL hash)
    if (window.location.hash.includes('ss_available_filter')) {
      return;
    }

    // Apply the "In Stock" filter via URL hash
    var currentHash = window.location.hash || '#/';
    if (currentHash === '#/') {
      window.location.hash = '#/filter:ss_available_filter:In%20Stock';
    } else {
      // Append to existing hash
      window.location.hash = currentHash + '/filter:ss_available_filter:In%20Stock';
    }
  }

  // Call immediately on script load (before SearchSpring initializes)
  applyInStockFilter();

  // Customizer card data comes straight from Shopify via the
  // product.card-data alternate template (templates/product.card-data.liquid)
  // - live metafields AND the current featured image - so cards never wait
  // on SearchSpring's index or serve its stale image cache. Cached per
  // handle for the session.
  var cardDataCache = {};
  function fetchCardData(handle) {
    if (!cardDataCache[handle]) {
      cardDataCache[handle] = fetch('/products/' + handle + '?view=card-data')
        .then(function(r) {
          if (!r.ok) throw new Error('card-data ' + r.status);
          return r.json();
        })
        .catch(function() { return null; });
    }
    return cardDataCache[handle];
  }

  // Fill a customizer card's overlay (model line + chips), swatch row, and
  // freshest image from the card-data payload. Idempotent - safe to call
  // once per card after the sync pass built the badge + button.
  function applyLiveCustomizerData(card, data, handle) {
    // Live title - SearchSpring serves its indexed copy until the next
    // feed run, so renames would otherwise lag on the grid
    if (data.title) {
      var titleEl = card.querySelector('.grid-product__title');
      if (titleEl && titleEl.textContent.trim() !== data.title) {
        titleEl.textContent = data.title;
      }
    }

    var mask = card.querySelector('.grid-product__image-mask');

    // Freshest image straight from Shopify - SearchSpring's cached
    // imageUrl 404s when an image is replaced between index runs
    if (mask && data.featured_image) {
      var img = mask.querySelector('img');
      if (img && img.src !== data.featured_image) {
        img.src = data.featured_image;
        img.removeAttribute('srcset');
        img.classList.add('lazyloaded');
        img.classList.remove('lazyload');
      }
    }

    var overlay = card.querySelector('.grid-product__model-logo');
    if (overlay) {
      // Model line: logo file wins, model_name text is the fallback
      if (!overlay.querySelector('img') && !overlay.querySelector('.grid-product__brand-model')) {
        if (data.model_logo) {
          var logoImg = document.createElement('img');
          logoImg.src = data.model_logo;
          logoImg.alt = data.model_name || '';
          logoImg.loading = 'lazy';
          overlay.appendChild(logoImg);
        } else if (data.model_name) {
          var brandModel = document.createElement('span');
          brandModel.className = 'grid-product__brand-model';
          if (data.vendor) {
            var brandSpan = document.createElement('span');
            brandSpan.textContent = data.vendor;
            brandModel.appendChild(brandSpan);
            brandModel.appendChild(document.createTextNode(' '));
          }
          brandModel.appendChild(document.createTextNode(data.model_name));
          overlay.appendChild(brandModel);
        }
      }
      // Build program + turnaround chips (2x2 grid places them via CSS)
      if (!overlay.querySelector('.grid-product__custom-chips') && (data.build_program || data.turnaround)) {
        var chips = document.createElement('div');
        chips.className = 'grid-product__custom-chips';
        if (data.build_program) {
          var buildChip = document.createElement('span');
          buildChip.className = 'custom-chip custom-chip--build';
          buildChip.textContent = data.build_program;
          chips.appendChild(buildChip);
        }
        if (data.turnaround) {
          var timeChip = document.createElement('span');
          timeChip.className = 'custom-chip custom-chip--time';
          timeChip.textContent = data.turnaround;
          chips.appendChild(timeChip);
        }
        overlay.appendChild(chips);
      }
    }

    // Static color dots from the swatch_colors list; when a customizer's
    // options don't suit dots, swatch_note renders text in the same slot
    // (e.g. "10 Styles Available"). Dots win when both are set.
    var swatchNames = (Array.isArray(data.swatch_colors) ? data.swatch_colors : [])
      .map(function(n) { return String(n).trim(); })
      .filter(Boolean);
    if (swatchNames.length < 2 && data.swatch_note && !card.querySelector('.grid-product__swatch-note')) {
      var noteRow = card.querySelector('.grid-product__swatches');
      if (!noteRow) {
        noteRow = document.createElement('div');
        noteRow.className = 'grid-product__swatches ss-swatches-init';
        var noteContent = card.querySelector('.grid-product__content');
        var noteWrap = card.querySelector('.grid-product__customize-wrap');
        if (noteContent && noteWrap) {
          noteContent.insertBefore(noteRow, noteWrap);
        } else if (noteContent) {
          noteContent.appendChild(noteRow);
        }
      }
      noteRow.classList.remove('grid-product__swatches--empty');
      noteRow.removeAttribute('aria-hidden');
      var note = document.createElement('span');
      note.className = 'grid-product__swatch-note';
      note.textContent = data.swatch_note;
      noteRow.appendChild(note);
    }
    // Single curated color: no dot (same rule as variant swatches)
    if (swatchNames.length > 1 && !card.querySelector('.grid-product__swatch--static')) {
      // buildCardSwatches may have left an empty placeholder (customizers
      // have no color variants) - replace it with the metafield dots
      var oldRow = card.querySelector('.grid-product__swatches');
      if (oldRow) oldRow.parentNode.removeChild(oldRow);
      var swRow = document.createElement('div');
      swRow.className = 'grid-product__swatches ss-swatches-init';
      var maxDots = swatchNames.length > 8 ? 7 : 8;
      swatchNames.slice(0, maxDots).forEach(function(name) {
        var dot = document.createElement('span');
        dot.className = 'grid-product__swatch grid-product__swatch--static';
        dot.dataset.color = name;
        dot.title = name;
        swRow.appendChild(dot);
        applySwatchVisual(dot);
      });
      if (swatchNames.length > 8) {
        var moreLink = document.createElement('a');
        moreLink.className = 'grid-product__swatch-more';
        moreLink.href = '/products/' + handle;
        moreLink.textContent = '+' + (swatchNames.length - 7);
        moreLink.setAttribute('aria-label', 'View all ' + swatchNames.length + ' colors');
        swRow.appendChild(moreLink);
      }
      var content = card.querySelector('.grid-product__content');
      var wrap = card.querySelector('.grid-product__customize-wrap');
      if (content && wrap) {
        content.insertBefore(swRow, wrap);
      } else if (content) {
        content.appendChild(swRow);
      }
    }
  }

  function applyCustomizeNowButtons() {
    var cards = document.querySelectorAll('#searchspring-content .grid-product:not(.ss-custom-checked)');
    cards.forEach(function(card) {
      card.classList.add('ss-custom-checked');
      try {
        var scope = angular && angular.element(card).scope();
        if (!scope || !scope.result || !scope.result.tags) return;
        var tags = Array.isArray(scope.result.tags) ? scope.result.tags.join(',') : String(scope.result.tags);
        if (tags.indexOf('THS-Custom') === -1) return;

        // Add class to card - CSS handles hiding quick-add and quick-view
        card.classList.add('grid-product--ths-custom');

        // CUSTOM badge overlaid INSIDE the image box (2x2 grid with the
        // model line + chips that arrive with the live card data). The
        // mask is moved wholesale by addVariantControlsToCard, so children
        // survive the link rebuild.
        var mask = card.querySelector('.grid-product__image-mask');
        if (mask && !card.querySelector('.grid-product__model-logo')) {
          var overlay = document.createElement('div');
          overlay.className = 'grid-product__model-logo';
          var badge = document.createElement('span');
          badge.className = 'ths-custom-badge';
          var wheel = document.createElement('span');
          wheel.className = 'ths-custom-badge__wheel';
          wheel.setAttribute('aria-hidden', 'true');
          badge.appendChild(wheel);
          badge.appendChild(document.createTextNode('Custom'));
          overlay.appendChild(badge);
          mask.appendChild(overlay);
        }

        // Insert Customize Now button before the title/price meta link
        var content = card.querySelector('.grid-product__content');
        var handle = card.dataset.productHandle || '';
        if (content && !card.querySelector('.grid-product__customize-btn')) {
          var btnWrap = document.createElement('div');
          btnWrap.className = 'grid-product__customize-wrap';
          var btn = document.createElement('a');
          btn.href = '/products/' + handle;
          btn.className = 'grid-product__customize-btn';
          btn.textContent = 'Customize Now';
          btnWrap.appendChild(btn);
          // Insert before the meta-link (title/price) so button sits between image and title
          var metaLink = content.querySelector('.grid-product__meta-link');
          if (metaLink) {
            content.insertBefore(btnWrap, metaLink);
          } else {
            content.appendChild(btnWrap);
          }
        }

        // Everything metafield-driven renders from live Shopify data
        if (handle) {
          fetchCardData(handle).then(function(data) {
            if (data) {
              try { applyLiveCustomizerData(card, data, handle); } catch (e2) {}
            }
          });
        }
      } catch (e) {}
    });
  }

  // Replace the price on cards whose product has the custom.custom_price_range
  // metafield (indexed by SearchSpring as mfield_custom_custom_price_range).
  // Custom/customizer products are priced $0 in Shopify, so without this the
  // grid shows $0.00 instead of e.g. "Customize for Price".
  function applyCustomPriceRange() {
    var cards = document.querySelectorAll('#searchspring-content .grid-product:not(.ss-price-range-checked)');
    cards.forEach(function(card) {
      card.classList.add('ss-price-range-checked');
      try {
        var scope = angular && angular.element(card).scope();
        if (!scope || !scope.result) return;
        var rangeText = scope.result.mfield_custom_custom_price_range;
        if (!rangeText) return;
        rangeText = String(rangeText).replace(/\s*CAD\s*/gi, ' ').trim();

        var priceEl = card.querySelector('.grid-product__price');
        if (!priceEl) return;
        priceEl.innerHTML = '<span class="grid-product__price--current">' + rangeText + '</span>';
        // Marker blocks renderCardPrice + the price reformatters from overwriting
        priceEl.classList.add('grid-product__price--custom-range', 'ss-cents-done');
      } catch (e) {}
    });
  }

  function hideSkeletonGrid() {
    var skeleton = document.getElementById('ss-skeleton-grid');
    if (skeleton && !skeleton.classList.contains('ss-hidden')) {
      var products = document.querySelectorAll('#searchspring-content .grid-product');
      if (products.length > 0) {
        skeleton.classList.add('ss-hidden');
      }
    }
  }

  function addInStockToggle() {
    // Don't add if already exists
    if (document.getElementById('ths-instock-toggle')) return;

    var filterBar = document.querySelector('.collection-filter');
    if (!filterBar) return;

    // Default to on: auto-apply in-stock filter if not already in hash
    var isActive = window.location.hash.indexOf('ss_available_filter') !== -1;
    if (!isActive) {
      var currentHash = window.location.hash || '#/';
      if (currentHash === '#/' || currentHash === '#' || currentHash === '') {
        window.location.hash = '#/filter:ss_available_filter:In%20Stock';
      } else {
        window.location.hash = currentHash + '/filter:ss_available_filter:In%20Stock';
      }
      isActive = true;
    }

    // Toggle switch hidden for now (2026-09-11): redundant with the In Stock
    // option shown selected in the filter bar. Default in-stock filter above
    // still applies. Remove this return to bring the switch back.
    return;

    var toggle = document.createElement('label');
    toggle.className = 'ths-instock-toggle ths-toggle-label';
    toggle.id = 'ths-instock-toggle';
    toggle.innerHTML = '<input type="checkbox"' + (isActive ? ' checked' : '') + '>' +
      '<span class="ths-instock-toggle__switch"></span>' +
      '<span>In Stock Only</span>';

    // Insert after filter bar, not inside it
    if (filterBar.parentNode) {
      filterBar.parentNode.insertBefore(toggle, filterBar.nextSibling);
    } else {
      filterBar.appendChild(toggle);
    }

    var checkbox = toggle.querySelector('input');
    checkbox.addEventListener('change', function() {
      var hash = window.location.hash || '#/';
      if (checkbox.checked) {
        // Add in-stock filter
        if (hash === '#/' || hash === '#' || hash === '') {
          window.location.hash = '#/filter:ss_available_filter:In%20Stock';
        } else if (hash.indexOf('ss_available_filter') === -1) {
          window.location.hash = hash + '/filter:ss_available_filter:In%20Stock';
        }
      } else {
        // Remove in-stock filter
        var newHash = hash.replace(/\/filter:ss_available_filter:In%20Stock/g, '');
        if (newHash === '#/' || newHash === '#') newHash = '#/';
        window.location.hash = newHash;
      }
    });

    // Sync toggle state when hash changes (e.g. user clears filters in sidebar)
    window.addEventListener('hashchange', function() {
      var cb = document.querySelector('#ths-instock-toggle input');
      if (cb) {
        cb.checked = window.location.hash.indexOf('ss_available_filter') !== -1;
      }
    });
  }

  function enhanceSearchSpringCards() {
    hideSkeletonGrid();
    applyCustomPriceRange();
    moveDiscountBadges();
    enhanceProductCards();
    applyCustomizeNowButtons();
    applyCardChips();
    applyCardStars();
    updateProductCountDisplay();
    addInStockToggle();
  }

  // Debounce helper to prevent excessive function calls
  function debounce(func, wait) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }

  // Debounced version for observer
  var debouncedEnhance = debounce(enhanceSearchSpringCards, 150);

  // Run on page load
  document.addEventListener('DOMContentLoaded', function() {
    // Apply "In Stock" filter immediately on search pages
    applyInStockFilter();
    // Single delayed run for SearchSpring to render
    setTimeout(enhanceSearchSpringCards, 1500);

    // Native (Liquid) collection grids: style server-rendered swatches now
    // and after every AJAX re-render (filtering/pagination replaces the grid).
    initLiquidSwatches();
    var ajaxContainer = document.getElementById('CollectionAjaxResult');
    if (ajaxContainer) {
      new MutationObserver(debounce(initLiquidSwatches, 150))
        .observe(ajaxContainer, { childList: true, subtree: true });
    }
  });

  // Observe for SearchSpring content changes (pagination, filtering)
  var observer = new MutationObserver(function(mutations) {
    debouncedEnhance();
  });

  // Start observing when SearchSpring container exists
  function startObserver() {
    var container = document.getElementById('searchspring-content');
    if (container) {
      observer.observe(container, { childList: true, subtree: true });
      enhanceSearchSpringCards();
    } else {
      setTimeout(startObserver, 500);
    }
  }

  // Update variant selections based on current filters
  function updateVariantSelections() {
    var cards = document.querySelectorAll('#searchspring-content .grid-product.ss-enhanced');
    var activeFilters = getActiveFilters();

    cards.forEach(function(card) {
      var handle = card.dataset.productHandle;
      var product = productCache[handle];
      if (!product) return;

      var select = card.querySelector('.grid-product__variant-select');
      if (!select) return;

      var availableVariants = product.variants.filter(function(v) {
        return v.available;
      });

      var sortedVariants = availableVariants.slice().sort(function(a, b) {
        return a.title.localeCompare(b.title);
      });

      var matchingVariant = findMatchingVariant(sortedVariants, activeFilters);
      var selectedVariant = matchingVariant || sortedVariants[0];

      if (select.value !== String(selectedVariant.id)) {
        select.value = selectedVariant.id;
        // Trigger change event to update image and button
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // Debounced variant selection update
  var debouncedVariantUpdate = debounce(updateVariantSelections, 300);

  // Re-process cards when filters change (hash change)
  var lastHash = window.location.hash;
  window.addEventListener('hashchange', function() {
    var newHash = window.location.hash;
    if (newHash !== lastHash) {
      lastHash = newHash;
      // Single debounced call handles SearchSpring re-renders
      debouncedVariantUpdate();
    }
  });

  // Also update when clicking on filter elements
  document.addEventListener('click', function(e) {
    var filterEl = e.target.closest('.ss-facet-value, .ss-facet-options a, [class*="facet"], [class*="filter"]');
    if (filterEl) {
      debouncedVariantUpdate();
    }
  });

  startObserver();
})();

// ========================================
// SEARCHSPRING SUGGEST LIMIT BOOST + POPULARITY RE-RANK
// SS catalog.js calls /api/suggest/query?limit=4 by default and its template
// uses ng-repeat="...| limitTo:4". We bump the API limit (XHR + fetch patch)
// AND inject the extra items as DOM siblings since we can't edit the template.
//
// Re-rank (2026-09-16): SearchSpring orders the terms by match type and
// query length, not by how often they are searched, even though every term
// comes back with a 90-day popularity count ("bauer vap" -> x4 (28), stick
// (32), skates (88)...). We capture the suggest response, then reorder
// scope.ac.terms in place: SS's own top suggestion first, the rest by
// popularity, and singular/plural twins ("skate guard" / "skate guards")
// collapsed to the more popular spelling. Angular re-renders from the same
// array, so its first four and our injected extras stay consistent.
// ========================================
(function() {
  'use strict';
  var SUGGEST_LIMIT = 8;
  var EXTRA_FLAG = 'ss-list-option--ths-extra';
  var lastSuggest = null;   // { query, top, pop: { normalizedTerm: count } }
  var schedule = function() {};   // set in init(); re-runs injectExtraTerms

  function normTerm(t) {
    return String(t || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  // Words after dropping punctuation: "off-campus" / "off+campus" -> off campus
  function cleanWords(t) {
    return normTerm(t).replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean);
  }
  // Letters only, trailing s dropped: "skate guards", "skate guard", "off campus",
  // "off campu", "off campu s", "offcampus", "off-campus" all share one key.
  function twinKey(t) {
    var k = cleanWords(t).join('');
    return (k.length > 3 && /s$/.test(k) && !/ss$/.test(k)) ? k.slice(0, -1) : k;
  }
  // A lone "s" word is a split typo ("off campu s"); never let it represent a group
  function isSplitTypo(words) {
    return words.indexOf('s') !== -1;
  }
  // "off camp" is the same word as "off campus", half typed (the SS dictionary
  // logs every keystroke's in-page search on collection pages).
  function isPartialOf(wa, wb) {
    if (wa.length !== wb.length) return false;
    for (var i = 0; i < wa.length - 1; i++) if (wa[i] !== wb[i]) return false;
    var la = wa[wa.length - 1], lb = wb[wb.length - 1];
    return la.length < lb.length && lb.indexOf(la) === 0;
  }
  // Which spelling represents a twin group: SS's top suggestion, else a clean
  // (non-typo, fully typed) one, most searched, then the one with more words
  // ("off campus" over "offcampus"), then SS's original order.
  function betterRep(x, cur) {
    if (x.pop === Infinity) return true;
    if (cur.pop === Infinity) return false;
    if (x.typo !== cur.typo) return !x.typo;
    if (x.partial !== cur.partial) return !x.partial;
    if (x.pop !== cur.pop) return x.pop > cur.pop;
    if (x.words.length !== cur.words.length) return x.words.length > cur.words.length;
    return false;
  }

  function captureSuggest(json) {
    if (!json || typeof json.query !== 'string') return;
    var pop = {};
    var alts = Array.isArray(json.alternatives) ? json.alternatives : [];
    for (var i = 0; i < alts.length; i++) {
      var a = alts[i];
      if (a && a.text) pop[normTerm(a.text)] = typeof a.popularity === 'number' ? a.popularity : 0;
    }
    var top = json.suggested && json.suggested.text ? normTerm(json.suggested.text) : '';
    lastSuggest = { query: json.query, top: top, pop: pop };
    schedule();
  }

  function isMainSuggestUrl(url) {
    return typeof url === 'string' && url.indexOf('/api/suggest/query') !== -1
      && url.indexOf('limit=' + SUGGEST_LIMIT) !== -1;
  }

  // Reorder scope.ac.terms in place. Returns true when the array changed
  // (Angular then re-renders; the caller waits for that render).
  function rerankTerms(scope) {
    var terms = scope.ac.terms;
    if (!lastSuggest || !Array.isArray(terms) || terms.length < 2) return false;
    var known = 0;
    var scored = terms.map(function(t, idx) {
      var n = normTerm(t && t.value);
      var isTop = n && n === lastSuggest.top;
      var p = lastSuggest.pop.hasOwnProperty(n) ? lastSuggest.pop[n] : -1;
      // Count inherited from folded twins on an earlier pass (Angular re-renders
      // trigger a second pass over the already-collapsed array)
      if (t && typeof t.__thsPop === 'number' && t.__thsPop > p) p = t.__thsPop;
      if (isTop || p >= 0) known++;
      var words = cleanWords(n);
      return { t: t, idx: idx, key: twinKey(n), letters: words.join(''), words: words,
               typo: isSplitTypo(words), partial: false, pop: isTop ? Infinity : p };
    });
    // A member whose letters are a strict prefix of a twin's letters is half typed
    scored.forEach(function(x) {
      x.partial = scored.some(function(y) {
        return y !== x && y.key === x.key && y.letters.length > x.letters.length && y.letters.indexOf(x.letters) === 0;
      });
    });
    // Different query than the captured response: leave SS's order alone
    if (known < Math.ceil(terms.length / 2)) return false;

    // 1) Collapse twins into one representative, ranked by the group's best count
    var byKey = {};
    scored.forEach(function(x) {
      if (!x.key) return;
      var cur = byKey[x.key];
      if (!cur) { byKey[x.key] = x; return; }
      if (betterRep(x, cur)) { x.pop = Math.max(x.pop, cur.pop); byKey[x.key] = x; }
      else cur.pop = Math.max(cur.pop, x.pop);
    });
    var kept = scored.filter(function(x) { return x.key && byKey[x.key] === x; });
    // 2) Drop half-typed versions of a more popular term ("off camp" vs "off campus")
    //    and split typos that have no clean twin to fold into
    kept = kept.filter(function(x) {
      if (x.pop === Infinity) return true;
      if (x.typo) return false;
      for (var i = 0; i < kept.length; i++) {
        var y = kept[i];
        if (y !== x && y.pop > x.pop && isPartialOf(x.words, y.words)) return false;
      }
      return true;
    });
    kept.sort(function(a, b) { return (b.pop - a.pop) || (a.idx - b.idx); });
    kept.forEach(function(x) { if (x.pop !== Infinity && x.t) x.t.__thsPop = x.pop; });

    var changed = kept.length !== terms.length;
    for (var i = 0; !changed && i < kept.length; i++) if (kept[i].t !== terms[i]) changed = true;
    if (!changed) return false;

    terms.length = 0;
    kept.forEach(function(x, i) { x.t.active = i === 0; terms.push(x.t); });
    try { scope.$applyAsync ? scope.$applyAsync() : scope.$evalAsync(); } catch (e) {}
    return true;
  }

  function bump(url) {
    if (typeof url !== 'string') return url;
    // 1) Bump suggest/query limit so left-rail terms have more options
    if (url.indexOf('/api/suggest/query') !== -1) {
      return url.replace(/([?&])limit=4\b/, '$1limit=' + SUGGEST_LIMIT);
    }
    // 2) Force In-Stock-only on autocomplete results (background filter)
    if (url.indexOf('/api/search/autocomplete.json') !== -1
        && url.indexOf('bgfilter.ss_available_filter') === -1) {
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return url + sep + 'bgfilter.ss_available_filter=' + encodeURIComponent('In Stock');
    }
    return url;
  }

  if (window.XMLHttpRequest && XMLHttpRequest.prototype && XMLHttpRequest.prototype.open) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      var args = Array.prototype.slice.call(arguments);
      args[1] = bump(url);
      if (isMainSuggestUrl(args[1])) {
        // Registered before SS's own handler, so the popularity map exists
        // by the time SS renders the terms.
        this.addEventListener('load', function() {
          try { captureSuggest(JSON.parse(this.responseText)); } catch (e) {}
        });
      }
      return origOpen.apply(this, args);
    };
  }

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function(input, init) {
      if (typeof input === 'string') {
        var bumped = bump(input);
        var p = origFetch.call(this, bumped, init);
        if (isMainSuggestUrl(bumped)) {
          p = p.then(function(res) {
            try { res.clone().json().then(captureSuggest).catch(function() {}); } catch (e) {}
            return res;
          });
        }
        return p;
      }
      return origFetch.apply(this, arguments);
    };
  }

  function injectExtraTerms() {
    if (typeof angular === 'undefined') return;
    var containers = document.querySelectorAll('[ss-autocomplete] .ss-ac-container');
    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      if (container.offsetWidth === 0) continue;
      var list = container.querySelector('.ss-ac-terms .ss-list');
      if (!list) continue;

      var scope;
      try { scope = angular.element(container).scope(); } catch (e) { continue; }
      if (!scope || !scope.ac || !Array.isArray(scope.ac.terms)) continue;

      var allTerms = scope.ac.terms;
      // Remove our previously injected extras (we re-render every cycle)
      var oldExtras = list.querySelectorAll('.' + EXTRA_FLAG);
      for (var j = 0; j < oldExtras.length; j++) oldExtras[j].remove();

      // Popularity re-rank; when it changes the array, Angular re-renders and
      // the observer brings us back here to append the extras in new order.
      if (rerankTerms(scope)) continue;

      if (allTerms.length <= 4) continue;

      // Append items 4..N as new DOM siblings, mimicking SS's template
      for (var k = 4; k < allTerms.length; k++) {
        var t = allTerms[k];
        if (!t || !t.value) continue;
        var div = document.createElement('div');
        div.className = 'ss-list-option ' + EXTRA_FLAG;
        var a = document.createElement('a');
        a.className = 'ss-list-link';
        a.href = t.url || ('/collections/shop?q=' + encodeURIComponent(t.value));
        // term.label may contain <em> highlights — trust SS's HTML
        a.innerHTML = t.label || t.value;
        // Defensive: SS's Angular may swallow click events on .ss-list-link.
        // Force-navigate so our injected items always work.
        (function(href) {
          a.addEventListener('click', function(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            window.location.href = href;
          }, true);
        })(a.href);
        div.appendChild(a);
        list.appendChild(div);
      }
    }
  }

  // Body-wide observers are expensive on mobile; the autocomplete only exists
  // after the shopper touches a search control, so arm them on that intent.
  function onSearchIntent(fn) {
    var armed = false;
    function isSearchTarget(t) {
      return !!(t && t.closest && t.closest('input[type="search"], .js-search-header, .site-header__search-btn, form[action*="/search"], [ss-autocomplete]'));
    }
    function handler(e) {
      if (armed || !isSearchTarget(e.target)) return;
      armed = true;
      ['focusin', 'pointerover', 'touchstart', 'click'].forEach(function (ev) { document.removeEventListener(ev, handler, true); });
      fn();
    }
    ['focusin', 'pointerover', 'touchstart', 'click'].forEach(function (ev) { document.addEventListener(ev, handler, { passive: true, capture: true }); });
  }

  function init() {
    var pending = null;
    schedule = function() {
      if (pending) return;
      pending = setTimeout(function() {
        pending = null;
        injectExtraTerms();
      }, 80);
    };
    var observer = new MutationObserver(schedule);
    onSearchIntent(function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ========================================
// SEARCHSPRING AUTOCOMPLETE - RELIABLE LINK TAPS ON TOUCH DEVICES
// Reported 2026-09-15: on phones, tapping "See N results for ..." in the
// autocomplete did nothing. Two failure modes this guards against:
//  1) iOS Safari: the tap blurs the search input, the keyboard closes and the
//     page re-lays out between touchend and the synthetic click, so Safari
//     drops the click entirely (the fixed-position dropdown shifts under the
//     finger). We navigate ourselves if no click arrives shortly after a
//     clean tap (no movement) on a dropdown link.
//  2) On SearchSpring-controlled pages (/collections/shop, collection pages)
//     SS intercepts same-path links and does an in-page pushState re-search
//     instead of loading the results page. For the "See results" link we
//     always force a real navigation so the results page opens.
// ========================================
(function() {
  'use strict';

  var LINK_SEL = '[ss-autocomplete] a[href]';
  var SEE_MORE_SEL = '.ss-ac-see-more-link';
  var TAP_MOVE_PX = 12;
  var TAP_MAX_MS = 800;
  var CLICK_GRACE_MS = 400;

  var navigating = false;
  var pending = null;   // { a, x, y, t }
  var fallbackTimer = null;

  function go(href) {
    if (navigating || !href || /^javascript:/i.test(href)) return;
    navigating = true;
    window.location.assign(href);
  }

  function linkFrom(target) {
    return target && target.closest ? target.closest(LINK_SEL) : null;
  }

  // "See N results" always does a full navigation (bypasses SS same-path pushState)
  document.addEventListener('click', function(evt) {
    var a = linkFrom(evt.target);
    if (!a) return;
    if (fallbackTimer) { clearTimeout(fallbackTimer); fallbackTimer = null; }
    if (a.matches(SEE_MORE_SEL)) {
      evt.preventDefault();
      evt.stopPropagation();
      go(a.href);
    }
  }, true);

  document.addEventListener('touchstart', function(evt) {
    var a = linkFrom(evt.target);
    if (!a || !evt.touches || evt.touches.length !== 1) { pending = null; return; }
    var t = evt.touches[0];
    pending = { a: a, x: t.clientX, y: t.clientY, t: Date.now() };
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function(evt) {
    if (!pending || !evt.touches || !evt.touches[0]) return;
    var t = evt.touches[0];
    if (Math.abs(t.clientX - pending.x) > TAP_MOVE_PX || Math.abs(t.clientY - pending.y) > TAP_MOVE_PX) {
      pending = null; // it's a scroll, not a tap
    }
  }, { passive: true, capture: true });

  document.addEventListener('touchcancel', function() { pending = null; }, { passive: true, capture: true });

  document.addEventListener('touchend', function(evt) {
    if (!pending) return;
    var p = pending;
    pending = null;
    if (Date.now() - p.t > TAP_MAX_MS) return;
    var a = linkFrom(evt.target);
    if (a !== p.a) return;
    var href = a.href;
    // "See N results": nothing else needs the click (no tracking, ng-click only
    // hides the dropdown), so navigate on the clean tap itself. iOS Safari can
    // treat a first tap as hover and never fire click; don't depend on it.
    if (a.matches(SEE_MORE_SEL)) { go(href); return; }
    // Other links (products/terms): let the browser's own click happen if it
    // does (keeps SearchSpring click tracking); navigate ourselves if it never arrives.
    if (fallbackTimer) clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(function() {
      fallbackTimer = null;
      if (!navigating && document.contains(a)) go(href);
    }, CLICK_GRACE_MS);
  }, { passive: true, capture: true });
})();

// ========================================
// SEARCHSPRING AUTOCOMPLETE - MOBILE SEARCH TAKEOVER (2026-09-16)
// Companion to the "MOBILE SEARCH TAKEOVER" block in custom.css. On phones
// the dropdown becomes a full-height panel with "See N results" pinned at
// the bottom. Three things CSS can't do on its own:
//  1) Size the panel to the *visible* viewport. iOS never shrinks 100vh/100dvh
//     for the on-screen keyboard; only window.visualViewport knows where the
//     keyboard's top edge is. We write --ths-ac-top / --ths-ac-height on the
//     panel whenever it opens or the visual viewport changes.
//  2) Drop the keyboard when the shopper starts scrolling the panel (Amazon /
//     Google behaviour) so the full list is visible. Blurring the input does
//     NOT close the SearchSpring dropdown (verified 2026-09-16).
//  3) Give the takeover a way out: SS never closes the dropdown on touch
//     devices (no outside-tap dismiss), so we add a Cancel button beside the
//     input that hides the dropdown via SS's own scope.
// Desktop (>1105px) is untouched.
// ========================================
(function() {
  'use strict';

  var MOBILE_MQ = '(max-width: 1105px)';
  var mql = window.matchMedia ? window.matchMedia(MOBILE_MQ) : null;
  var INPUT_SEL = '.header-item--search-nested .nested-search-input';
  var HEADER_SEL = '.header-sticky-wrapper';
  var CANCEL_CLASS = 'ths-ac-cancel';
  var SCROLL_BLUR_PX = 10;

  function isMobile() {
    return mql ? mql.matches : window.innerWidth <= 1105;
  }

  function openPanel() {
    var panels = document.querySelectorAll('[ss-autocomplete]');
    for (var i = 0; i < panels.length; i++) {
      if (!panels[i].classList.contains('ng-hide') && panels[i].offsetWidth) return panels[i];
    }
    // Empty-state panel (recent + trending) uses the same sizing
    var empty = document.querySelector('.ths-ac-empty:not([hidden])');
    return empty && empty.offsetWidth ? empty : null;
  }

  // --- 1) size the panel to the visible viewport -------------------------
  var raf = null;
  function scheduleSize() {
    if (raf) return;
    raf = window.requestAnimationFrame(function() { raf = null; size(); });
  }

  function size() {
    if (!isMobile()) return;
    var panel = openPanel();
    if (!panel) return;
    var header = document.querySelector(HEADER_SEL);
    var vv = window.visualViewport;
    // Layout-viewport coordinates throughout: fixed elements and
    // getBoundingClientRect() both use them; the visual viewport's bottom edge
    // is offsetTop + height in the same space.
    var top = header ? Math.round(header.getBoundingClientRect().bottom) : 70;
    if (top < 0 || top > 200) top = 70;
    var bottom = vv ? (vv.offsetTop + vv.height) : window.innerHeight;
    var height = Math.max(120, Math.round(bottom - top));
    panel.style.setProperty('--ths-ac-top', top + 'px');
    panel.style.setProperty('--ths-ac-height', height + 'px');
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleSize);
    window.visualViewport.addEventListener('scroll', scheduleSize);
  }
  window.addEventListener('resize', scheduleSize);
  window.addEventListener('orientationchange', scheduleSize);
  document.addEventListener('focusin', function(evt) {
    if (evt.target && evt.target.matches && evt.target.matches(INPUT_SEL)) scheduleSize();
  });

  // Re-measure when SearchSpring toggles the dropdown (ng-hide class flips).
  // Observing only the header subtree keeps this cheap.
  function observe() {
    var root = document.querySelector(HEADER_SEL) || document.body;
    if (!root || !window.MutationObserver) return;
    new MutationObserver(function(muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (muts[i].type === 'childList' || (t.hasAttribute && (t.hasAttribute('ss-autocomplete') || t.classList.contains('ths-ac-empty')))) {
          scheduleSize();
          return;
        }
      }
    }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden'] });
  }

  // --- 2) scrolling the panel dismisses the keyboard ----------------------
  var touchStartY = null;
  document.addEventListener('touchstart', function(evt) {
    touchStartY = null;
    if (!isMobile() || !evt.touches || evt.touches.length !== 1) return;
    var t = evt.target;
    if (t && t.closest && t.closest('[ss-autocomplete]')) touchStartY = evt.touches[0].clientY;
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function(evt) {
    if (touchStartY === null || !evt.touches || !evt.touches[0]) return;
    if (Math.abs(evt.touches[0].clientY - touchStartY) < SCROLL_BLUR_PX) return;
    touchStartY = null;
    var active = document.activeElement;
    if (active && active.matches && active.matches(INPUT_SEL)) active.blur();
  }, { passive: true, capture: true });

  // --- 2b) tapping the box brings the keyboard back ------------------------
  // iOS: the keyboard's dismiss arrow hides the keyboard but leaves the input
  // focused, and a tap on an already-focused input does not reliably reopen
  // it (reported 2026-09-16: type "ftw", hide keyboard, tap box -> nothing).
  // A focus() call inside the tap gesture is user-initiated, so iOS shows the
  // keyboard. Only when no keyboard is up: with one showing, the visual
  // viewport is much shorter than the layout viewport.
  var inputTouch = null;
  document.addEventListener('touchstart', function(evt) {
    inputTouch = null;
    if (!isMobile() || !evt.touches || evt.touches.length !== 1) return;
    var t = evt.target;
    if (t && t.matches && t.matches(INPUT_SEL)) inputTouch = { el: t, x: evt.touches[0].clientX, y: evt.touches[0].clientY, t: Date.now() };
  }, { passive: true, capture: true });
  document.addEventListener('touchmove', function(evt) {
    if (!inputTouch || !evt.touches || !evt.touches[0]) return;
    if (Math.abs(evt.touches[0].clientX - inputTouch.x) > 12 || Math.abs(evt.touches[0].clientY - inputTouch.y) > 12) inputTouch = null;
  }, { passive: true, capture: true });
  document.addEventListener('touchend', function(evt) {
    if (!inputTouch) return;
    var it = inputTouch;
    inputTouch = null;
    if (Date.now() - it.t > 800 || evt.target !== it.el) return;
    var vv = window.visualViewport;
    var keyboardUp = vv && vv.height < window.innerHeight - 100;
    if (keyboardUp) return;
    if (document.activeElement === it.el) it.el.blur();
    it.el.focus();
  }, { passive: true, capture: true });

  // --- 3) Cancel button ----------------------------------------------------
  function hideDropdown() {
    if (window.__thsSearchEmptyState) window.__thsSearchEmptyState.hideAll();
    var panel = openPanel();
    if (!panel || !panel.hasAttribute('ss-autocomplete')) return;
    var input = document.querySelector(INPUT_SEL);
    if (input && document.activeElement === input) input.blur();
    var container = panel.querySelector('.ss-ac-container') || panel;
    var scope = null;
    try { if (window.angular) scope = window.angular.element(container).scope(); } catch (e) {}
    if (scope && scope.ac) {
      scope.ac.visible = false;
      try { scope.$applyAsync ? scope.$applyAsync() : scope.$evalAsync(); } catch (e) {}
    }
    // Belt and braces: hide immediately even if Angular is slow to digest.
    panel.classList.add('ng-hide');
  }

  function addCancel() {
    var input = document.querySelector(INPUT_SEL);
    if (!input) return;
    var host = input.closest('.header-item--search-nested');
    if (!host || host.querySelector('.' + CANCEL_CLASS)) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = CANCEL_CLASS;
    btn.textContent = 'Cancel';
    btn.setAttribute('aria-label', 'Close search suggestions');
    // iOS Safari: while the keyboard is up, a tap on Cancel blurs the input,
    // the keyboard closes and the page re-lays out between touchend and the
    // synthetic click, so the click never arrives (reported 2026-09-16, same
    // failure as the "See N results" link). Act on a clean touch directly and
    // swallow the click that may follow; mouse/keyboard still use click.
    var touch = null;
    btn.addEventListener('touchstart', function(evt) {
      touch = evt.touches && evt.touches.length === 1
        ? { x: evt.touches[0].clientX, y: evt.touches[0].clientY, t: Date.now() } : null;
    }, { passive: true });
    btn.addEventListener('touchmove', function(evt) {
      if (!touch || !evt.touches || !evt.touches[0]) return;
      if (Math.abs(evt.touches[0].clientX - touch.x) > 12 || Math.abs(evt.touches[0].clientY - touch.y) > 12) touch = null;
    }, { passive: true });
    btn.addEventListener('touchcancel', function() { touch = null; }, { passive: true });
    btn.addEventListener('touchend', function(evt) {
      if (!touch) return;
      var quick = Date.now() - touch.t < 800;
      touch = null;
      if (!quick) return;
      evt.preventDefault();   // no synthetic click, no focus juggling
      hideDropdown();
    });
    btn.addEventListener('click', function(evt) {
      evt.preventDefault();
      hideDropdown();
    });
    host.appendChild(btn);
  }

  function init() {
    addCancel();
    observe();
    scheduleSize();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

// ========================================
// SEARCH EMPTY STATE: RECENT SEARCHES + TRENDING (2026-09-16)
// SearchSpring shows nothing until the shopper types. Amazon-style empty
// state: focus the search box with no query -> panel with the shopper's
// recent searches (localStorage, recorded from the results page URL) and
// SearchSpring's trending queries (/api/suggest/trending, cached per
// session). Hidden as soon as there is a query (the SS dropdown takes over),
// on Cancel (mobile), on the modal close button / Escape / outside click
// (desktop). CSS: ".ths-ac-empty" block in custom.css; the panel is sized on
// phones by the MOBILE SEARCH TAKEOVER block (it treats it like [ss-autocomplete]).
// ========================================
(function() {
  'use strict';

  var INPUT_SEL = 'input.site-header__search-input';
  var RESULTS_PATH = '/collections/shop';
  var LS_KEY = 'ths_recent_searches';
  var SS_KEY = 'ths_trending_v1';
  var MAX_RECENT = 6;
  var MAX_TRENDING = 10;   // desktop chip row; custom.css hides chips 7+ on phones
  var TRENDING_URL = 'https://ei8rrj.a.searchspring.io/api/suggest/trending?siteId=ei8rrj&limit=12';
  var TRENDING_TTL_MS = 60 * 60 * 1000;

  // --- storage helpers (every access guarded: private mode / disabled) ---
  function lsGet(store, key) {
    try { var v = store.getItem(key); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function lsSet(store, key, val) {
    try { store.setItem(key, JSON.stringify(val)); } catch (e) {}
  }

  function normalize(q) {
    return String(q || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  function resultsUrl(q) {
    return RESULTS_PATH + '?q=' + encodeURIComponent(q);
  }

  // --- recent searches -----------------------------------------------------
  function getRecent() {
    var list = lsGet(window.localStorage, LS_KEY);
    return Array.isArray(list) ? list.filter(function(s) { return typeof s === 'string' && s; }) : [];
  }
  function addRecent(q) {
    q = normalize(q);
    if (!q || q.length > 60) return;
    var list = getRecent().filter(function(s) { return s !== q; });
    list.unshift(q);
    lsSet(window.localStorage, LS_KEY, list.slice(0, MAX_RECENT));
  }
  function clearRecent() {
    try { window.localStorage.removeItem(LS_KEY); } catch (e) {}
  }
  function recordFromUrl() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (path !== RESULTS_PATH && path !== '/search') return;
    var m = window.location.search.match(/[?&]q=([^&]*)/);
    if (!m) return;
    var q;
    try { q = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return; }
    addRecent(q.replace(/\*/g, ''));
  }

  // --- trending ------------------------------------------------------------
  var trendingCache = null;   // array of strings, or null until loaded
  var trendingPromise = null;

  function dedupeTrending(queries) {
    // The feed contains split-typo duplicates ("off campu s" / "off campus");
    // keep one per letters-only key, preferring the version with fewer words.
    var byKey = {};
    var order = [];
    queries.forEach(function(entry) {
      var q = normalize(entry && entry.searchQuery);
      if (!q || q.length < 2) return;
      var key = q.replace(/[^a-z0-9]/g, '');
      if (!key) return;
      if (!byKey[key]) { byKey[key] = q; order.push(key); return; }
      if (q.split(' ').length < byKey[key].split(' ').length) byKey[key] = q;
    });
    return order.map(function(k) { return byKey[k]; }).slice(0, MAX_TRENDING);
  }

  // Merchandiser-curated list wins (shop metafield custom.trending_searches,
  // passed in via theme.liquid as theme.trendingSearches). Falls back to
  // SearchSpring's volume-based feed only when the list is empty.
  function curatedTrending() {
    var list = window.theme && window.theme.trendingSearches;
    if (!Array.isArray(list)) return null;
    var seen = {};
    var out = [];
    list.forEach(function(q) {
      // Shown exactly as the merchandiser typed it (casing kept); dedupe case-insensitively
      q = String(q || '').replace(/\s+/g, ' ').trim();
      var key = q.toLowerCase();
      if (!q || seen[key]) return;
      seen[key] = true;
      out.push(q);
    });
    return out.length ? out.slice(0, MAX_TRENDING) : null;
  }

  function loadTrending() {
    if (trendingCache) return Promise.resolve(trendingCache);
    var curated = curatedTrending();
    if (curated) { trendingCache = curated; return Promise.resolve(curated); }
    var cached = lsGet(window.sessionStorage, SS_KEY);
    if (cached && cached.t && Date.now() - cached.t < TRENDING_TTL_MS && Array.isArray(cached.list)) {
      trendingCache = cached.list;
      return Promise.resolve(trendingCache);
    }
    if (trendingPromise) return trendingPromise;
    if (!window.fetch) return Promise.resolve([]);
    trendingPromise = window.fetch(TRENDING_URL).then(function(r) { return r.json(); }).then(function(j) {
      var list = dedupeTrending((j && j.trending && j.trending.queries) || []);
      trendingCache = list;
      lsSet(window.sessionStorage, SS_KEY, { t: Date.now(), list: list });
      return list;
    }).catch(function() { trendingPromise = null; return []; });
    return trendingPromise;
  }

  // --- panel ---------------------------------------------------------------
  var panels = [];  // { input, el }

  function escapeHTML(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }
  function linksHTML(list) {
    return list.map(function(q) {
      return '<a class="ths-ac-empty__link" href="' + escapeHTML(resultsUrl(q)) + '">' + escapeHTML(q) + '</a>';
    }).join('');
  }

  function render(p) {
    var recent = getRecent();
    var trending = trendingCache || [];
    var recentSec = p.el.querySelector('.ths-ac-empty__section--recent');
    var trendSec = p.el.querySelector('.ths-ac-empty__section--trending');
    recentSec.querySelector('.ths-ac-empty__links').innerHTML = linksHTML(recent);
    recentSec.hidden = recent.length === 0;
    trendSec.querySelector('.ths-ac-empty__links').innerHTML = linksHTML(trending);
    trendSec.hidden = trending.length === 0;
    return recent.length + trending.length > 0;
  }

  function panelFor(input) {
    for (var i = 0; i < panels.length; i++) if (panels[i].input === input) return panels[i];
    var host = input.form ? input.form.parentElement : input.parentElement;
    if (!host) return null;
    var el = document.createElement('div');
    el.className = 'ths-ac-empty';
    el.hidden = true;
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'Search suggestions');
    el.innerHTML =
      '<div class="ths-ac-empty__inner">' +
        '<div class="ths-ac-empty__section ths-ac-empty__section--recent" hidden>' +
          '<h4 class="ths-ac-empty__title">Recent searches <button type="button" class="ths-ac-empty__clear">Clear</button></h4>' +
          '<div class="ths-ac-empty__links"></div>' +
        '</div>' +
        '<div class="ths-ac-empty__section ths-ac-empty__section--trending" hidden>' +
          '<h4 class="ths-ac-empty__title">Trending searches</h4>' +
          '<div class="ths-ac-empty__links"></div>' +
        '</div>' +
      '</div>';
    el.querySelector('.ths-ac-empty__clear').addEventListener('click', function(evt) {
      evt.preventDefault();
      clearRecent();
      if (!render(p)) hide(p);
      input.focus();
    });
    // Keep focus in the input while interacting with the panel (desktop mouse).
    el.addEventListener('mousedown', function(evt) {
      if (!evt.target.closest('a, button')) evt.preventDefault();
    });
    host.appendChild(el);
    var p = { input: input, el: el };
    panels.push(p);
    return p;
  }

  function show(p) {
    if (!p) return;
    if (!render(p)) { hide(p); return; }
    p.el.hidden = false;
  }
  function hide(p) {
    if (p) p.el.hidden = true;
  }
  function hideAll() {
    panels.forEach(hide);
  }

  function maybeShow(input) {
    if (!input.matches(INPUT_SEL) || !input.offsetWidth) return;
    var p = panelFor(input);
    if (!p) return;
    if (normalize(input.value)) { hide(p); return; }
    show(p);
    if (!trendingCache) loadTrending().then(function() {
      if (document.activeElement === input && !normalize(input.value)) show(p);
    });
  }

  document.addEventListener('focusin', function(evt) {
    var t = evt.target;
    if (t && t.matches && t.matches(INPUT_SEL)) maybeShow(t);
  });
  document.addEventListener('input', function(evt) {
    var t = evt.target;
    if (!t || !t.matches || !t.matches(INPUT_SEL)) return;
    if (normalize(t.value)) hide(panelFor(t)); else maybeShow(t);
  });
  document.addEventListener('keydown', function(evt) {
    if (evt.key === 'Escape') hideAll();
  });
  document.addEventListener('click', function(evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    // Desktop modal close, mobile Cancel, or a click outside the search UI
    if (t.closest('.js-search-header-close, .ths-ac-cancel')) { hideAll(); return; }
    if (!t.closest('.ths-ac-empty, ' + INPUT_SEL + ', .site-header__search, .header-item--search-nested')) hideAll();
  }, true);

  // Expose for the mobile takeover block (Cancel button) and debugging.
  window.__thsSearchEmptyState = { hideAll: hideAll, addRecent: addRecent };

  recordFromUrl();
})();

// ========================================
// SEARCHSPRING AUTOCOMPLETE PRICE RESTRUCTURING
// Matches collection page price layout (superscript cents, CAD label,
// rounded MSRP, % off badge, Save $X) for the search autocomplete cards.
//
// Important: SS uses Angular ng-binding to update price text on each new
// product render. We must NOT replace the watched text nodes — instead we
// hide the originals and render a sibling formatted block that we re-build
// from the originals' current text on every mutation.
// ========================================
(function() {
  'use strict';

  var FORMATTED_CLASS = 'ss-ac-formatted-price';

  function escapeHTML(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function handleFromPriceEl(priceEl) {
    var link = priceEl.closest('a[href*="/products/"]') ||
               (priceEl.closest('.ss-ac-item') && priceEl.closest('.ss-ac-item').querySelector('a[href*="/products/"]'));
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // Format $X<sup>YY</sup> from a cents integer (Shopify-style price). When a
  // higher compare-at price is known, append it struck through plus a % off
  // pill (rounded like the collection cards) so sale items keep their context.
  function formatCentsHTML(priceCents, compareCents) {
    var dollars = Math.floor(priceCents / 100);
    var centsNum = priceCents % 100;
    var cents = centsNum < 10 ? '0' + centsNum : '' + centsNum;
    var dollarsStr = '$' + dollars.toLocaleString('en-US');
    var onSale = compareCents > priceCents;
    var html = '<span class="grid-product__price--current' + (onSale ? ' on-sale' : '') + '">'
      + escapeHTML(dollarsStr)
      + '<sup class="price-cents">' + cents + '</sup>'
      + '</span>';
    if (onSale) {
      var pctOff = Math.round((compareCents - priceCents) / compareCents * 100);
      html += '<span class="ss-ac-price-was">$' + Math.ceil(compareCents / 100).toLocaleString('en-US') + '</span>';
      if (pctOff >= 10) html += '<span class="ss-ac-price-pct">' + pctOff + '% off</span>';
    }
    return html;
  }

  function buildHTML(priceEl) {
    // Prefer live Shopify price if a fetch has resolved for this item.
    if (priceEl.dataset.thsLivePrice) {
      var livePrice = parseInt(priceEl.dataset.thsLivePrice, 10);
      var liveCompare = priceEl.dataset.thsLiveCompare ? parseInt(priceEl.dataset.thsLiveCompare, 10) : 0;
      if (!isNaN(livePrice)) {
        return formatCentsHTML(livePrice, isNaN(liveCompare) ? 0 : liveCompare);
      }
    }

    // Fallback: mirror SS's indexed price text (legacy behavior).
    var msrpEl = priceEl.querySelector('.ss-ac-item-msrp');
    var regularEl = priceEl.querySelector('.ss-ac-item-regular');
    if (!regularEl) return null;

    var regText = regularEl.textContent.trim();
    var regMatch = regText.match(/^(\$[\d,]+)\.(\d{2})/);
    if (!regMatch) return null;

    var dollars = regMatch[1];
    var cents = regMatch[2];
    var priceCents = Math.round(parseFloat(dollars.replace(/[$,]/g, '')) * 100) + parseInt(cents, 10);

    // SS's indexed MSRP (compare-at) gives the sale context until live data lands
    var compareCents = 0;
    if (msrpEl) {
      var msrpMatch = msrpEl.textContent.trim().match(/\$([\d,]+)\.(\d{2})/);
      if (msrpMatch) {
        compareCents = Math.round(parseFloat(msrpMatch[1].replace(/,/g, '')) * 100) + parseInt(msrpMatch[2], 10);
      }
    }

    return formatCentsHTML(priceCents, compareCents);
  }

  function ensureLivePrice(priceEl) {
    if (typeof window.__thsFetchProduct !== 'function') return;
    var handle = handleFromPriceEl(priceEl);
    if (!handle) return;
    // Skip if we already have live data for this exact handle.
    // Re-fetches when DOM is reused for a different product (typing changes results).
    if (priceEl.dataset.thsLiveHandle === handle) return;
    // Clear stale live data so buildHTML falls back to SS text until our fetch resolves.
    delete priceEl.dataset.thsLivePrice;
    delete priceEl.dataset.thsLiveCompare;
    priceEl.dataset.thsLiveHandle = handle; // claim before fetch to avoid duplicates

    window.__thsFetchProduct(handle).then(function(product) {
      if (priceEl.dataset.thsLiveHandle !== handle) return; // item recycled mid-flight
      var variant = (product.variants && product.variants.find(function(v) { return v.available; })) ||
                    (product.variants && product.variants[0]);
      if (!variant) return;
      priceEl.dataset.thsLivePrice = variant.price;
      priceEl.dataset.thsLiveCompare = variant.compare_at_price || '';
      renderPrice(priceEl); // re-render with live values
    }).catch(function() {
      // Allow retry on next mutation
      delete priceEl.dataset.thsLiveHandle;
    });
  }

  function renderPrice(priceEl) {
    var html = buildHTML(priceEl);
    if (!html) return;

    // Hide the original SS spans (Angular keeps them updated; we mirror them).
    var originals = priceEl.querySelectorAll('.ss-ac-item-regular, .ss-ac-item-msrp');
    for (var i = 0; i < originals.length; i++) {
      if (originals[i].style.display !== 'none') {
        originals[i].style.display = 'none';
      }
    }

    var formatted = priceEl.querySelector('.' + FORMATTED_CLASS);
    if (!formatted) {
      formatted = document.createElement('span');
      formatted.className = FORMATTED_CLASS;
      priceEl.appendChild(formatted);
    }
    if (formatted.innerHTML !== html) {
      formatted.innerHTML = html;
    }

    // Add layout class to the price container for CSS hooks
    if (!priceEl.classList.contains('grid-product__price')) {
      priceEl.classList.add('grid-product__price', 'ss-price-restructured');
    }

    // Kick off live-price fetch (if handle present and not already in flight).
    ensureLivePrice(priceEl);
  }

  // Catalog titles mix "Foo - 2024" and "Foo (2024)"; the dropdown shows ten
  // of them side by side, so normalise the year suffix to the bracket form
  // here (display only; Angular writes the raw title again when the product
  // in that slot changes, which the observer catches again).
  // Edit the TEXT NODE in place. Angular's {{ }} interpolation keeps a
  // reference to the original text node and writes every later name into it;
  // assigning textContent replaced that node, so Angular kept updating a
  // detached one and the visible title froze while the image/link/price moved
  // on to the next product (2026-10-22: "bauer x" -> "bauer x-lp 2.0" showed
  // X Series shin-guard titles over X-LP skate cards).
  function normalizeName(nameEl) {
    for (var n = nameEl.firstChild; n; n = n.nextSibling) {
      if (n.nodeType !== 3) continue;
      var raw = n.nodeValue;
      var fixed = raw.replace(/\s+[-–]\s+(20\d\d)\s*$/, ' ($1)');
      if (fixed !== raw) n.nodeValue = fixed;
    }
  }

  function processAll() {
    var prices = document.querySelectorAll('.ss-ac-item-price');
    prices.forEach(renderPrice);
    var names = document.querySelectorAll('[ss-autocomplete] .ss-ac-item-name');
    names.forEach(normalizeName);
  }

  function onSearchIntent(fn) {
    var armed = false;
    function isSearchTarget(t) {
      return !!(t && t.closest && t.closest('input[type="search"], .js-search-header, .site-header__search-btn, form[action*="/search"], [ss-autocomplete]'));
    }
    function handler(e) {
      if (armed || !isSearchTarget(e.target)) return;
      armed = true;
      ['focusin', 'pointerover', 'touchstart', 'click'].forEach(function (ev) { document.removeEventListener(ev, handler, true); });
      fn();
    }
    ['focusin', 'pointerover', 'touchstart', 'click'].forEach(function (ev) { document.addEventListener(ev, handler, { passive: true, capture: true }); });
  }

  function init() {
    var pending = null;
    var observer = new MutationObserver(function() {
      if (pending) return;
      pending = setTimeout(function() {
        pending = null;
        processAll();
      }, 50);
    });
    // Body-wide + characterData is costly on mobile: arm only once the shopper
    // touches a search control (the autocomplete can't exist before that).
    onSearchIntent(function () {
      processAll();
      // characterData catches Angular's price text updates; childList catches re-renders
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ========================================
// SEARCHSPRING SPELL-CORRECTION INDICATOR
// "Did you mean X?" banner when SS auto-corrects the typed query
// ========================================
(function() {
  'use strict';

  var SS_SITE_ID = 'ei8rrj';
  var DEBOUNCE_MS = 250;
  var MIN_LEN = 3;

  var fetchTimer = null;
  var lastQuery = null;
  var bannerEl = null;
  var queryCache = {};

  function escapeHTML(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function ensureBanner() {
    if (bannerEl) return bannerEl;
    bannerEl = document.createElement('div');
    bannerEl.className = 'ss-ac-correction-banner';
    bannerEl.style.display = 'none';
    bannerEl.addEventListener('click', function(evt) {
      var link = evt.target.closest('.ss-ac-correction-link');
      if (!link) return;
      var corrected = link.getAttribute('data-corrected');
      if (!corrected) return;
      var input = document.querySelector('#HeaderSearchForm .site-header__search-input')
        || document.querySelector('.nested-search-input')
        || document.querySelector('.site-header__search-input');
      var form = input && input.closest('form');
      if (input && form) {
        input.value = corrected;
        form.submit();
      }
    });
    return bannerEl;
  }

  var placeRetryTimer = null;
  function placeBanner() {
    // [ss-autocomplete] uses position: fixed; width: 100vw; top: 116px (82px on mobile).
    // Insert into the visible .ss-ac-container as the first child.
    // SS may briefly hide the dropdown between queries — retry until visible.
    var containers = document.querySelectorAll('[ss-autocomplete] .ss-ac-container');
    var visible = null;
    for (var i = 0; i < containers.length; i++) {
      if (containers[i].offsetWidth > 0) { visible = containers[i]; break; }
    }
    if (!visible) {
      if (placeRetryTimer) return; // already retrying
      var attempts = 0;
      placeRetryTimer = setInterval(function() {
        attempts++;
        var cs = document.querySelectorAll('[ss-autocomplete] .ss-ac-container');
        var v = null;
        for (var j = 0; j < cs.length; j++) {
          if (cs[j].offsetWidth > 0) { v = cs[j]; break; }
        }
        if (v) {
          clearInterval(placeRetryTimer);
          placeRetryTimer = null;
          if (bannerEl && bannerEl.style.display !== 'none') {
            v.insertBefore(bannerEl, v.firstChild);
          }
        } else if (attempts > 20) {
          clearInterval(placeRetryTimer);
          placeRetryTimer = null;
        }
      }, 100);
      return;
    }
    if (bannerEl.parentNode !== visible || visible.firstChild !== bannerEl) {
      visible.insertBefore(bannerEl, visible.firstChild);
    }
  }

  function showBanner(corrected) {
    ensureBanner();
    bannerEl.innerHTML = 'Did you mean <button type="button" class="ss-ac-correction-link" data-corrected="'
      + escapeHTML(corrected) + '"><strong>'
      + escapeHTML(corrected) + '</strong></button>?';
    bannerEl.style.display = 'block';
    placeBanner();
  }

  function hideBanner() {
    if (bannerEl) bannerEl.style.display = 'none';
  }

  function checkCorrection(query) {
    if (!query || query.length < MIN_LEN) { hideBanner(); return; }

    if (queryCache[query] !== undefined) {
      var cached = queryCache[query];
      if (cached) showBanner(cached); else hideBanner();
      return;
    }

    var url = 'https://' + SS_SITE_ID + '.a.searchspring.io/api/suggest/query?lang=en&limit=1&pubId='
      + SS_SITE_ID + '&query=' + encodeURIComponent(query);
    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var corrected = data['corrected-query'];
        if (corrected && corrected.toLowerCase() !== query.toLowerCase()) {
          queryCache[query] = corrected;
          showBanner(corrected);
        } else {
          queryCache[query] = null;
          hideBanner();
        }
      })
      .catch(function() { hideBanner(); });
  }

  function onInput(evt) {
    var input = evt.target;
    if (!input.classList || (
        !input.classList.contains('site-header__search-input') &&
        !input.classList.contains('nested-search-input'))) return;

    var value = input.value.trim();
    if (value === lastQuery) return;
    lastQuery = value;

    if (fetchTimer) clearTimeout(fetchTimer);
    if (!value) { hideBanner(); return; }
    fetchTimer = setTimeout(function() { checkCorrection(value); }, DEBOUNCE_MS);
  }

  // Bubble + capture phases (Angular may stop bubbling on some inputs)
  document.addEventListener('input', onInput, false);
  document.addEventListener('input', onInput, true);
})();

// ========================================
// GRID PRICE RESTRUCTURING (non-SearchSpring)
// Matches collection page price layout: superscript cents,
// rounded compare-at, rounded savings, two-row flex layout
// ========================================
(function() {
  'use strict';

  function restructureGridPrices() {
    // Target Liquid-rendered grid prices NOT inside SearchSpring content
    var priceBlocks = document.querySelectorAll('.grid-product__price:not(.ss-price-restructured):not(.ss-cents-done)');

    priceBlocks.forEach(function(priceBlock) {
      // Skip if inside SearchSpring (handled separately)
      if (priceBlock.closest('#searchspring-content')) return;
      if (priceBlock.closest('.ss-profile')) return;

      var original = priceBlock.querySelector('.grid-product__price--original');
      var current = priceBlock.querySelector('.grid-product__price--current');
      if (!current) return;

      if (original) {
        // On sale — full restructure
        priceBlock.classList.add('ss-price-restructured');

        // Superscript cents on current price
        var priceText = current.textContent.trim();
        var priceMatch = priceText.match(/^(\$[\d,]+)\.(\d{2})\s*(CAD)?/);
        if (priceMatch) {
          current.innerHTML = priceMatch[1] + '<sup class="price-cents">' + priceMatch[2] + '</sup>' +
            (priceMatch[3] ? ' <span class="currency-format">' + priceMatch[3] + '</span>' : '');
        }

        // Round up compare-at price to nearest dollar
        var origText = original.textContent.trim();
        var origMatch = origText.match(/\$([\d,]+)\.(\d{2})/);
        if (origMatch) {
          var origDollars = parseInt(origMatch[1].replace(/,/g, ''), 10);
          var origCents = parseInt(origMatch[2], 10);
          if (origCents > 0) origDollars += 1;
          original.innerHTML = '$' + origDollars;
        }

        // Remove cents from save amount
        var savings = priceBlock.querySelector('.grid-product__price--savings');
        if (savings) {
          var saveText = savings.textContent.trim();
          var saveMatch = saveText.match(/(Save\s*\$[\d,]+)\.\d{2}/);
          if (saveMatch) {
            savings.textContent = saveMatch[1];
          }
        }
      } else {
        // Regular price — just superscript cents
        priceBlock.classList.add('ss-cents-done');
        var priceText = current.textContent.trim();
        var priceMatch = priceText.match(/^(\$[\d,]+)\.(\d{2})\s*(CAD)?/);
        if (priceMatch) {
          current.innerHTML = priceMatch[1] + '<sup class="price-cents">' + priceMatch[2] + '</sup>' +
            (priceMatch[3] ? ' <span class="currency-format">' + priceMatch[3] + '</span>' : '');
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Run after a short delay to ensure Liquid content is rendered
    setTimeout(restructureGridPrices, 500);
  });

  // Also re-run on Shopify section loads (e.g. featured collections)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(restructureGridPrices, 300);
  });
})();

// ========================================
// VARIANT LABEL UPDATER
// Updates selected value display for ALL variant options
// ========================================
(function() {
  'use strict';

  document.addEventListener('change', function(evt) {
    var input = evt.target;

    // Check if this is a variant radio button or select
    if (!input.matches('[data-variant-input], .single-option-selector')) return;

    var optionIndex = input.dataset.index; // e.g., "option1", "option2"
    if (!optionIndex) return;

    // Get the numeric index (0, 1, 2)
    var numericIndex = parseInt(optionIndex.replace('option', ''), 10) - 1;

    // Get selected value
    var selectedValue = input.value;

    // Find the corresponding label span
    var form = input.closest('form') || input.closest('.product-single__meta') || document;
    var labelSpan = form.querySelector('[data-variant-value-label][data-index="' + numericIndex + '"]');

    if (labelSpan) {
      labelSpan.textContent = selectedValue;
    }
  });
})();

// ========================================
// INVENTORY QUANTITY UPDATER
// Shows "X in stock" or "10+ in stock" based on quantity
// Overrides theme.js default behavior
// ========================================
(function() {
  'use strict';

  function updateInventoryText(container) {
    var inventoryEl = container.querySelector('[data-product-inventory]');
    if (!inventoryEl) return;

    // Get product ID from data-product-id attribute (how theme.js stores it)
    var productId = container.getAttribute('data-product-id');
    if (!productId || !window.inventories || !window.inventories[productId]) return;

    // Get current variant ID from the hidden select
    var variantSelect = container.querySelector('[name="id"]');
    if (!variantSelect) return;

    var variantId = variantSelect.value;
    var variantInventory = window.inventories[productId][variantId];
    if (!variantInventory) return;

    var quantity = parseInt(variantInventory.quantity, 10);

    // Products tagged 'hide-stock-count' show a scarcity message
    // instead of a unit count (limited/hyped releases)
    if (inventoryEl.hasAttribute('data-hide-count')) {
      if (quantity > 0) {
        inventoryEl.innerHTML = 'Limited Stock<br>Selling Fast';
        inventoryEl.parentNode.classList.add('inventory--low');
      }
      // If 0 or less, theme.js already wrote "Sold Out"
      return;
    }

    // Update the text based on quantity
    if (quantity >= 10) {
      inventoryEl.textContent = '10+ in stock';
    } else if (quantity > 0) {
      inventoryEl.textContent = quantity + ' in stock';
    }
    // If 0 or less, let theme.js handle hiding it
  }

  // Listen for variant changes on product containers
  // Use setTimeout to run AFTER theme.js updates the text
  document.addEventListener('variantChange', function(evt) {
    var container = evt.target;
    setTimeout(function() {
      updateInventoryText(container);
    }, 10);
  }, true);

  // Also listen on document for the variant:change event
  document.addEventListener('variant:change', function(evt) {
    // Find the closest product container
    var containers = document.querySelectorAll('[data-product-id]');
    containers.forEach(function(container) {
      setTimeout(function() {
        updateInventoryText(container);
      }, 10);
    });
  });
})();

/**
 * Selected Variant Display Updater
 * Shows currently selected options above Add to Bag button
 */
(function() {
  function updateSelectedVariantDisplay() {
    var display = document.querySelector('[data-selected-variant-display]');
    if (!display) return;

    var variantWraps = document.querySelectorAll('.variant-input-wrap');
    variantWraps.forEach(function(wrap, idx) {
      var selected = '';
      var checkedInput = wrap.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        selected = checkedInput.value;
      } else {
        var selectEl = wrap.querySelector('select');
        if (selectEl) selected = selectEl.value;
      }
      if (!selected) return;
      var valueSpan = display.querySelector('[data-selected-option="' + (idx + 1) + '"]');
      if (valueSpan) valueSpan.textContent = selected;
    });
  }

  // Listen for clicks on variant inputs
  document.addEventListener('click', function(evt) {
    var label = evt.target.closest('.variant__button-label');
    if (label) {
      setTimeout(updateSelectedVariantDisplay, 10);
    }
  });

  // Listen for variant dropdown changes
  document.addEventListener('change', function(evt) {
    if (evt.target.matches('.variant-input-wrap select, [data-variant-input]')) {
      setTimeout(updateSelectedVariantDisplay, 10);
    }
  });

  // Initial update on page load
  document.addEventListener('DOMContentLoaded', updateSelectedVariantDisplay);
})();

/**
 * Filter List Scroll Detection
 * Adds 'has-scroll' class to wrappers with scrollable content
 * Adds 'scrolled-bottom' class when scrolled to bottom (hides fade)
 */
(function() {
  // Throttle helper to limit function calls
  function throttle(func, limit) {
    var inThrottle;
    return function() {
      var context = this, args = arguments;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(function() { inThrottle = false; }, limit);
      }
    };
  }

  function initFilterScrollDetection() {
    var wrappers = document.querySelectorAll('.filter-list-wrapper');

    wrappers.forEach(function(wrapper) {
      var list = wrapper.querySelector('.tag-list');
      if (!list) return;

      // Cache dimensions to avoid repeated layout reads
      var cachedScrollHeight = 0;
      var cachedClientHeight = 0;

      // Check if list is scrollable (reads layout once)
      function checkScrollable() {
        cachedScrollHeight = list.scrollHeight;
        cachedClientHeight = list.clientHeight;
        wrapper.classList.toggle('has-scroll', cachedScrollHeight > cachedClientHeight);
      }

      // Check if scrolled to bottom (uses cached values)
      function checkScrollPosition() {
        var isAtBottom = cachedScrollHeight - list.scrollTop - cachedClientHeight < 10;
        wrapper.classList.toggle('scrolled-bottom', isAtBottom);
      }

      // Initial check
      checkScrollable();
      checkScrollPosition();

      // Throttled scroll handler (16ms = ~60fps)
      list.addEventListener('scroll', throttle(checkScrollPosition, 16), { passive: true });

      // Throttled resize handler (100ms)
      window.addEventListener('resize', throttle(function() {
        checkScrollable();
        checkScrollPosition();
      }, 100));
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterScrollDetection);
  } else {
    initFilterScrollDetection();
  }

  // Re-run when collapsibles open (in case content was hidden)
  document.addEventListener('click', function(e) {
    if (e.target.closest('.collapsible-trigger')) {
      setTimeout(initFilterScrollDetection, 300);
    }
  });
})();

/**
 * Variant Option Sorting
 * Sorts variant options within each option group while preserving in-stock first order.
 * Sort priority: clothing sizes (XXXS-5XL), then numbers (0-99), then alphabetical (A-Z)
 */
(function() {
  // Clothing size order map - covers standard sizes and numeric variants (2XL, 3XL, etc.)
  var sizeOrder = {
    // Extra smalls
    'xxxxs': 1, '4xs': 1,
    'xxxs': 2, '3xs': 2,
    'xxs': 3, '2xs': 3,
    'xs': 4,
    // Standard sizes
    's': 5, 'small': 5, 'sm': 5,
    'm': 6, 'medium': 6, 'med': 6,
    'l': 7, 'large': 7, 'lg': 7,
    // Extra larges
    'xl': 8,
    'xxl': 9, '2xl': 9,
    'xxxl': 10, '3xl': 10,
    'xxxxl': 11, '4xl': 11,
    'xxxxxl': 12, '5xl': 12,
    // One size
    'one size': 0, 'os': 0, 'o/s': 0
  };

  // Check if a value is a clothing size
  function getSizeIndex(value) {
    var normalized = value.toLowerCase().trim();
    return sizeOrder.hasOwnProperty(normalized) ? sizeOrder[normalized] : null;
  }

  // Check if value is purely numeric
  function isNumeric(value) {
    return /^\d+(\.\d+)?$/.test(value.trim());
  }

  // Get sort key for a variant value
  // Returns { type: 'size'|'number'|'alpha', value: number|string }
  function getSortKey(value) {
    var sizeIndex = getSizeIndex(value);
    if (sizeIndex !== null) {
      return { type: 'size', value: sizeIndex };
    }
    if (isNumeric(value)) {
      return { type: 'number', value: parseFloat(value) };
    }
    return { type: 'alpha', value: value.toLowerCase().trim() };
  }

  // Compare two variant values
  function compareVariants(a, b) {
    var keyA = getSortKey(a);
    var keyB = getSortKey(b);

    // Same type - compare values
    if (keyA.type === keyB.type) {
      if (keyA.type === 'alpha') {
        return keyA.value.localeCompare(keyB.value);
      }
      return keyA.value - keyB.value;
    }

    // Different types - priority: size > number > alpha
    var typePriority = { 'size': 0, 'number': 1, 'alpha': 2 };
    return typePriority[keyA.type] - typePriority[keyB.type];
  }

  function sortVariantOptions() {
    var fieldsets = document.querySelectorAll('.variant-input-wrap[data-index]');

    fieldsets.forEach(function(fieldset) {
      // Skip color swatches - they often have a deliberate merchandising order.
      // The wrapper is a CHILD of the fieldset (closest() looked up the tree and
      // never matched, so tiles were being sorted and re-appended outside the
      // wrapper, breaking its layout).
      if (fieldset.querySelector('.color-swatches-wrapper')) return;

      var container = fieldset;
      var inputs = Array.from(fieldset.querySelectorAll('.variant-input[data-value]'));

      if (inputs.length < 2) return;

      // Separate in-stock and out-of-stock variants
      var inStock = [];
      var outOfStock = [];

      inputs.forEach(function(input) {
        var radio = input.querySelector('input[type="radio"]');
        if (radio && radio.classList.contains('disabled')) {
          outOfStock.push(input);
        } else {
          inStock.push(input);
        }
      });

      // Sort each group by value
      function sortGroup(group) {
        return group.sort(function(a, b) {
          var valA = a.getAttribute('data-value') || '';
          var valB = b.getAttribute('data-value') || '';
          return compareVariants(valA, valB);
        });
      }

      var sortedInStock = sortGroup(inStock);
      var sortedOutOfStock = sortGroup(outOfStock);

      // Reorder DOM: in-stock first, then out-of-stock
      sortedInStock.concat(sortedOutOfStock).forEach(function(input) {
        container.appendChild(input);
      });
    });

    // Also sort dropdown options
    var dropdowns = document.querySelectorAll('.variant-wrapper--dropdown select[data-variant-input]');
    dropdowns.forEach(function(select) {
      var options = Array.from(select.querySelectorAll('option'));
      if (options.length < 2) return;

      // Separate enabled and disabled options
      var enabled = [];
      var disabled = [];

      options.forEach(function(opt) {
        if (opt.disabled) {
          disabled.push(opt);
        } else {
          enabled.push(opt);
        }
      });

      // Sort each group
      function sortOptions(group) {
        return group.sort(function(a, b) {
          return compareVariants(a.value, b.value);
        });
      }

      var sortedEnabled = sortOptions(enabled);
      var sortedDisabled = sortOptions(disabled);

      // Reorder: enabled first, then disabled
      sortedEnabled.concat(sortedDisabled).forEach(function(opt) {
        select.appendChild(opt);
      });
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortVariantOptions);
  } else {
    sortVariantOptions();
  }
})();

// ========================================
// COLLECTION QUICK FILTER PILLS
// ========================================
(function() {
  'use strict';

  // Only run on collection pages
  if (!document.querySelector('.collection-quick-filters')) return;

  // Facet priority order
  var FACET_PRIORITY = ['tags_category', 'product_type', 'tags_division', 'vendor'];
  var MIN_VALUES = 5;
  var MAX_PILLS = 10;

  // Display-only label shortening; the filter value sent to SearchSpring stays untouched.
  // On all-customizers every product_type starts with "Custom", so the word that
  // differentiates each pill is what gets cut off in the scroll strip.
  function displayLabel(label) {
    if (window.location.pathname.indexOf('/collections/all-customizers') === -1) return label;
    if (label === 'Custom Goalie Chest & Arm Protectors') return 'Chest & Arm';
    return String(label).replace(/^Custom\s+(Hockey\s+)?/i, '');
  }

  // Debounce helper
  function debounce(func, wait) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() { func.apply(context, args); }, wait);
    };
  }

  // SearchSpring double-encoding: spaces become %20 then $2520, slashes become $252F, etc.
  function ssEncode(value) {
    // First URL-encode, then replace % with $25
    return encodeURIComponent(value).replace(/%/g, '$25');
  }

  // Decode a SS-encoded value back to plain text
  function ssDecode(encoded) {
    // Replace $25 with %, then URL-decode
    return decodeURIComponent(encoded.replace(/\$25/g, '%'));
  }

  // Parse active quick-filter from URL hash for a given field
  function getActiveFilterValue(field) {
    var hash = window.location.hash;
    if (!hash) return null;

    // Match filter:{field}:{value} — value ends at next / or end of string
    var regex = new RegExp('filter:' + field.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ':([^/]+)');
    var match = hash.match(regex);
    if (match) {
      return ssDecode(match[1]);
    }
    return null;
  }

  // Set or remove a filter in the URL hash
  function toggleFilter(field, value) {
    var hash = window.location.hash || '#/';
    var encoded = ssEncode(value);
    var filterSegment = 'filter:' + field + ':' + encoded;

    // Check if this exact filter is already in the hash
    var regex = new RegExp('/?' + 'filter:' + field.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ':[^/]+');
    var existing = hash.match(regex);

    if (existing) {
      // Check if it's the same value (toggle off) or different (replace)
      var existingDecoded = null;
      var existingMatch = existing[0].match(/filter:[^:]+:(.+)/);
      if (existingMatch) {
        existingDecoded = ssDecode(existingMatch[1]);
      }

      if (existingDecoded === value) {
        // Same value — remove filter (toggle off)
        var newHash = hash.replace(regex, '');
        // Clean up double slashes
        newHash = newHash.replace(/\/+/g, '/').replace(/\/#$/, '#/').replace(/\/$/, '');
        if (newHash === '#' || newHash === '#/') newHash = '#/';
        window.location.hash = newHash;
      } else {
        // Different value — replace
        var newHash = hash.replace(regex, '/' + filterSegment);
        // Clean up leading double slashes
        newHash = newHash.replace(/\/+/g, '/');
        window.location.hash = newHash;
      }
    } else {
      // Filter not present — add it
      if (hash === '#/' || hash === '#') {
        window.location.hash = '#/' + filterSegment;
      } else {
        window.location.hash = hash + '/' + filterSegment;
      }
    }
  }

  // Update active pill state based on current hash
  function updateActivePills(container, field) {
    var activeValue = getActiveFilterValue(field);
    var pills = container.querySelectorAll('.collection-quick-filters__pill');

    pills.forEach(function(pill) {
      var pillValue = pill.getAttribute('data-filter-value');
      if (activeValue && pillValue === activeValue) {
        pill.classList.add('is-active');
        pill.setAttribute('aria-pressed', 'true');
      } else {
        pill.classList.remove('is-active');
        pill.setAttribute('aria-pressed', 'false');
      }
    });
  }

  // Build pills from facet values
  function buildPills(facetField, values) {
    var nav = document.querySelector('.collection-quick-filters');
    var scroll = nav ? nav.querySelector('.collection-quick-filters__scroll') : null;
    if (!scroll) return;

    // Sort by count descending, take top MAX_PILLS
    var sorted = values.slice().sort(function(a, b) {
      return (b.count || 0) - (a.count || 0);
    });
    sorted = sorted.slice(0, MAX_PILLS);

    // Clear existing pills
    scroll.innerHTML = '';

    // Get current collection path
    var collectionPath = window.location.pathname;

    sorted.forEach(function(item) {
      var label = item.value || item.label || item;
      var pill = document.createElement('a');
      pill.className = 'collection-quick-filters__pill';
      pill.setAttribute('role', 'button');
      pill.setAttribute('aria-pressed', 'false');
      pill.setAttribute('data-filter-value', label);
      pill.setAttribute('data-filter-field', facetField);
      pill.href = collectionPath + '#/filter:' + facetField + ':' + ssEncode(label);
      pill.textContent = displayLabel(label);
      scroll.appendChild(pill);
    });

    // Store field on nav for hashchange handler
    nav.setAttribute('data-active-field', facetField);

    // Update active state
    updateActivePills(scroll, facetField);

    // Show the container
    nav.classList.add('is-active');
  }

  // Read facets from SearchSpring Angular scope
  function readFacets() {
    if (typeof angular === 'undefined') return null;

    var sidebar = document.getElementById('searchspring-sidebar');
    var content = document.getElementById('searchspring-content');

    // Build list of elements to check for Angular scope with facets
    var targets = [];
    if (sidebar) {
      targets.push(
        sidebar.querySelector('.ss-facets'),
        sidebar.querySelector('.ss-facet-container'),
        sidebar.querySelector('.ss-sidebar-container'),
        sidebar
      );
    }

    // On mobile, sidebar may be empty (slideout mode). Check content area and root .ng-scope
    if (content) {
      var ngScope = content.querySelector('.ng-scope');
      if (ngScope) targets.push(ngScope);
      targets.push(content);
    }

    // Fallback: root ng-scope element (works on both mobile and desktop)
    var rootNgScope = document.querySelector('[ng-app], [data-ng-app], .ng-scope');
    if (rootNgScope) targets.push(rootNgScope);

    targets = targets.filter(Boolean);

    for (var i = 0; i < targets.length; i++) {
      try {
        var scope = angular.element(targets[i]).scope();
        if (scope && scope.facets && scope.facets.length > 0) {
          return scope.facets;
        }
      } catch (e) {
        // continue to next target
      }
    }

    return null;
  }

  // Alternative: read facets from DOM
  function readFacetsFromDOM() {
    var facetContainers = document.querySelectorAll('#searchspring-sidebar .ss-facet-container, #searchspring-sidebar [ss-facet-container]');
    if (facetContainers.length === 0) return null;

    var facets = [];
    facetContainers.forEach(function(container) {
      var fieldEl = container.querySelector('[ss-facet-field]') || container;
      var field = fieldEl.getAttribute('ss-facet-field') || container.getAttribute('data-field') || '';

      // Try to get field name from various attributes
      if (!field) {
        var heading = container.querySelector('.ss-facet-title, .ss-facet-heading, h3, h4');
        if (heading) field = heading.textContent.trim().toLowerCase().replace(/\s+/g, '_');
      }

      var values = [];
      var valueEls = container.querySelectorAll('.ss-facet-value, [ss-facet-value]');
      valueEls.forEach(function(valEl) {
        var label = valEl.querySelector('.ss-facet-value-label, .ss-value-label, label');
        var count = valEl.querySelector('.ss-facet-value-count, .ss-value-count, .count');
        if (label) {
          values.push({
            value: label.textContent.trim(),
            count: count ? parseInt(count.textContent.replace(/[^\d]/g, ''), 10) || 0 : 0
          });
        }
      });

      if (field && values.length > 0) {
        facets.push({ field: field, values: values });
      }
    });

    return facets.length > 0 ? facets : null;
  }

  // Pick the best facet based on priority
  function pickFacet(facets) {
    if (!facets) return null;

    // Normalize facets to array format
    var facetArray;
    if (Array.isArray(facets)) {
      facetArray = facets;
    } else if (typeof facets === 'object') {
      // Object keyed by field name
      facetArray = Object.keys(facets).map(function(key) {
        var f = facets[key];
        return {
          field: f.field || key,
          values: f.values || f.facet_values || []
        };
      });
    } else {
      return null;
    }

    // Walk priority list
    for (var i = 0; i < FACET_PRIORITY.length; i++) {
      var targetField = FACET_PRIORITY[i];

      for (var j = 0; j < facetArray.length; j++) {
        var facet = facetArray[j];
        var field = facet.field || '';

        if (field === targetField || field.indexOf(targetField) !== -1) {
          var vals = facet.values || facet.facet_values || [];
          if (vals.length >= MIN_VALUES) {
            return { field: field, values: vals };
          }
        }
      }
    }

    return null;
  }

  // Main initialization with retry logic
  var initAttempts = 0;
  var MAX_INIT_ATTEMPTS = 10;

  function initQuickFilters() {
    // Try Angular scope first
    var facets = readFacets();
    var chosen = pickFacet(facets);

    // Fallback to DOM reading
    if (!chosen) {
      facets = readFacetsFromDOM();
      chosen = pickFacet(facets);
    }

    if (chosen) {
      buildPills(chosen.field, chosen.values);
    } else if (initAttempts < MAX_INIT_ATTEMPTS) {
      // Facet data may not be populated yet — retry
      initAttempts++;
      setTimeout(initQuickFilters, 500);
    }
  }

  // Click handler for pills (event delegation)
  document.addEventListener('click', function(evt) {
    var pill = evt.target.closest('.collection-quick-filters__pill');
    if (!pill) return;

    evt.preventDefault();

    var field = pill.getAttribute('data-filter-field');
    var value = pill.getAttribute('data-filter-value');
    if (field && value) {
      toggleFilter(field, value);
    }
  });

  // Update active pills on hashchange
  window.addEventListener('hashchange', function() {
    var nav = document.querySelector('.collection-quick-filters');
    if (!nav) return;
    var field = nav.getAttribute('data-active-field');
    if (!field) return;

    var scroll = nav.querySelector('.collection-quick-filters__scroll');
    if (scroll) {
      updateActivePills(scroll, field);
    }
  });

  // Wait for SearchSpring to render, then initialize
  function waitForSearchSpring() {
    var sidebar = document.getElementById('searchspring-sidebar');
    var content = document.getElementById('searchspring-content');
    if (!sidebar && !content) {
      setTimeout(waitForSearchSpring, 500);
      return;
    }

    // Use MutationObserver to detect when SS populates
    var initialized = false;
    var observers = [];

    function onReady() {
      if (initialized) return;
      initialized = true;
      observers.forEach(function(obs) { obs.disconnect(); });
      // Small delay for Angular digest
      setTimeout(initQuickFilters, 200);
    }

    var checkDebounced = debounce(function() {
      if (initialized) return;

      // Desktop: sidebar has facet containers
      if (sidebar && sidebar.querySelector('.ss-facet-container, [ss-facet-container], .ss-sidebar')) {
        onReady();
        return;
      }

      // Mobile: content area has rendered products (facets available on root scope)
      if (content && content.querySelector('.ng-scope, .ss-results, [ss-results]')) {
        onReady();
        return;
      }
    }, 150);

    // Observe both sidebar and content area
    if (sidebar) {
      var sidebarObs = new MutationObserver(checkDebounced);
      sidebarObs.observe(sidebar, { childList: true, subtree: true });
      observers.push(sidebarObs);
    }

    if (content) {
      var contentObs = new MutationObserver(checkDebounced);
      contentObs.observe(content, { childList: true, subtree: true });
      observers.push(contentObs);
    }

    // Fallback: try after a longer delay if observers don't fire
    setTimeout(function() {
      if (!initialized) {
        initialized = true;
        observers.forEach(function(obs) { obs.disconnect(); });
        initQuickFilters();
      }
    }, 4000);
  }

  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSearchSpring);
  } else {
    waitForSearchSpring();
  }
})();


// ========================================
// CART DRAWER SCROLL LOCK
// ========================================
// DISABLED 2026-04-13 — trialing stock Rebuy Smart Cart. Re-enable by removing the `if (false)`.
if (false)
(function CartDrawerScrollLock() {
  'use strict';

  var scrollPosition = 0;
  var isLocked = false;

  function lockScroll() {
    if (isLocked) return;
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.add('smart-cart--open');
    document.body.style.top = '-' + scrollPosition + 'px';
    isLocked = true;
  }

  function unlockScroll() {
    if (!isLocked) return;
    document.body.classList.remove('smart-cart--open');
    document.body.style.top = '';
    window.scrollTo(0, scrollPosition);
    isLocked = false;
  }

  // Watch for Rebuy cart overlay visibility changes
  function init() {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes') {
          var overlay = mutation.target;
          var isVisible = window.getComputedStyle(overlay).display !== 'none'
                          && window.getComputedStyle(overlay).visibility !== 'hidden';
          if (isVisible) {
            lockScroll();
          } else {
            unlockScroll();
          }
        }
      });
    });

    // Find the Rebuy overlay and observe it
    var checkInterval = setInterval(function() {
      var overlay = document.querySelector('.rebuy-cart__flyout-overlay');
      if (overlay) {
        clearInterval(checkInterval);
        observer.observe(overlay, {
          attributes: true,
          attributeFilter: ['style', 'class']
        });

        overlay.addEventListener('click', function() {
          setTimeout(unlockScroll, 50);
        });
      }
    }, 500);

    setTimeout(function() { clearInterval(checkInterval); }, 30000);

    document.addEventListener('keydown', function(evt) {
      if (evt.key === 'Escape' && isLocked) {
        setTimeout(unlockScroll, 50);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ========================================
// REBUY CART - MOVE RECOMMENDATIONS BELOW CHECKOUT
// + ITEM COUNT IN HEADER ("Your Bag (3)")
// ========================================
// DISABLED 2026-04-13 — trialing stock Rebuy Smart Cart. Re-enable by removing the `if (false)`.
if (false)
(function() {
  'use strict';

  var isMoving = false;

  function moveAnnouncementToFooter() {
    if (isMoving) return;

    var flyout = document.querySelector('.rebuy-cart__flyout');
    if (!flyout) return;

    var announcement = flyout.querySelector('.rebuy-cart__flyout-announcement-bar');
    if (!announcement) return;

    var footer = flyout.querySelector('.rebuy-cart__flyout-footer');
    if (!footer) return;

    // Already in footer
    if (announcement.parentNode === footer) return;

    var installments = footer.querySelector('.rebuy-cart__flyout-installments');
    var belowCheckout = footer.querySelector('[data-app-target="below_checkout"]');
    var insertBefore = belowCheckout || null;

    if (insertBefore) {
      footer.insertBefore(announcement, insertBefore);
    } else {
      footer.appendChild(announcement);
    }
  }

  function moveRecsAfterFooter() {
    if (isMoving) return;

    var flyout = document.querySelector('.rebuy-cart__flyout');
    if (!flyout) return;

    var recs = flyout.querySelector('.rebuy-cart__flyout-recommendations');
    if (!recs) return;

    // Already a direct child of the flyout (already moved)
    if (recs.parentNode === flyout) return;

    var footer = flyout.querySelector('.rebuy-cart__flyout-footer');
    if (!footer) return;

    isMoving = true;
    if (footer.nextSibling) {
      flyout.insertBefore(recs, footer.nextSibling);
    } else {
      flyout.appendChild(recs);
    }
    requestAnimationFrame(function() { isMoving = false; });
  }

  function updateCartTitle() {
    var title = document.querySelector('.rebuy-cart__flyout-title');
    if (!title) return;

    var items = document.querySelectorAll('.rebuy-cart__flyout-item');
    var count = items.length;
    var newText = count > 0 ? 'Your Bag (' + count + ')' : 'Your Bag';

    // Only update if text actually changed (prevents infinite loop)
    if (title.textContent.trim() === newText) return;
    title.textContent = newText;

    // Sync header cart icon count with Rebuy flyout state
    var headerCounts = document.querySelectorAll('.cart-link__bubble-num');
    headerCounts.forEach(function(el) { el.textContent = count; });
    var bubbles = document.querySelectorAll('.cart-link__bubble');
    bubbles.forEach(function(bubble) {
      if (count > 0) {
        bubble.classList.add('cart-link__bubble--visible');
      } else {
        bubble.classList.remove('cart-link__bubble--visible');
      }
    });
  }

  function addShippingCheckmark() {
    var prompt = document.querySelector('.rebuy-cart__progress-bar-prompt');
    if (!prompt) return;

    var fill = document.querySelector('.rebuy-cart__progress-bar-meter-fill');
    var isFull = fill && fill.style.width === '100%';

    var existing = prompt.querySelector('.rebuy-shipping-checkmark');

    if (isFull) {
      if (!existing) {
        var icon = document.createElement('span');
        icon.className = 'rebuy-shipping-checkmark';
        icon.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="12" fill="#22c55e"/><path d="M7 12.5l3 3 7-7" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        prompt.insertBefore(icon, prompt.firstChild);
      }
    } else if (existing) {
      existing.remove();
    }
  }

  function addProgressLabels() {
    var meter = document.querySelector('.rebuy-cart__progress-bar-meter');
    if (!meter) return;
    // Don't add if already there
    if (meter.parentElement.querySelector('.rebuy-progress-labels')) return;
    var labels = document.createElement('div');
    labels.className = 'rebuy-progress-labels';
    labels.innerHTML = '<span>$0</span><span>$119</span>';
    meter.parentElement.insertBefore(labels, meter.nextSibling);
  }

  // Shipping restriction notice for non-Canadian visitors in Rebuy Smart Cart
  // Use Shopify's browsing API for country detection (IP-based, more reliable than timezone)
  var __ths_isCanadian = true; // Default to Canadian (don't show notices) until we know
  var __ths_countryResolved = false;
  (function() {
    fetch('/browsing_context_suggestions.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var country = data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (country) {
          __ths_isCanadian = country === 'CA';
        }
        __ths_countryResolved = true;
        // Re-run Rebuy filters now that we know the country
        addShippingRestrictionNotice();
        addPickupOnlyNotice();
        filterRestrictedRecommendations();
      })
      .catch(function() { __ths_countryResolved = true; });
  })();

  function addShippingRestrictionNotice() {
    if (__ths_isCanadian) return;

    var flyout = document.querySelector('.rebuy-cart__flyout');
    if (!flyout) return;

    var existing = flyout.querySelector('.rebuy-shipping-restriction');

    // Check cart for Canada-only items via vendor field in /cart.js
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var restrictedVendors = ['bauer', 'ccm', 'true hockey', 'true'];
        var hasRestricted = cart.items.some(function(item) {
          return restrictedVendors.indexOf((item.vendor || '').toLowerCase()) !== -1;
        });

        if (hasRestricted && !flyout.querySelector('.rebuy-shipping-restriction')) {
          var notice = document.createElement('div');
          notice.className = 'rebuy-shipping-restriction';
          notice.innerHTML =
            '<div style="display:flex;align-items:flex-start;gap:8px;padding:10px 12px;margin:10px 15px;background:#FEF3C7;border:1px solid #F59E0B;border-radius:6px;color:#92400E;font-size:12px;line-height:1.4;">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:1px;color:#D97706;"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
              '<div><strong style="color:#78350F;">Shipping Notice:</strong> Bauer and CCM items can only be shipped within Canada. Please substitute them before checkout if you are outside Canada.</div>' +
            '</div>';
          var footer = flyout.querySelector('.rebuy-cart__flyout-footer');
          if (footer) {
            footer.parentNode.insertBefore(notice, footer);
          }
        } else if (!hasRestricted && existing) {
          existing.remove();
        }
      })
      .catch(function() {});
  }
  // In-store-pickup-only notice (Rebuy Smart Cart). Sparx sharpeners/rings/accessories
  // sit in the "Local pickup" delivery profile — checkout offers pickup only, no shipping —
  // but customers kept placing orders expecting delivery and never collecting them (Oct 2026).
  // /cart.js carries no product tags, so match on vendor. When EVERY line is pickup-only the
  // "$X away from free shipping" bar is hidden too; it was reinforcing the wrong expectation.
  var PICKUP_ONLY_VENDORS = ['sparx', 'sparx hockey'];
  function addPickupOnlyNotice() {
    var flyout = document.querySelector('.rebuy-cart__flyout');
    if (!flyout) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var items = cart.items || [];
        var isPickup = function(item) { return PICKUP_ONLY_VENDORS.indexOf((item.vendor || '').toLowerCase()) !== -1; };
        var hasPickupOnly = items.some(isPickup);
        var allPickupOnly = items.length > 0 && items.every(isPickup);
        var existing = flyout.querySelector('.rebuy-pickup-only');
        if (hasPickupOnly && !existing) {
          var notice = document.createElement('div');
          notice.className = 'rebuy-pickup-only';
          notice.innerHTML =
            '<div style="display:flex;align-items:flex-start;gap:8px;padding:10px 12px;margin:10px 15px;background:#FEF3C7;border:1px solid #F59E0B;border-radius:6px;color:#92400E;font-size:12px;line-height:1.4;">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:1px;color:#D97706;"><path d="M3 9l1-5h16l1 5"/><path d="M4 9v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><path d="M9 21v-6h6v6"/></svg>' +
              '<div><strong style="color:#78350F;">In-Store Pickup Only:</strong> Sparx items cannot be shipped. This order will need to be picked up at The Hockey Shop, 20202 66 Ave, Langley, BC.</div>' +
            '</div>';
          // Rebuy's current markup has no .rebuy-cart__flyout-footer (checked live 2026-10-20): anchor on the
          // subtotal row's wrapper so the banner sits between the progress bar and the subtotal; else prepend
          // to the last flyout block (checkout area).
          var subtotal = flyout.querySelector('.rebuy-cart__flyout-subtotal');
          var anchor = subtotal ? subtotal.parentNode : null;
          if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(notice, anchor);
          else if (flyout.lastElementChild) flyout.lastElementChild.insertBefore(notice, flyout.lastElementChild.firstChild);
        } else if (!hasPickupOnly && existing) {
          existing.remove();
        }
        var pbw = flyout.querySelector('.rebuy-cart__progress-bar-wrapper');
        var bar = flyout.querySelector('.rebuy-cart__progress-bar-container') || (pbw ? pbw.parentNode : null);
        var want = allPickupOnly ? 'none' : '';
        if (bar && bar.style.display !== want) bar.style.display = want; // only touch when it changes — the flyout observer would otherwise re-fire forever
      })
      .catch(function() {});
  }


  // Rebuy recommendation filtering — disabled for now
  function filterRestrictedRecommendations() {
    return;
  }

  var checkInterval = setInterval(function() {
    var flyout = document.querySelector('.rebuy-cart__flyout');
    if (flyout) {
      clearInterval(checkInterval);
      moveRecsAfterFooter();
      moveAnnouncementToFooter();
      updateCartTitle();
      addProgressLabels();
      addShippingCheckmark();
      addShippingRestrictionNotice();
      addPickupOnlyNotice();
      filterRestrictedRecommendations();

      // Single observer for all flyout changes (structure, items, visibility)
      var flyoutTimer;
      var filterTimer;
      var flyoutObserver = new MutationObserver(function() {
        if (flyoutTimer) return;
        flyoutTimer = setTimeout(function() {
          flyoutTimer = null;
          moveRecsAfterFooter();
          moveAnnouncementToFooter();
          updateCartTitle();
          addProgressLabels();
          addShippingCheckmark();
          addShippingRestrictionNotice();
          addPickupOnlyNotice();
          filterRestrictedRecommendations();
        }, 100);

        // Run filter again after Rebuy finishes re-rendering
        clearTimeout(filterTimer);
        filterTimer = setTimeout(function() {
          filterRestrictedRecommendations();
        }, 800);
      });
      flyoutObserver.observe(flyout, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    }
  }, 500);

  setTimeout(function() { clearInterval(checkInterval); }, 30000);
})();

// ========================================
// SEARCHSPRING SLIDEOUT BREAKPOINT OVERRIDE
// Forces SearchSpring into slideout (mobile) mode at ≤1105px
// so the Filter button appears instead of the empty sidebar.
// ========================================
(function() {
  'use strict';

  var SS_BREAKPOINT = 1105;

  function getSlideoutScope() {
    if (typeof angular === 'undefined') return null;

    // SearchSpring's slideout object lives on a scope near the sidebar or content containers
    var candidates = [
      document.getElementById('searchspring-sidebar'),
      document.getElementById('searchspring-content'),
      document.querySelector('[ss-slideout]'),
      document.querySelector('.ss-slideout'),
      document.querySelector('[ng-controller*="slideout"]'),
      document.querySelector('.ng-scope')
    ].filter(Boolean);

    for (var i = 0; i < candidates.length; i++) {
      try {
        var scope = angular.element(candidates[i]).scope();
        // Walk up scope chain looking for slideout
        var current = scope;
        while (current) {
          if (current.slideout && typeof current.slideout.triggered !== 'undefined') {
            return current;
          }
          current = current.$parent;
        }
      } catch (e) {
        // continue
      }
    }
    return null;
  }

  function syncSlideout() {
    var shouldSlideout = window.innerWidth <= SS_BREAKPOINT;
    var scope = getSlideoutScope();
    if (!scope) return false;

    if (scope.slideout.triggered !== shouldSlideout) {
      scope.$apply(function() {
        scope.slideout.triggered = shouldSlideout;
      });
    }
    return true;
  }

  // Debounce resize handler
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncSlideout, 150);
  });

  // Wait for SearchSpring Angular to be ready, then sync
  function waitAndSync() {
    var attempts = 0;
    var maxAttempts = 40; // 40 × 500ms = 20s
    var interval = setInterval(function() {
      attempts++;
      if (syncSlideout() || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndSync);
  } else {
    waitAndSync();
  }
})();


/* ============================================
   BACK TO TOP BUTTON
   ============================================ */
(function() {
  var btn = document.querySelector('.footer-back-to-top');
  if (!btn) return;

  var ticking = false;
  var threshold = 600;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        if (window.scrollY > threshold) {
          btn.classList.add('is-visible');
        } else {
          btn.classList.remove('is-visible');
        }
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  btn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

// ========================================
// GA4 DATALAYER EVENT TRACKING
// Client-side events pushed to dataLayer for GTM
// ========================================
(function() {
  'use strict';

  // Helper: push to dataLayer
  function dl(obj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
  }

  // Helper: ecommerce push (clears stale ecommerce data first)
  function dlEcom(obj) {
    dl({ ecommerce: null });
    dl(obj);
  }

  // Helper: find variant by ID from server-rendered product data
  function findVariant(variantId) {
    var p = window.__THS_PRODUCT;
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (String(p.variants[i].id) === String(variantId)) return p.variants[i];
    }
    return null;
  }

  // ── add_to_cart (product page, Quick Add, Rebuy FBT) ──
  document.addEventListener('ajaxProduct:added', function(evt) {
    var data = (evt.detail && evt.detail.product) ? evt.detail.product : evt.detail;
    if (!data) return;

    var price = data.price ? data.price / 100 : 0;
    var compareAt = data.compare_at_price ? data.compare_at_price / 100 : 0;
    var discount = compareAt > price ? compareAt - price : 0;

    dlEcom({
      event: 'add_to_cart',
      ecommerce: {
        currency: window.__THS_CURRENCY || 'CAD',
        value: price * (data.quantity || 1),
        items: [{
          item_id: data.sku || String(data.product_id || data.id),
          item_name: data.product_title || data.title || '',
          item_brand: data.vendor || '',
          item_category: data.product_type || '',
          item_variant: data.variant_title || '',
          price: price,
          discount: discount,
          quantity: data.quantity || 1
        }]
      }
    });
  });

  // ── remove_from_cart (intercept fetch to /cart/change.js) ──
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function() {
      var url = arguments[0];
      var opts = arguments[1];
      var fetchArgs = arguments;
      var fetchCtx = this;

      if (typeof url === 'string' && url.indexOf('/cart/change') !== -1 && opts && opts.body) {
        try {
          var body = typeof opts.body === 'string' ? JSON.parse(opts.body) : opts.body;
          if (body.quantity === 0 || body.quantity === '0') {
            // Fetch current cart to get full item data before removal
            origFetch.call(fetchCtx, '/cart.js', { method: 'GET', headers: { 'Accept': 'application/json' } })
              .then(function(r) { return r.json(); })
              .then(function(cart) {
                var lineKey = body.id || body.line;
                var item = cart.items.find(function(i) {
                  return String(i.key) === String(lineKey) || String(i.id) === String(lineKey) || i.variant_id === Number(lineKey);
                });
                if (item) {
                  dlEcom({
                    event: 'remove_from_cart',
                    ecommerce: {
                      currency: window.__THS_CURRENCY || 'CAD',
                      value: (item.final_price / 100) * item.quantity,
                      items: [{
                        item_id: item.sku || String(item.product_id),
                        item_name: item.product_title || '',
                        item_brand: item.vendor || '',
                        item_category: item.product_type || '',
                        item_variant: item.variant_title || '',
                        price: item.final_price / 100,
                        quantity: item.quantity
                      }]
                    }
                  });
                }
              })
              .catch(function() { /* ignore cart fetch errors */ });
          }
        } catch (e) { /* ignore parse errors */ }
      }

      return origFetch.apply(fetchCtx, fetchArgs);
    };
  }

  // ── select_item (product card click on collection page) ──
  var ssContent = document.getElementById('searchspring-content');
  if (ssContent) {
    ssContent.addEventListener('click', function(evt) {
      var link = evt.target.closest('a[href*="/products/"]');
      if (!link) return;

      var href = link.getAttribute('href') || '';
      var handle = href.split('/products/')[1];
      if (handle) handle = handle.split('?')[0].split('#')[0];

      var card = link.closest('.ss-item-container, .grid-product');
      var name = '';
      if (card) {
        var titleEl = card.querySelector('.grid-product__title, .ss-item-title');
        if (titleEl) name = titleEl.textContent.trim();
      }

      dlEcom({
        event: 'select_item',
        ecommerce: {
          items: [{
            item_id: handle || '',
            item_name: name || handle || ''
          }]
        }
      });
    });
  }

  // ── quick_filter_click (Searchspring quick filter pills) ──
  document.addEventListener('click', function(evt) {
    var btn = evt.target.closest('nav[aria-label="Quick filters"] button, .ss-quick-filter button');
    if (!btn) return;
    dl({
      event: 'quick_filter_click',
      filter_name: btn.textContent.trim()
    });
  });

  // ── sort_change (Searchspring sort dropdown) ──
  document.addEventListener('change', function(evt) {
    var sel = evt.target.closest('.ss-sort select, select[ss-sort]');
    if (!sel) return;
    dl({
      event: 'sort_change',
      sort_value: sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text.trim() : sel.value
    });
  });

  // ── load_more_click ──
  document.addEventListener('click', function(evt) {
    if (!evt.target.closest('.ss-infinite-loadmore-button')) return;
    var items = document.querySelectorAll('#searchspring-content .ss-item-container, #searchspring-content .grid-product');
    dl({
      event: 'load_more_click',
      products_shown: items.length
    });
  });

  // ── newsletter_signup ──
  document.addEventListener('submit', function(evt) {
    var form = evt.target.closest('#newsletter-footer-modern, .footer-signup form');
    if (!form) return;
    var emailInput = form.querySelector('input[type="email"]');
    dl({
      event: 'newsletter_signup',
      method: 'footer_form',
      email_provided: !!emailInput && !!emailInput.value
    });
  });

  // ── customize_product_click ──
  document.addEventListener('click', function(evt) {
    var btn = evt.target.closest('.grid-product__customize-btn, a[href*="view=mczrmobile"]');
    if (!btn) return;
    var href = btn.getAttribute('href') || '';
    dl({
      event: 'customize_product_click',
      product_url: href
    });
  });

  // ── rebuy_cart_open (observe overlay visibility) ──
  (function() {
    var checkInterval = setInterval(function() {
      var overlay = document.querySelector('.rebuy-cart__flyout-overlay');
      if (!overlay) return;
      clearInterval(checkInterval);

      var wasVisible = false;
      var obs = new MutationObserver(function() {
        var style = window.getComputedStyle(overlay);
        var isVisible = style.display !== 'none' && style.visibility !== 'hidden';
        if (isVisible && !wasVisible) {
          dl({ event: 'rebuy_cart_open' });
        }
        wasVisible = isVisible;
      });
      obs.observe(overlay, { attributes: true, attributeFilter: ['style', 'class'] });
    }, 1000);
    setTimeout(function() { clearInterval(checkInterval); }, 30000);
  })();


  // ── Rebuy cart: swap minus icon to trash when qty is 1 ──
  (function() {
    var MINUS_HTML = '<i aria-hidden="true" class="far fa-minus"></i>';
    var TRASH_HTML = '<i aria-hidden="true" class="far fa-trash"></i>';

    function updateButtons() {
      var items = document.querySelectorAll('.rebuy-cart__flyout-item-quantity-widget');
      items.forEach(function(widget) {
        var input = widget.querySelector('.rebuy-cart__flyout-item-quantity-widget-input');
        var minusBtn = widget.querySelector('.rebuy-cart__flyout-item-quantity-widget-button:first-child');
        if (!input || !minusBtn) return;
        var qty = parseInt(input.value, 10);
        var hasTrash = minusBtn.querySelector('.fa-trash');
        var hasMinus = minusBtn.querySelector('.fa-minus');
        if (qty <= 1 && !hasTrash) minusBtn.innerHTML = TRASH_HTML;
        else if (qty > 1 && !hasMinus) minusBtn.innerHTML = MINUS_HTML;
      });
    }

    function init() {
      var cart = document.querySelector('.rebuy-cart__flyout');
      if (!cart) { setTimeout(init, 500); return; }
      new MutationObserver(updateButtons).observe(cart, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
      updateButtons();
    }

    document.addEventListener('rebuy:cart.change', updateButtons);
    document.addEventListener('rebuy.cart.change', updateButtons);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  // ── Rebuy cart: item count in title, consistent "Add" labels,
  //    Save $X chip on sale line items (matches PDP savings pill) ──
  (function() {
    function parseMoney(el) {
      var m = (el.textContent || '').replace(/[^0-9.]/g, '');
      return m ? parseFloat(m) : NaN;
    }

    function updateTitle() {
      var title = document.querySelector('.rebuy-cart__title');
      if (!title) return;
      var count = 0;
      document.querySelectorAll('.rebuy-cart__flyout-item-quantity-widget-input').forEach(function(input) {
        count += parseInt(input.value, 10) || 0;
      });
      var newText = count > 0 ? 'Your Cart (' + count + ')' : 'Your Cart';
      if (title.textContent.trim() !== newText) title.textContent = newText;
    }

    function normalizeAddButtons() {
      document.querySelectorAll('.rebuy-cart__flyout .rebuy-product-actions .rebuy-button span').forEach(function(span) {
        var t = span.textContent.trim().toLowerCase();
        if (t === 'options' || t === 'size' || t === 'choose' || t === 'select') {
          span.textContent = 'Add';
        }
      });
    }

    function addSavingsChips() {
      document.querySelectorAll('.rebuy-cart__flyout-item-price').forEach(function(priceEl) {
        var sale = priceEl.querySelector('.rebuy-money.sale');
        var compare = priceEl.querySelector('.rebuy-money.compare-at');
        var chip = priceEl.querySelector('.rebuy-item-savings');
        if (!sale || !compare) { if (chip) chip.remove(); return; }
        var saved = parseMoney(compare) - parseMoney(sale);
        if (!(saved > 0)) { if (chip) chip.remove(); return; }
        // PDP rounds partial dollars up: Save $61 for $60.01
        var label = 'Save $' + Math.ceil(saved);
        if (chip) {
          if (chip.textContent !== label) chip.textContent = label;
          return;
        }
        chip = document.createElement('span');
        chip.className = 'rebuy-item-savings';
        chip.textContent = label;
        (sale.parentElement || priceEl).appendChild(chip);
      });
    }

    // Subtotal: Save chip replaces the struck-through compare-at (hidden in CSS,
    // but still rendered by Rebuy so we can read the amount off it)
    function updateSubtotalChip() {
      var amount = document.querySelector('.rebuy-cart__flyout-subtotal-amount');
      if (!amount) return;
      var final = amount.querySelector('.rebuy-cart__flyout-subtotal-final-amount');
      var compare = amount.querySelector('.rebuy-cart__flyout-subtotal-compare-amount');
      var chip = amount.querySelector('.rebuy-subtotal-savings');
      if (!final || !compare) { if (chip) chip.remove(); return; }
      var saved = parseMoney(compare) - parseMoney(final);
      if (!(saved > 0)) { if (chip) chip.remove(); return; }
      var label = 'Save $' + Math.ceil(saved);
      if (chip) {
        if (chip.textContent !== label) chip.textContent = label;
        return;
      }
      chip = document.createElement('span');
      chip.className = 'rebuy-item-savings rebuy-subtotal-savings';
      chip.textContent = label;
      compare.parentElement.appendChild(chip);
    }

    // Pro Stock line items carry no manufacturer warranty. The cart page gets
    // this badge from Liquid (snippets/cart-item.liquid), but Rebuy renders the
    // drawer from its own API, so it has to be injected here.
    // Caveat: tags aren't in the Rebuy DOM, so this matches on the title text
    // and the product handle in the link href — a tagged product whose title
    // and handle both omit "pro stock" would miss the badge in the drawer only.
    function addProStockBadges() {
      document.querySelectorAll('.rebuy-cart__flyout-item').forEach(function(item) {
        var info = item.querySelector('.rebuy-cart__flyout-item-info');
        if (!info) return;
        var titleEl = item.querySelector('.rebuy-cart__flyout-item-product-title');
        var link = titleEl ? titleEl.querySelector('a') : null;
        var haystack = (
          (titleEl ? titleEl.textContent : '') + ' ' +
          (link ? link.getAttribute('href') || '' : '')
        ).toLowerCase();
        var isProStock = haystack.indexOf('pro stock') !== -1 || haystack.indexOf('pro-stock') !== -1;
        var badge = info.querySelector('.ths-prostock-badge');
        if (!isProStock) { if (badge) badge.remove(); return; }
        if (badge) return;
        badge = document.createElement('div');
        badge.className = 'ths-prostock-badge';
        badge.textContent = 'No Manufacturer Warranty';
        // Sit under the title/variant rows, above the price
        var anchor = info.querySelector('.rebuy-cart__flyout-item-variant-title') || titleEl;
        if (anchor && anchor.parentElement === info) info.insertBefore(badge, anchor.nextSibling);
        else info.appendChild(badge);
      });
    }

    var pending;
    function runAll() {
      if (pending) return;
      pending = setTimeout(function() {
        pending = null;
        updateTitle();
        normalizeAddButtons();
        addSavingsChips();
        updateSubtotalChip();
        addProStockBadges();
      }, 100);
    }

    function init() {
      var cart = document.querySelector('.rebuy-cart__flyout');
      if (!cart) { setTimeout(init, 500); return; }
      new MutationObserver(runAll).observe(cart, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'value'] });
      runAll();
    }

    document.addEventListener('rebuy:cart.change', runAll);
    document.addEventListener('rebuy.cart.change', runAll);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  // ── faq_open (theme collapsible accordions site-wide) ──
  document.addEventListener('click', function(evt) {
    var trigger = evt.target.closest('.collapsible-trigger');
    if (!trigger) return;
    var label = trigger.querySelector('span');
    dl({
      event: 'faq_open',
      question_text: label ? label.textContent.trim().substring(0, 100) : ''
    });
  });

  // ── sizing_guide_card_click ──
  document.addEventListener('click', function(evt) {
    var card = evt.target.closest('[data-sizing-card]');
    if (!card) return;
    var titleEl = card.querySelector('.sizing-hub__card-title, h3');
    dl({
      event: 'sizing_guide_card_click',
      category_name: titleEl ? titleEl.textContent.trim() : ''
    });
  });

  // ── sizing_guide_shop_click ──
  document.addEventListener('click', function(evt) {
    var btn = evt.target.closest('.sizing-hub__shop-btn');
    if (!btn) return;
    dl({
      event: 'sizing_guide_shop_click',
      category_name: btn.textContent.trim(),
      destination_url: btn.getAttribute('href') || ''
    });
  });

  // ── buying_guide_section_view (IntersectionObserver) ──
  (function() {
    var sections = document.querySelectorAll('.buying-guide__section[id]');
    if (!sections.length) return;

    var viewed = {};
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !viewed[entry.target.id]) {
          viewed[entry.target.id] = true;
          dl({
            event: 'buying_guide_section_view',
            section_id: entry.target.id
          });
        }
      });
    }, { threshold: 0.2 });

    sections.forEach(function(sec) { observer.observe(sec); });
  })();

  // ── buying_guide_faq_open ──
  document.addEventListener('click', function(evt) {
    var faq = evt.target.closest('[data-buying-guide-faq]');
    if (!faq) return;
    var questionEl = faq.querySelector('.buying-guide__faq-question, span');
    dl({
      event: 'buying_guide_faq_open',
      question_text: questionEl ? questionEl.textContent.trim().substring(0, 100) : ''
    });
  });

  // ── contact_form_submit ──
  document.addEventListener('submit', function(evt) {
    var form = evt.target.closest('form[id^="contact-"], form[action*="/contact"]');
    if (!form) return;
    // Avoid double-firing with newsletter
    if (form.closest('#newsletter-footer-modern, .footer-signup')) return;
    var section = form.closest('.shopify-section');
    dl({
      event: 'contact_form_submit',
      form_location: section ? section.id : 'unknown'
    });
  });

  // ── blog_article_read (75% scroll depth) ──
  (function() {
    var articleBody = document.querySelector('.ths-article__body, .rte--article, .article__body');
    if (!articleBody) return;

    var fired = false;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !fired) {
          fired = true;
          var dlData = { event: 'blog_article_read' };
          // Pull article info from server-rendered dataLayer if available
          var dl_entries = window.dataLayer || [];
          for (var i = 0; i < dl_entries.length; i++) {
            if (dl_entries[i].event === 'view_article') {
              dlData.article_title = dl_entries[i].article_title;
              dlData.article_category = dl_entries[i].article_category;
              dlData.read_time = dl_entries[i].read_time;
              break;
            }
          }
          dl(dlData);
          observer.disconnect();
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -25% 0px' });

    observer.observe(articleBody);
  })();

  // ── social_link_click ──
  document.addEventListener('click', function(evt) {
    var link = evt.target.closest('.footer-social-icons a, .social-icons a');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var network = 'unknown';
    var networks = ['instagram', 'facebook', 'youtube', 'twitter', 'tiktok', 'pinterest', 'linkedin'];
    for (var i = 0; i < networks.length; i++) {
      if (href.indexOf(networks[i]) !== -1) { network = networks[i]; break; }
    }
    dl({
      event: 'social_link_click',
      network: network,
      destination_url: href
    });
  });

  // ── product_tab_click ──
  document.addEventListener('click', function(evt) {
    var tab = evt.target.closest('.product-tabs-horizontal button, .product-tabs-horizontal [role="tab"]');
    if (!tab) return;
    dl({
      event: 'product_tab_click',
      tab_name: tab.textContent.trim()
    });
  });

  // ── variant_select ──
  document.addEventListener('click', function(evt) {
    var label = evt.target.closest('.variant__button-label');
    if (!label) return;
    var input = label.previousElementSibling;
    if (!input || input.type !== 'radio') return;
    var fieldset = label.closest('fieldset, .variant-wrapper');
    var optionName = '';
    if (fieldset) {
      var legend = fieldset.querySelector('legend, .variant__label');
      if (legend) optionName = legend.textContent.trim().replace(/:$/, '');
    }
    dl({
      event: 'variant_select',
      option_name: optionName,
      option_value: label.textContent.trim()
    });
  });

  // ── sezzle_info_click ──
  document.addEventListener('click', function(evt) {
    var sezzleBtn = evt.target.closest('.sezzle-modal-link, .sezzle-learn-more, [data-sezzle-modal]');
    if (!sezzleBtn) return;
    var p = window.__THS_PRODUCT;
    dl({
      event: 'sezzle_info_click',
      product_name: p ? p.title : '',
      product_price: p && p.variants && p.variants[0] ? p.variants[0].price : 0
    });
  });

  // ── product_image_zoom ──
  document.addEventListener('click', function(evt) {
    var zoom = evt.target.closest('.product-image-zoom, .product__photo-zoom, [data-zoom]');
    if (!zoom) return;
    var p = window.__THS_PRODUCT;
    dl({
      event: 'product_image_zoom',
      product_name: p ? p.title : ''
    });
  });

  // ── rebuy_fbt_add_all ──
  document.addEventListener('click', function(evt) {
    var btn = evt.target.closest('[data-rebuy-id] .rebuy-actions button, .rebuy-widget button');
    if (!btn) return;
    var text = btn.textContent.trim().toLowerCase();
    if (text.indexOf('add all') === -1 && text.indexOf('add to') === -1) return;

    var widget = btn.closest('[data-rebuy-id], .rebuy-widget');
    if (!widget) return;
    var items = widget.querySelectorAll('.rebuy-product-item, .rebuy-product-card');
    dl({
      event: 'rebuy_fbt_add_all',
      item_count: items.length
    });
  });

  // ── product_recommendation_click ──
  document.addEventListener('click', function(evt) {
    var link = evt.target.closest('#shopify-section-product-recommendations a[href*="/products/"], .product-recommendations a[href*="/products/"]');
    if (!link) return;
    var titleEl = link.querySelector('.grid-product__title') || link.querySelector('img');
    dl({
      event: 'product_recommendation_click',
      recommended_product: titleEl ? (titleEl.textContent || titleEl.alt || '').trim() : ''
    });
  });

  // ── promo_banner_click ──
  document.addEventListener('click', function(evt) {
    var link = evt.target.closest('a');
    if (!link) return;
    var img = link.querySelector('img[alt*="romotional"], img[alt*="anner"], img[alt*="romo"]');
    if (!img) return;
    dl({
      event: 'promo_banner_click',
      destination_url: link.getAttribute('href') || '',
      banner_alt: img.alt || ''
    });
  });

  // ── category_card_click ──
  document.addEventListener('click', function(evt) {
    var card = evt.target.closest('.collection-list__item a, .featured-collection-grid a, .category-card a');
    if (!card) return;
    var titleEl = card.querySelector('.collection-list__item-title, h3, .card-title');
    dl({
      event: 'category_card_click',
      category_name: titleEl ? titleEl.textContent.trim() : '',
      destination_url: card.getAttribute('href') || ''
    });
  });

  // ── sms_signup_click ──
  document.addEventListener('click', function(evt) {
    var link = evt.target.closest('a[href*="attn.tv"]');
    if (!link) return;
    dl({ event: 'sms_signup_click' });
  });

  // ── phone_call_click ──
  document.addEventListener('click', function(evt) {
    var link = evt.target.closest('a[href^="tel:"]');
    if (!link) return;
    dl({
      event: 'phone_call_click',
      phone_number: link.getAttribute('href').replace('tel:', '')
    });
  });

  // ── email_link_click ──
  document.addEventListener('click', function(evt) {
    var link = evt.target.closest('a[href^="mailto:"]');
    if (!link) return;
    dl({
      event: 'email_link_click',
      email_address: link.getAttribute('href').replace('mailto:', '')
    });
  });

  // ── announcement_bar_click ──
  document.addEventListener('click', function(evt) {
    var link = evt.target.closest('.announcement a, .announcement-bar a, [class*="announcement"] a');
    if (!link) return;
    dl({
      event: 'announcement_bar_click',
      promo_text: link.textContent.trim().substring(0, 100),
      destination_url: link.getAttribute('href') || ''
    });
  });

  // ── Store currency for JS-side events ──
  (function() {
    var entries = window.dataLayer || [];
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].shop_currency) {
        window.__THS_CURRENCY = entries[i].shop_currency;
        break;
      }
    }
  })();

})();

// ============================================
// SS Recommendations Price Restructuring
// Match collection page pricing style in "Browse similar items"
// ============================================
(function() {
  'use strict';

  // Disable mouse drag on desktop by intercepting mousedown on the slider
  function disableDesktopMouseDrag() {
    if (window.innerWidth < 769) return;
    var sliders = document.querySelectorAll('.ss-profile .tns-slider');
    sliders.forEach(function(slider) {
      if (slider.dataset.dragDisabled) return;
      slider.dataset.dragDisabled = 'true';
      slider.addEventListener('mousedown', function(e) {
        if (window.innerWidth >= 769) {
          e.stopPropagation();
        }
      }, true);
    });
  }

  // Fix items that have no price displayed (msrp missing in SS index)
  function fixMissingPrices() {
    var items = document.querySelectorAll('.ss-profile .ss-recommendations-item:not(.ss-price-checked)');
    items.forEach(function(item) {
      item.classList.add('ss-price-checked');
      var meta = item.querySelector('.grid-product__meta');
      if (!meta) return;
      if (meta.querySelector('.grid-product__price')) return;

      // Extract product handle from the link URL
      var link = item.querySelector('a[href*="/products/"]');
      if (!link) return;
      var match = link.href.match(/\/products\/([^?#]+)/);
      if (!match) return;
      var handle = match[1];

      // Fetch price from Shopify product JSON
      fetch('/products/' + handle + '.json')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var product = data.product;
          if (!product || !product.variants || !product.variants.length) return;
          var variant = product.variants[0];
          var price = parseFloat(variant.price);
          if (isNaN(price) || price === 0) return;

          var priceFormatted = price.toFixed(2);
          var priceParts = priceFormatted.split('.');
          var priceDiv = document.createElement('div');
          priceDiv.className = 'grid-product__price';
          priceDiv.innerHTML = '<span class="grid-product__price--current">' +
            '$' + priceParts[0] + '<sup class="price-cents">' + priceParts[1] + '</sup>' +
            ' <span class="currency-format">CAD</span></span>';
          meta.appendChild(priceDiv);
        })
        .catch(function() {});
    });
  }

  function restructureRecPrices() {
    var items = document.querySelectorAll('.ss-profile .ss-recommendations-item .grid-product__price:not(.ss-price-restructured)');
    items.forEach(function(priceBlock) {
      var original = priceBlock.querySelector('.grid-product__price--original, .recs-was');
      var current = priceBlock.querySelector('.grid-product__price--current, .recs-sale');
      if (!original || !current) return;

      priceBlock.classList.add('ss-price-restructured');

      // Superscript cents on sale price
      var priceText = current.textContent.trim();
      var priceMatch = priceText.match(/^\$([\d,]+)\.(\d{2})\s*(CAD)?/);
      if (priceMatch) {
        current.innerHTML = '$' + priceMatch[1] + '<sup class="price-cents">' + priceMatch[2] + '</sup>' +
          (priceMatch[3] ? ' <span class="currency-format">' + priceMatch[3] + '</span>' : '');
      }

      // Round up compare-at price to nearest dollar
      var origText = original.textContent.trim();
      var origMatch = origText.match(/\$([\d,]+)\.(\d{2})/);
      if (origMatch) {
        var origDollars = parseInt(origMatch[1].replace(/,/g, ''), 10);
        var origCents = parseInt(origMatch[2], 10);
        if (origCents > 0) origDollars += 1;
        original.innerHTML = '$' + origDollars;
      }

      // Remove cents from save amount
      var savings = priceBlock.querySelector('.grid-product__price--savings');
      if (savings) {
        var saveText = savings.textContent.trim();
        var saveMatch = saveText.match(/(Save\s*\$[\d,]+)\.\d{2}/);
        if (saveMatch) {
          savings.textContent = saveMatch[1];
        }
      }

      // Move pct-off badge into price block (if it's elsewhere in the card)
      var card = priceBlock.closest('.grid-product, .ss-recommendations-item');
      if (card) {
        var pctBadge = card.querySelector('.grid-product__pct-off:not(.ss-badge-moved)');
        if (pctBadge) {
          pctBadge.classList.add('ss-badge-moved');
          if (savings) {
            priceBlock.insertBefore(pctBadge, savings);
          } else {
            priceBlock.appendChild(pctBadge);
          }
        }
      }
    });
  }

  // Superscript cents on non-sale recommendation prices
  function superscriptRegularRecPrices() {
    var priceBlocks = document.querySelectorAll('.ss-profile .ss-recommendations-item .grid-product__price:not(.ss-price-restructured):not(.ss-cents-done)');
    priceBlocks.forEach(function(priceBlock) {
      var current = priceBlock.querySelector('.grid-product__price--current');
      if (!current) return;
      priceBlock.classList.add('ss-cents-done');
      var priceText = current.textContent.trim();
      var priceMatch = priceText.match(/^\$([\d,]+)\.(\d{2})\s*(CAD)?/);
      if (priceMatch) {
        current.innerHTML = '$' + priceMatch[1] + '<sup class="price-cents">' + priceMatch[2] + '</sup>' +
          (priceMatch[3] ? ' <span class="currency-format">' + priceMatch[3] + '</span>' : '');
      }
    });
  }

  // Observe all SS recommendation containers (similar, recently-viewed, view-cart)
  function startRecObserver() {
    var containers = document.querySelectorAll('.ss-profile');
    if (containers.length > 0) {
      restructureRecPrices();
      superscriptRegularRecPrices();
      disableDesktopMouseDrag();
      fixMissingPrices();
      var obs = new MutationObserver(function() {
        restructureRecPrices();
        superscriptRegularRecPrices();
        disableDesktopMouseDrag();
        fixMissingPrices();
      });
      containers.forEach(function(container) {
        obs.observe(container, { childList: true, subtree: true });
      });
    } else {
      setTimeout(startRecObserver, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(startRecObserver, 1000); });
  } else {
    setTimeout(startRecObserver, 1000);
  }
})();

// ========================================
// SEZZLE HIDDEN PRICE SYNC
// Keeps the hidden .sezzle-price-target in sync on variant change
// so the Sezzle widget reads the correct decimal price.
// Config override is inline in product-template.liquid (must run before async Sezzle script).
// ========================================
(function() {
  'use strict';
  document.addEventListener('variant:change', function(evt) {
    var variant = evt.detail && evt.detail.variant;
    var el = document.querySelector('[data-sezzle-price]');
    if (!el || !variant) return;
    var formatted = theme && theme.Currency ? theme.Currency.formatMoney(variant.price) : '$' + (variant.price / 100).toFixed(2);
    el.innerHTML = formatted;
  });
})();

// ========================================
// SHIPPING ESTIMATE VISIBILITY
// Swap "Ships in 1-2 Days" for the back-in-stock signup hint on OOS
// variants (both rows are server-rendered; toggling keeps the row
// height stable so the buy area doesn't bounce).
// ========================================
(function() {
  'use strict';
  document.addEventListener('variant:change', function(evt) {
    var el = document.querySelector('[data-shipping-estimate]');
    var oosEl = document.querySelector('[data-shipping-estimate-oos]');
    if (!el && !oosEl) return;
    if (el && el.hasAttribute('data-launch-date')) return;
    var variant = evt.detail && evt.detail.variant;
    var available = !!(variant && variant.available);
    if (el && !el.hasAttribute('data-variant-preorder')) {
      el.style.display = available ? 'flex' : 'none';
    }
    if (oosEl) {
      oosEl.style.display = available ? 'none' : 'flex';
    }
  });
})();

// ========================================
// DISCONTINUED PRODUCTS (sold_out_rule)
// Klaviyo back-in-stock hides the ATC (inline display:none !important)
// and injects a notify button — pointless for discontinued products.
// Keep the disabled "Sold Out" ATC visible and suppress the notify
// button so the buy area reads as discontinued, not restockable.
// ========================================
(function() {
  'use strict';
  function init() {
    var info = document.querySelector('[id*="product-info"]');
    var btn = document.querySelector('[data-add-to-cart]');
    if (!info || !btn) return;
    var tags;
    try { tags = JSON.parse(info.dataset.tags || '[]'); } catch (e) { return; }
    if (tags.indexOf('sold_out_rule') === -1) return;

    function enforce() {
      if (btn.style.display === 'none') {
        btn.style.setProperty('display', 'block', 'important');
      }
      var bis = document.getElementById('klaviyo-bis-button-container');
      if (bis) bis.style.setProperty('display', 'none', 'important');
    }
    enforce();
    // Klaviyo re-hides the ATC and injects its button asynchronously
    new MutationObserver(enforce).observe(btn, { attributes: true, attributeFilter: ['style'] });
    if (btn.parentElement) {
      new MutationObserver(enforce).observe(btn.parentElement, { childList: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ========================================
// SS RECOMMENDATIONS — LIVE SHOPIFY PRICES
// Replaces SearchSpring's indexed price on rec cards
// (Browse Similar, Recently Viewed, Cross-Sell, View Cart)
// with the live /products/{handle}.js price.
// ========================================
(function() {
  'use strict';

  function handleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function pickDisplayVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0];
  }

  function patchRecCards() {
    if (typeof window.__thsFetchProduct !== 'function' ||
        typeof window.__thsRenderCardPrice !== 'function') return;

    var cards = document.querySelectorAll('.ss-recommendations-item:not(.ss-rec-priced)');
    cards.forEach(function(card) {
      var handle = handleFromCard(card);
      if (!handle) return;

      card.classList.add('ss-rec-priced');

      window.__thsFetchProduct(handle).then(function(product) {
        var variant = pickDisplayVariant(product);
        if (!variant) return;
        window.__thsRenderCardPrice(card, variant.price, variant.compare_at_price);
      }).catch(function() {
        // Allow retry on next observer pass if fetch failed
        card.classList.remove('ss-rec-priced');
      });
    });
  }

  function startObserver() {
    var containers = document.querySelectorAll('.ss-profile');
    if (containers.length === 0) {
      setTimeout(startObserver, 500);
      return;
    }
    patchRecCards();
    var obs = new MutationObserver(function() { patchRecCards(); });
    containers.forEach(function(c) {
      obs.observe(c, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(startObserver, 1000); });
  } else {
    setTimeout(startObserver, 1000);
  }
})();



/* Judge.me: badge-click scroll must clear the fixed site header (102px desktop).
   Judge.me animates to offset().top - jdgmSettings.scrollTopOffset (default 30). */
(function () {
  function measureHeader() {
    /* offsetHeight forces layout; only read it once the page is idle (PSI flagged
       the eager read as a 29ms forced reflow during load). */
    var header = document.querySelector('.site-header');
    if (header && header.offsetHeight) window.jdgmSettings.scrollTopOffset = header.offsetHeight + 28;
  }
  function setJdgmScrollOffset() {
    window.jdgmSettings = window.jdgmSettings || {};
    if (!window.jdgmSettings.scrollTopOffset || window.jdgmSettings.scrollTopOffset < 100) window.jdgmSettings.scrollTopOffset = 102 + 28;
    window.jdgmSettings.show_review_guidance_text = false; /* hide Poor/Great star labels */
    window.jdgmSettings.review_content_screen_title_text = 'Rate your gear';
    window.jdgmSettings.review_content_introduction_text = 'Tap a star to rate it — it takes about 30 seconds.';
    /* Written text is optional but rating-only reviews never reach Google Shopping — nudge for a sentence */
    window.jdgmSettings.widget_review_body_field_text = "How's it working out? (optional)";
    window.jdgmSettings.widget_review_body_placeholder_text = 'Fit, feel, durability — even one quick sentence helps other players pick the right gear.';
  }
  setJdgmScrollOffset();
  window.addEventListener('load', function () {
    setJdgmScrollOffset();
    if ('requestIdleCallback' in window) requestIdleCallback(measureHeader, { timeout: 2000 });
    else setTimeout(measureHeader, 500);
  });
})();

/* Judge.me modal: the modal reads the product photo from data-image-url on
   the inner widget element. Judge.me's synced data can be stale (404s after
   image re-uploads) or missing entirely (recently created products), so on
   product pages force it to the live og:image (size suffix stripped). */
(function () {
  function liveImageUrl() {
    var og = document.querySelector('meta[property="og:image:secure_url"]') ||
             document.querySelector('meta[property="og:image"]');
    if (!og || !og.content) return null;
    var url = og.content.replace(/_(\d+x\d+|pico|icon|thumb|small|compact|medium|large|grande)(_crop_[a-z]+)?(\.(?:jpg|jpeg|png|gif|webp))/i, '$3');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=480';
  }
  if (window.location.pathname.indexOf('/products/') === -1) return;
  function fixJdgmProductImage() {
    var url = liveImageUrl();
    if (!url) return;
    document.querySelectorAll('.jm-review-widget, .jdgm-rev-widg, [data-product-image-url]').forEach(function (el) {
      if (el.getAttribute('data-image-url') !== url) {
        el.setAttribute('data-image-url', url);
      }
      if (el.hasAttribute('data-product-image-url') && el.getAttribute('data-product-image-url') !== url) {
        el.setAttribute('data-product-image-url', url);
      }
    });
  }
  fixJdgmProductImage();
  /* the widget hydrates lazily and adds its elements late - keep it correct.
     Coalesced: one pass per 200ms burst instead of one per mutation batch
     (uncoalesced it ran 6-10ms on every DOM change anywhere on the page). */
  var jdgmImgPending = null;
  new MutationObserver(function () {
    if (jdgmImgPending) return;
    jdgmImgPending = setTimeout(function () { jdgmImgPending = null; fixJdgmProductImage(); }, 200);
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-image-url', 'data-product-image-url']
  });
})();

/* Judge.me modal: rating misclick guard.
   Small star tiles get fat-fingered (1-star reviews with "everything is great" text).
   Judge.me already routes ratings <= 3 to its "negative resolution" page - retext it
   as a rating check, and show a live "N of 5 stars" caption under every star row so
   the chosen rating is never silent (the Poor/Great labels are intentionally off). */
(function () {
  window.jdgmSettings = window.jdgmSettings || {};
  var s = window.jdgmSettings;
  s.negative_review_resolution_screen_title_text = 'Just checking your rating';
  s.negative_review_resolution_text = "Not what you meant? Tap a different star above to change it. If something went wrong with your purchase, we're here to help.";
  s.negative_review_resolution_proceed_with_review_text = 'Yes, continue';
  /* email star links land here with ?judgeme_rating=N - say so, in case the tap was a miss.
     Re-applied on load because the scroll-offset block above resets the intro text on load. */
  function applyPrefillIntro() {
    var pre = new URLSearchParams(window.location.search).get('judgeme_rating');
    if (/^[1-5]$/.test(pre)) {
      /* Judge.me may swap the settings object after load, so write to the live one */
      (window.jdgmSettings = window.jdgmSettings || {}).review_content_introduction_text = 'You tapped ' + pre + (pre === '1' ? ' star' : ' stars') + ' in the email. Tap a different star to change it.';
    }
  }
  applyPrefillIntro();
  window.addEventListener('load', applyPrefillIntro);

  function caption(n) {
    if (!n) return 'Tap a star to rate';
    return n + (n === 1 ? ' of 5 stars' : ' of 5 stars');
  }
  function syncCaptions() {
    document.querySelectorAll('.jdgm-write-review-modal__stars').forEach(function (stars) {
      var cap = stars.nextElementSibling;
      if (!cap || !cap.classList.contains('ths-rating-caption')) {
        cap = document.createElement('div');
        cap.className = 'ths-rating-caption';
        cap.setAttribute('aria-live', 'polite');
        stars.insertAdjacentElement('afterend', cap);
      }
      var input = stars.querySelector('input[name="score"]');
      var n = parseInt(input && input.value, 10);
      if (!(n >= 1 && n <= 5)) n = stars.querySelectorAll('.jdgm-star.jdgm--on').length;
      var text = caption(n);
      if (cap.textContent !== text) cap.textContent = text;
      cap.classList.toggle('is-low', n >= 1 && n <= 2);
    });
  }
  function start() {
    /* the write-review modal only opens from the PDP widget */
    if (window.location.pathname.indexOf('/products/') === -1) return;
    syncCaptions();
    var capPending = null;
    new MutationObserver(function () {
      if (capPending) return;
      capPending = setTimeout(function () { capPending = null; syncCaptions(); }, 100);
    }).observe(document.documentElement, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['class']
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.jdgm-write-review-modal__stars')) setTimeout(syncCaptions, 50);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Judge.me: arriving from a review-request email (?judgeme_token=) auto-opens the write-review
   modal - but EVERY review widget instance on the page opens its own copy (the Reviews-tab widget
   and Judge.me's own app block each run a ReviewWidgetManager), and Judge.me's legacy form.js
   opens one more. The copies are identical and stack at the same z-index, so after the customer
   submits and closes the top one the next still shows the untouched, star-prefilled form - the
   submission looks lost and they feel stuck in a loop (reported 2026-10-06; the review had in fact
   saved). ReviewWidgetManager removes stale modals before opening its own, but the openers run
   concurrently and race past that check. Keep the modal the customer sees (modals are prepended to
   <body>, so the oldest is last in DOM order and paints on top) and drop the rest. A closed modal
   re-creates itself hidden (closeModal -> setup), so only open ones count. */
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  var q = new URLSearchParams(window.location.search);
  if (!q.has('judgeme_token') && !q.has('judgeme_pre_verified') && window.location.hash !== '#judgeme') return;
  var SEL = '.jdgm-write-review-modal';
  var pending = null;
  function isOpen(m) { return getComputedStyle(m).display !== 'none'; }
  function dedupe() {
    var open = Array.prototype.filter.call(document.querySelectorAll(SEL), isOpen);
    if (open.length < 2) return;
    open.slice(0, -1).forEach(function (m) { m.remove(); });
  }
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; dedupe(); }, 50);
  }
  var watched = [];
  function watch(m) {
    if (watched.indexOf(m) !== -1) return;
    watched.push(m);
    /* the modal is inserted with style="display:none" and shown later via its inline style */
    new MutationObserver(schedule).observe(m, { attributes: true, attributeFilter: ['style', 'class'] });
    schedule();
  }
  function start() {
    Array.prototype.forEach.call(document.querySelectorAll(SEL), watch);
    new MutationObserver(function (muts) {
      muts.forEach(function (mu) {
        Array.prototype.forEach.call(mu.addedNodes, function (n) {
          if (n.nodeType === 1 && n.matches && n.matches(SEL)) watch(n);
        });
      });
    }).observe(document.body, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

// ========================================
// Bloggle Table of Contents anchors: offset for the sticky header
// Bloggle's own click handler (bloggle-article-min.js) animates to the target
// with a fixed "move-scroll" offset that is 0 on every article, so headings
// land under the stuck header. We take over the click in the capture phase
// (stopPropagation keeps Bloggle's element-level listener from running) and
// animate with the live header height, re-measuring the target every frame so
// lazy-loaded images above it can't throw the landing off. #StickyHeaderWrap
// only exists when the theme's sticky header is active, so the offset is 0
// whenever it is not.
// ========================================
(function() {
  'use strict';
  var GAP = 16;
  var DURATION = 600;

  function headerOffset() {
    var wrap = document.getElementById('StickyHeaderWrap');
    var header = wrap && wrap.querySelector('.site-header');
    return header ? header.offsetHeight : 0;
  }

  function destination(target) {
    return Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - GAP);
  }

  function scrollToTarget(target) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !window.requestAnimationFrame) { window.scrollTo(0, destination(target)); return; }
    var start = window.pageYOffset;
    var t0 = null;
    function frame(now) {
      if (t0 === null) t0 = now;
      var p = Math.min(1, (now - t0) / DURATION);
      var ease = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p;
      var dest = destination(target);
      window.scrollTo(0, p < 1 ? start + (dest - start) * ease : dest);
      if (p < 1) window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
  }

  document.addEventListener('click', function(evt) {
    var link = evt.target && evt.target.closest ? evt.target.closest('#bloggy--article .bggle--anchor-link') : null;
    if (!link) return;
    var id = (link.getAttribute('href') || '').replace(/^#/, '');
    if (!id) return;
    var target = document.querySelector(".bggle--block[section-id='" + id + "']") || document.getElementById(id);
    if (!target) return;
    evt.preventDefault();
    evt.stopPropagation();
    scrollToTarget(target);
    if (window.history && history.replaceState) history.replaceState(null, '', '#' + id);
  }, true);
})();
